//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import * as Extensions from './BfsIopAdminApiClient.extensions.g';
import { BfsIopAdminApiClientSupport } from '../BfsIopAdminApiClientSupport';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, from as _observableFrom, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const IOP_ADMIN_API_BASE_URL = new InjectionToken<string>('IOP_ADMIN_API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class AgentClient extends Extensions.ApiClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(BfsIopAdminApiClientSupport) configuration: BfsIopAdminApiClientSupport, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(IOP_ADMIN_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets the Agent with the specified id.
     * @return OK
     */
    getById(id: string): Observable<SwaggerResponse<Agent>> {
        let url_ = this.baseUrl + "/api/Agent/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<Agent>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<Agent>>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<SwaggerResponse<Agent>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Agent.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<Agent>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Lists all agents
     * @return OK
     */
    get(): Observable<SwaggerResponse<Agent[]>> {
        let url_ = this.baseUrl + "/api/Agent";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGet(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGet(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<Agent[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<Agent[]>>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SwaggerResponse<Agent[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Agent.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<Agent[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Lists all agents to which the current user has access to
     * @return OK
     */
    getUser(): Observable<SwaggerResponse<Agent[]>> {
        let url_ = this.baseUrl + "/api/Agent/user";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetUser(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetUser(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<Agent[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<Agent[]>>;
        }));
    }

    protected processGetUser(response: HttpResponseBase): Observable<SwaggerResponse<Agent[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Agent.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<Agent[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Gets the agents published statistics about the resources that the current user is allowed to access.
     * @return OK
     */
    getStatistics(): Observable<SwaggerResponse<AgentStatisticsResult[]>> {
        let url_ = this.baseUrl + "/api/Agent/statistics";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetStatistics(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetStatistics(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<AgentStatisticsResult[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<AgentStatisticsResult[]>>;
        }));
    }

    protected processGetStatistics(response: HttpResponseBase): Observable<SwaggerResponse<AgentStatisticsResult[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgentStatisticsResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<AgentStatisticsResult[]>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable({
    providedIn: 'root'
})
export class AllowActionsClient extends Extensions.ApiClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(BfsIopAdminApiClientSupport) configuration: BfsIopAdminApiClientSupport, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(IOP_ADMIN_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Returns the possible creation authorizations according to the user business role.
     * @return OK
     */
    getAllowCreate(): Observable<SwaggerResponse<AllowActionResult[]>> {
        let url_ = this.baseUrl + "/api/AllowActions/allow-create";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllowCreate(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllowCreate(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<AllowActionResult[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<AllowActionResult[]>>;
        }));
    }

    protected processGetAllowCreate(response: HttpResponseBase): Observable<SwaggerResponse<AllowActionResult[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AllowActionResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<AllowActionResult[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Returns the user possible authorizations for a specific resource.
     * @param resourceType Resource type.
     * @param id Resource id.
     * @return OK
     */
    getV2ByResourceTypeAndId(resourceType: AllowActionResourceType, id: string): Observable<SwaggerResponse<AllowActionResult[]>> {
        let url_ = this.baseUrl + "/api/AllowActions/{resourceType}/{id}/v2";
        if (resourceType === undefined || resourceType === null)
            throw new globalThis.Error("The parameter 'resourceType' must be defined.");
        url_ = url_.replace("{resourceType}", encodeURIComponent("" + resourceType));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetV2ByResourceTypeAndId(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetV2ByResourceTypeAndId(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<AllowActionResult[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<AllowActionResult[]>>;
        }));
    }

    protected processGetV2ByResourceTypeAndId(response: HttpResponseBase): Observable<SwaggerResponse<AllowActionResult[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AllowActionResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<AllowActionResult[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Gets the information if the application is in read only mode.
     * @return OK
     */
    getReadOnly(): Observable<SwaggerResponse<boolean>> {
        let url_ = this.baseUrl + "/api/AllowActions/read-only";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetReadOnly(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetReadOnly(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<boolean>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<boolean>>;
        }));
    }

    protected processGetReadOnly(response: HttpResponseBase): Observable<SwaggerResponse<boolean>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<boolean>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable({
    providedIn: 'root'
})
export class CatalogClient extends Extensions.ApiClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(BfsIopAdminApiClientSupport) configuration: BfsIopAdminApiClientSupport, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(IOP_ADMIN_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Search the catalog for datasets, data services and public services.
     * @param query (optional) The search query
     * @param accessRights (optional) Only results with one of the specified access rights (PUBLIC, NON_PUBLIC, RESTRICTED) are returned
     * @param attributedAgents (optional) Only results with a qualified attribution to one of the specified agents (by identifier) are returned
     * @param conceptValueTypes (optional) Only results with one of the specified concept value types are returned
     * @param formats (optional) Only results with at least one distribution providing one of the specified formats are returned
     * @param businessEvents (optional) Only results with one of the specified business events are returned
     * @param levels (optional) Only results corresponding to one of the specified publication levels are returned
     * @param levelProposals (optional) Only results with the proposal publication (I14Y Public) is returned
     * @param lifeEvents (optional) Only results with one of the specified life events are returned
     * @param publishers (optional) Only results with one of the specified publishers are returned
     * @param statuses (optional) Only results with one of the specified registration statuses are returned
     * @param statusProposals (optional) Only results with one of the proposals registration statuses are returned
     * @param structure (optional) Only results for datasets are returned.
     * @param themes (optional) Only results with one of the specified themes are returned
     * @param types (optional) Only results with one of the specified types are returned
     * @param page (optional) The number of the result page to return
     * @param pageSize (optional) The size of each result page
     * @return OK
     */
    getSearchByQueryAndAccessRightsAndAttributedAgentsAndConceptValueTypesAndFormatsAndBusinessEventsAndLevelsAndLevelProposalsAndLifeEventsAndPublishersAndStatusesAndStatusProposalsAndStructureAndThemesAndTypesAndPageAndPageSize(query: string | undefined, accessRights: string[] | undefined, attributedAgents: string[] | undefined, conceptValueTypes: ConceptType[] | undefined, formats: string[] | undefined, businessEvents: string[] | undefined, levels: PublicationLevel[] | undefined, levelProposals: PublicationLevel[] | undefined, lifeEvents: string[] | undefined, publishers: string[] | undefined, statuses: RegistrationStatus[] | undefined, statusProposals: RegistrationStatus[] | undefined, structure: SearchStructureOption | undefined, themes: string[] | undefined, types: SearchResourceType[] | undefined, page: number | undefined, pageSize: number | undefined): Observable<SwaggerResponse<CatalogEntry[]>> {
        let url_ = this.baseUrl + "/api/Catalog/search?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (accessRights === null)
            throw new globalThis.Error("The parameter 'accessRights' cannot be null.");
        else if (accessRights !== undefined)
            accessRights && accessRights.forEach(item => { url_ += "accessRights=" + encodeURIComponent("" + item) + "&"; });
        if (attributedAgents === null)
            throw new globalThis.Error("The parameter 'attributedAgents' cannot be null.");
        else if (attributedAgents !== undefined)
            attributedAgents && attributedAgents.forEach(item => { url_ += "attributedAgents=" + encodeURIComponent("" + item) + "&"; });
        if (conceptValueTypes === null)
            throw new globalThis.Error("The parameter 'conceptValueTypes' cannot be null.");
        else if (conceptValueTypes !== undefined)
            conceptValueTypes && conceptValueTypes.forEach(item => { url_ += "conceptValueTypes=" + encodeURIComponent("" + item) + "&"; });
        if (formats === null)
            throw new globalThis.Error("The parameter 'formats' cannot be null.");
        else if (formats !== undefined)
            formats && formats.forEach(item => { url_ += "formats=" + encodeURIComponent("" + item) + "&"; });
        if (businessEvents === null)
            throw new globalThis.Error("The parameter 'businessEvents' cannot be null.");
        else if (businessEvents !== undefined)
            businessEvents && businessEvents.forEach(item => { url_ += "businessEvents=" + encodeURIComponent("" + item) + "&"; });
        if (levels === null)
            throw new globalThis.Error("The parameter 'levels' cannot be null.");
        else if (levels !== undefined)
            levels && levels.forEach(item => { url_ += "levels=" + encodeURIComponent("" + item) + "&"; });
        if (levelProposals === null)
            throw new globalThis.Error("The parameter 'levelProposals' cannot be null.");
        else if (levelProposals !== undefined)
            levelProposals && levelProposals.forEach(item => { url_ += "levelProposals=" + encodeURIComponent("" + item) + "&"; });
        if (lifeEvents === null)
            throw new globalThis.Error("The parameter 'lifeEvents' cannot be null.");
        else if (lifeEvents !== undefined)
            lifeEvents && lifeEvents.forEach(item => { url_ += "lifeEvents=" + encodeURIComponent("" + item) + "&"; });
        if (publishers === null)
            throw new globalThis.Error("The parameter 'publishers' cannot be null.");
        else if (publishers !== undefined)
            publishers && publishers.forEach(item => { url_ += "publishers=" + encodeURIComponent("" + item) + "&"; });
        if (statuses === null)
            throw new globalThis.Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        if (statusProposals === null)
            throw new globalThis.Error("The parameter 'statusProposals' cannot be null.");
        else if (statusProposals !== undefined)
            statusProposals && statusProposals.forEach(item => { url_ += "statusProposals=" + encodeURIComponent("" + item) + "&"; });
        if (structure === null)
            throw new globalThis.Error("The parameter 'structure' cannot be null.");
        else if (structure !== undefined)
            url_ += "structure=" + encodeURIComponent("" + structure) + "&";
        if (themes === null)
            throw new globalThis.Error("The parameter 'themes' cannot be null.");
        else if (themes !== undefined)
            themes && themes.forEach(item => { url_ += "themes=" + encodeURIComponent("" + item) + "&"; });
        if (types === null)
            throw new globalThis.Error("The parameter 'types' cannot be null.");
        else if (types !== undefined)
            types && types.forEach(item => { url_ += "types=" + encodeURIComponent("" + item) + "&"; });
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetSearchByQueryAndAccessRightsAndAttributedAgentsAndConceptValueTypesAndFormatsAndBusinessEventsAndLevelsAndLevelProposalsAndLifeEventsAndPublishersAndStatusesAndStatusProposalsAndStructureAndThemesAndTypesAndPageAndPageSize(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetSearchByQueryAndAccessRightsAndAttributedAgentsAndConceptValueTypesAndFormatsAndBusinessEventsAndLevelsAndLevelProposalsAndLifeEventsAndPublishersAndStatusesAndStatusProposalsAndStructureAndThemesAndTypesAndPageAndPageSize(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<CatalogEntry[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<CatalogEntry[]>>;
        }));
    }

    protected processGetSearchByQueryAndAccessRightsAndAttributedAgentsAndConceptValueTypesAndFormatsAndBusinessEventsAndLevelsAndLevelProposalsAndLifeEventsAndPublishersAndStatusesAndStatusProposalsAndStructureAndThemesAndTypesAndPageAndPageSize(response: HttpResponseBase): Observable<SwaggerResponse<CatalogEntry[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CatalogEntry.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<CatalogEntry[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Get the result count by filter value corresponding to a search query
     * @param query (optional) The search query
     * @param accessRights (optional) Only results with one of the specified access rights (PUBLIC, NON_PUBLIC, RESTRICTED) are counted
     * @param attributedAgents (optional) Only results with a qualified attribution to one of the specified agents (by identifier) are counted
     * @param conceptValueTypes (optional) Only results with one of the specified concept value types are counted
     * @param businessEvents (optional) Only results with one of the specified business events are counted
     * @param formats (optional) Only results with at least one distribution providing one of the specified formats are counted
     * @param levels (optional) Only results corresponding to one of the specified publication levels are counted
     * @param levelProposals (optional) Only results with the proposal publication (I14Y Public) is counted
     * @param lifeEvents (optional) Only results with one of the specified life events are counted
     * @param publishers (optional) Only results with one of the specified publishers are counted
     * @param statuses (optional) Only results with one of the specified registration statuses are counted
     * @param statusProposals (optional) Only results with one of the proposals registration statuses are counted
     * @param structure (optional) Only results for datasets are returned.
     * @param themes (optional) Only results with one of the specified themes are counted
     * @param types (optional) Only results corresponding to one of the specified types are counted
     * @return OK
     */
    getSearchcountByQueryAndAccessRightsAndAttributedAgentsAndConceptValueTypesAndBusinessEventsAndFormatsAndLevelsAndLevelProposalsAndLifeEventsAndPublishersAndStatusesAndStatusProposalsAndStructureAndThemesAndTypes(query: string | undefined, accessRights: string[] | undefined, attributedAgents: string[] | undefined, conceptValueTypes: ConceptType[] | undefined, businessEvents: string[] | undefined, formats: string[] | undefined, levels: PublicationLevel[] | undefined, levelProposals: PublicationLevel[] | undefined, lifeEvents: string[] | undefined, publishers: string[] | undefined, statuses: RegistrationStatus[] | undefined, statusProposals: RegistrationStatus[] | undefined, structure: SearchStructureOption | undefined, themes: string[] | undefined, types: SearchResourceType[] | undefined): Observable<SwaggerResponse<FilterCountResult>> {
        let url_ = this.baseUrl + "/api/Catalog/searchcount?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (accessRights === null)
            throw new globalThis.Error("The parameter 'accessRights' cannot be null.");
        else if (accessRights !== undefined)
            accessRights && accessRights.forEach(item => { url_ += "accessRights=" + encodeURIComponent("" + item) + "&"; });
        if (attributedAgents === null)
            throw new globalThis.Error("The parameter 'attributedAgents' cannot be null.");
        else if (attributedAgents !== undefined)
            attributedAgents && attributedAgents.forEach(item => { url_ += "attributedAgents=" + encodeURIComponent("" + item) + "&"; });
        if (conceptValueTypes === null)
            throw new globalThis.Error("The parameter 'conceptValueTypes' cannot be null.");
        else if (conceptValueTypes !== undefined)
            conceptValueTypes && conceptValueTypes.forEach(item => { url_ += "conceptValueTypes=" + encodeURIComponent("" + item) + "&"; });
        if (businessEvents === null)
            throw new globalThis.Error("The parameter 'businessEvents' cannot be null.");
        else if (businessEvents !== undefined)
            businessEvents && businessEvents.forEach(item => { url_ += "businessEvents=" + encodeURIComponent("" + item) + "&"; });
        if (formats === null)
            throw new globalThis.Error("The parameter 'formats' cannot be null.");
        else if (formats !== undefined)
            formats && formats.forEach(item => { url_ += "formats=" + encodeURIComponent("" + item) + "&"; });
        if (levels === null)
            throw new globalThis.Error("The parameter 'levels' cannot be null.");
        else if (levels !== undefined)
            levels && levels.forEach(item => { url_ += "levels=" + encodeURIComponent("" + item) + "&"; });
        if (levelProposals === null)
            throw new globalThis.Error("The parameter 'levelProposals' cannot be null.");
        else if (levelProposals !== undefined)
            levelProposals && levelProposals.forEach(item => { url_ += "levelProposals=" + encodeURIComponent("" + item) + "&"; });
        if (lifeEvents === null)
            throw new globalThis.Error("The parameter 'lifeEvents' cannot be null.");
        else if (lifeEvents !== undefined)
            lifeEvents && lifeEvents.forEach(item => { url_ += "lifeEvents=" + encodeURIComponent("" + item) + "&"; });
        if (publishers === null)
            throw new globalThis.Error("The parameter 'publishers' cannot be null.");
        else if (publishers !== undefined)
            publishers && publishers.forEach(item => { url_ += "publishers=" + encodeURIComponent("" + item) + "&"; });
        if (statuses === null)
            throw new globalThis.Error("The parameter 'statuses' cannot be null.");
        else if (statuses !== undefined)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        if (statusProposals === null)
            throw new globalThis.Error("The parameter 'statusProposals' cannot be null.");
        else if (statusProposals !== undefined)
            statusProposals && statusProposals.forEach(item => { url_ += "statusProposals=" + encodeURIComponent("" + item) + "&"; });
        if (structure === null)
            throw new globalThis.Error("The parameter 'structure' cannot be null.");
        else if (structure !== undefined)
            url_ += "structure=" + encodeURIComponent("" + structure) + "&";
        if (themes === null)
            throw new globalThis.Error("The parameter 'themes' cannot be null.");
        else if (themes !== undefined)
            themes && themes.forEach(item => { url_ += "themes=" + encodeURIComponent("" + item) + "&"; });
        if (types === null)
            throw new globalThis.Error("The parameter 'types' cannot be null.");
        else if (types !== undefined)
            types && types.forEach(item => { url_ += "types=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetSearchcountByQueryAndAccessRightsAndAttributedAgentsAndConceptValueTypesAndBusinessEventsAndFormatsAndLevelsAndLevelProposalsAndLifeEventsAndPublishersAndStatusesAndStatusProposalsAndStructureAndThemesAndTypes(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetSearchcountByQueryAndAccessRightsAndAttributedAgentsAndConceptValueTypesAndBusinessEventsAndFormatsAndLevelsAndLevelProposalsAndLifeEventsAndPublishersAndStatusesAndStatusProposalsAndStructureAndThemesAndTypes(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FilterCountResult>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FilterCountResult>>;
        }));
    }

    protected processGetSearchcountByQueryAndAccessRightsAndAttributedAgentsAndConceptValueTypesAndBusinessEventsAndFormatsAndLevelsAndLevelProposalsAndLifeEventsAndPublishersAndStatusesAndStatusProposalsAndStructureAndThemesAndTypes(response: HttpResponseBase): Observable<SwaggerResponse<FilterCountResult>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FilterCountResult.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FilterCountResult>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Returns the related-by ("relations") count for each of the given catalogue resources, with a
    per-type breakdown. Intended to be called asynchronously by the catalogue page after the
    search results render.
     * @param body (optional) The catalogue resources (id + type) to count.
     * @return OK
     */
    postRelationsCountByBody(body: RelationsCountRequestItem[] | undefined): Observable<SwaggerResponse<RelationsCountModel[]>> {
        let url_ = this.baseUrl + "/api/Catalog/relations-count";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPostRelationsCountByBody(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPostRelationsCountByBody(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<RelationsCountModel[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<RelationsCountModel[]>>;
        }));
    }

    protected processPostRelationsCountByBody(response: HttpResponseBase): Observable<SwaggerResponse<RelationsCountModel[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RelationsCountModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<RelationsCountModel[]>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable({
    providedIn: 'root'
})
export class ConceptInputClient extends Extensions.ApiClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(BfsIopAdminApiClientSupport) configuration: BfsIopAdminApiClientSupport, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(IOP_ADMIN_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets the entity
     * @return OK
     */
    getById(id: string): Observable<SwaggerResponse<ConceptInput>> {
        let url_ = this.baseUrl + "/api/ConceptInput/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<ConceptInput>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<ConceptInput>>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<SwaggerResponse<ConceptInput>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConceptInput.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<ConceptInput>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Deletes the entity
     * @return No Content
     */
    deleteById(id: string): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/ConceptInput/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processDeleteById(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Checks whether the identifier with version is in use
     * @return OK
     */
    getIdentifierExistsByIdentifierAndVersion(identifier: string, version: string): Observable<SwaggerResponse<IdentifierVersionExistsResult>> {
        let url_ = this.baseUrl + "/api/ConceptInput/identifier/{identifier}/{version}/exists";
        if (identifier === undefined || identifier === null)
            throw new globalThis.Error("The parameter 'identifier' must be defined.");
        url_ = url_.replace("{identifier}", encodeURIComponent("" + identifier));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetIdentifierExistsByIdentifierAndVersion(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetIdentifierExistsByIdentifierAndVersion(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<IdentifierVersionExistsResult>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<IdentifierVersionExistsResult>>;
        }));
    }

    protected processGetIdentifierExistsByIdentifierAndVersion(response: HttpResponseBase): Observable<SwaggerResponse<IdentifierVersionExistsResult>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdentifierVersionExistsResult.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<IdentifierVersionExistsResult>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Checks whether the identifier is in use
     * @return OK
     */
    getIdentifierCounterByIdentifier(identifier: string): Observable<SwaggerResponse<boolean>> {
        let url_ = this.baseUrl + "/api/ConceptInput/identifier/{identifier}/Counter";
        if (identifier === undefined || identifier === null)
            throw new globalThis.Error("The parameter 'identifier' must be defined.");
        url_ = url_.replace("{identifier}", encodeURIComponent("" + identifier));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetIdentifierCounterByIdentifier(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetIdentifierCounterByIdentifier(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<boolean>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<boolean>>;
        }));
    }

    protected processGetIdentifierCounterByIdentifier(response: HttpResponseBase): Observable<SwaggerResponse<boolean>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<boolean>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Checks whether the identifier is in use
     * @return OK
     */
    getIdentifierExistsByIdentifier(identifier: string): Observable<SwaggerResponse<boolean>> {
        let url_ = this.baseUrl + "/api/ConceptInput/identifier/{identifier}/exists";
        if (identifier === undefined || identifier === null)
            throw new globalThis.Error("The parameter 'identifier' must be defined.");
        url_ = url_.replace("{identifier}", encodeURIComponent("" + identifier));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetIdentifierExistsByIdentifier(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetIdentifierExistsByIdentifier(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<boolean>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<boolean>>;
        }));
    }

    protected processGetIdentifierExistsByIdentifier(response: HttpResponseBase): Observable<SwaggerResponse<boolean>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<boolean>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Add a new concept
     * @param body (optional) The new concept
     * @return Created
     */
    postByBody(body: ConceptInput | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/ConceptInput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPostByBody(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPostByBody(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPostByBody(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Updates the entity
     * @param body (optional) 
     * @return No Content
     */
    putByBody(body: ConceptInput | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/ConceptInput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPutByBody(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutByBody(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPutByBody(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Locks or unlocks the concept with the given id.
     * @param locked True to lock, false to unlock.
     * @return No Content
     */
    putLockedByIdAndLocked(id: string, locked: boolean): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/ConceptInput/{id}/locked?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (locked === undefined || locked === null)
            throw new globalThis.Error("The parameter 'locked' must be defined and cannot be null.");
        else
            url_ += "locked=" + encodeURIComponent("" + locked) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPutLockedByIdAndLocked(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutLockedByIdAndLocked(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPutLockedByIdAndLocked(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Updates the registration proposal of a concept.
     * @param id The concept id.
     * @param proposal (optional) The new registration proposal or an empty value to reset an existing one.
     * @return No Content
     */
    putRegistrationStatusProposalByIdAndProposal(id: string, proposal: RegistrationStatus | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/ConceptInput/{id}/registrationStatusProposal?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (proposal === null)
            throw new globalThis.Error("The parameter 'proposal' cannot be null.");
        else if (proposal !== undefined)
            url_ += "proposal=" + encodeURIComponent("" + proposal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPutRegistrationStatusProposalByIdAndProposal(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutRegistrationStatusProposalByIdAndProposal(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPutRegistrationStatusProposalByIdAndProposal(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Updates the registration status of a concept.
     * @param id The concept id.
     * @param status (optional) The new registration status.
     * @return No Content
     */
    putRegistrationStatusByIdAndStatus(id: string, status: RegistrationStatus | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/ConceptInput/{id}/registrationStatus?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPutRegistrationStatusByIdAndStatus(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutRegistrationStatusByIdAndStatus(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPutRegistrationStatusByIdAndStatus(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Updates the publication level proposal of a concept.
     * @param id The concept id.
     * @param proposal (optional) The new publication level proposal or an empty value to reset an existing one.
     * @return No Content
     */
    putPublicationLevelProposalByIdAndProposal(id: string, proposal: PublicationLevel | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/ConceptInput/{id}/publicationLevelProposal?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (proposal === null)
            throw new globalThis.Error("The parameter 'proposal' cannot be null.");
        else if (proposal !== undefined)
            url_ += "proposal=" + encodeURIComponent("" + proposal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPutPublicationLevelProposalByIdAndProposal(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutPublicationLevelProposalByIdAndProposal(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPutPublicationLevelProposalByIdAndProposal(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Updates the publication level of a concept.
     * @param id The concept id.
     * @param level (optional) The new publication level.
     * @return No Content
     */
    putPublicationLevelByIdAndLevel(id: string, level: PublicationLevel | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/ConceptInput/{id}/publicationLevel?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (level === null)
            throw new globalThis.Error("The parameter 'level' cannot be null.");
        else if (level !== undefined)
            url_ += "level=" + encodeURIComponent("" + level) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPutPublicationLevelByIdAndLevel(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutPublicationLevelByIdAndLevel(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPutPublicationLevelByIdAndLevel(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Returns the input model of a specific codelist entry .
     * @return OK
     */
    getCodelistEntriesByIdAndCodeListEntryId(id: string, codeListEntryId: string): Observable<SwaggerResponse<CodelistEntryInput>> {
        let url_ = this.baseUrl + "/api/ConceptInput/{id}/codelist-entries/{codeListEntryId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (codeListEntryId === undefined || codeListEntryId === null)
            throw new globalThis.Error("The parameter 'codeListEntryId' must be defined.");
        url_ = url_.replace("{codeListEntryId}", encodeURIComponent("" + codeListEntryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetCodelistEntriesByIdAndCodeListEntryId(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetCodelistEntriesByIdAndCodeListEntryId(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<CodelistEntryInput>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<CodelistEntryInput>>;
        }));
    }

    protected processGetCodelistEntriesByIdAndCodeListEntryId(response: HttpResponseBase): Observable<SwaggerResponse<CodelistEntryInput>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CodelistEntryInput.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<CodelistEntryInput>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Deletes one codelist entry from a concept
     * @param id the id from the concept
     * @return No Content
     */
    deleteCodelistEntriesByIdAndCodeListEntryId(id: string, codeListEntryId: string): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/ConceptInput/{id}/codelist-entries/{codeListEntryId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (codeListEntryId === undefined || codeListEntryId === null)
            throw new globalThis.Error("The parameter 'codeListEntryId' must be defined.");
        url_ = url_.replace("{codeListEntryId}", encodeURIComponent("" + codeListEntryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteCodelistEntriesByIdAndCodeListEntryId(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteCodelistEntriesByIdAndCodeListEntryId(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processDeleteCodelistEntriesByIdAndCodeListEntryId(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Updates an existing codelistEntry
     * @param body (optional) 
     * @return No Content
     */
    putCodelistEntriesByIdAndCodeListEntryIdAndBody(id: string, codeListEntryId: string, body: CodelistEntryInput | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/ConceptInput/{id}/codelist-entries/{codeListEntryId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (codeListEntryId === undefined || codeListEntryId === null)
            throw new globalThis.Error("The parameter 'codeListEntryId' must be defined.");
        url_ = url_.replace("{codeListEntryId}", encodeURIComponent("" + codeListEntryId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPutCodelistEntriesByIdAndCodeListEntryIdAndBody(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutCodelistEntriesByIdAndCodeListEntryIdAndBody(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPutCodelistEntriesByIdAndCodeListEntryIdAndBody(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Deletes all codelist entries from a concept
     * @param id the id from the concept
     * @return No Content
     */
    deleteCodelistEntriesById(id: string): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/ConceptInput/{id}/codelist-entries";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteCodelistEntriesById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteCodelistEntriesById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processDeleteCodelistEntriesById(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Add a new codelistEntry
     * @param body (optional) 
     * @return Created
     */
    postCodelistEntriesByIdAndBody(id: string, body: CodelistEntryInput | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/ConceptInput/{id}/codelist-entries";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPostCodelistEntriesByIdAndBody(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPostCodelistEntriesByIdAndBody(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processPostCodelistEntriesByIdAndBody(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return _observableOf(new SwaggerResponse(status, _headers, result201));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Add a new annotation to a codelistEntry
     * @param body (optional) 
     * @return Created
     */
    postCodelistEntriesAnnotationsByIdAndCodeListEntryIdAndBody(id: string, codeListEntryId: string, body: AnnotationInputModel | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/ConceptInput/{id}/codelist-entries/{codeListEntryId}/annotations";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (codeListEntryId === undefined || codeListEntryId === null)
            throw new globalThis.Error("The parameter 'codeListEntryId' must be defined.");
        url_ = url_.replace("{codeListEntryId}", encodeURIComponent("" + codeListEntryId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPostCodelistEntriesAnnotationsByIdAndCodeListEntryIdAndBody(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPostCodelistEntriesAnnotationsByIdAndCodeListEntryIdAndBody(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processPostCodelistEntriesAnnotationsByIdAndCodeListEntryIdAndBody(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return _observableOf(new SwaggerResponse(status, _headers, result201));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Updates an existing annotation.
     * @param body (optional) 
     * @return No Content
     */
    putCodelistEntriesAnnotationsByIdAndCodeListEntryIdAndAnnotationIdAndBody(id: string, codeListEntryId: string, annotationId: string, body: Annotation | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/ConceptInput/{id}/codelist-entries/{codeListEntryId}/annotations/{annotationId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (codeListEntryId === undefined || codeListEntryId === null)
            throw new globalThis.Error("The parameter 'codeListEntryId' must be defined.");
        url_ = url_.replace("{codeListEntryId}", encodeURIComponent("" + codeListEntryId));
        if (annotationId === undefined || annotationId === null)
            throw new globalThis.Error("The parameter 'annotationId' must be defined.");
        url_ = url_.replace("{annotationId}", encodeURIComponent("" + annotationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPutCodelistEntriesAnnotationsByIdAndCodeListEntryIdAndAnnotationIdAndBody(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutCodelistEntriesAnnotationsByIdAndCodeListEntryIdAndAnnotationIdAndBody(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPutCodelistEntriesAnnotationsByIdAndCodeListEntryIdAndAnnotationIdAndBody(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Updates an existing annotation.
     * @return No Content
     */
    deleteCodelistEntriesAnnotationsByIdAndCodeListEntryIdAndAnnotationId(id: string, codeListEntryId: string, annotationId: string): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/ConceptInput/{id}/codelist-entries/{codeListEntryId}/annotations/{annotationId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (codeListEntryId === undefined || codeListEntryId === null)
            throw new globalThis.Error("The parameter 'codeListEntryId' must be defined.");
        url_ = url_.replace("{codeListEntryId}", encodeURIComponent("" + codeListEntryId));
        if (annotationId === undefined || annotationId === null)
            throw new globalThis.Error("The parameter 'annotationId' must be defined.");
        url_ = url_.replace("{annotationId}", encodeURIComponent("" + annotationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteCodelistEntriesAnnotationsByIdAndCodeListEntryIdAndAnnotationId(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteCodelistEntriesAnnotationsByIdAndCodeListEntryIdAndAnnotationId(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processDeleteCodelistEntriesAnnotationsByIdAndCodeListEntryIdAndAnnotationId(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * @param file (optional) 
     * @return No Content
     */
    postCodelistEntriesImportsByIdAndFormatAndBody(id: string, format: CodeListEntriesDataFormat, file: FileParameter | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/ConceptInput/{id}/codelist-entries/imports/{format}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (format === undefined || format === null)
            throw new globalThis.Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPostCodelistEntriesImportsByIdAndFormatAndBody(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPostCodelistEntriesImportsByIdAndFormatAndBody(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPostCodelistEntriesImportsByIdAndFormatAndBody(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Create a new version based on a existing Concept
     * @param body (optional) The new version information
     * @return Created
     */
    postCreateVersionByBody(body: ConceptInputCreateVersion | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/ConceptInput/createVersion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPostCreateVersionByBody(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPostCreateVersionByBody(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPostCreateVersionByBody(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable({
    providedIn: 'root'
})
export class ConceptViewClient extends Extensions.ApiClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(BfsIopAdminApiClientSupport) configuration: BfsIopAdminApiClientSupport, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(IOP_ADMIN_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets the concepts matching the given filters.
     * @param conceptIdentifier (optional) An optional identifier used to filter concepts by their concept identifier.
     * @param publisherIdentifier (optional) An optional identifier used to filter concepts by their publisher.
     * @param version (optional) An optional version string used to filter concepts by version.
     * @param publicationLevel (optional) An optional publication level used to filter concepts.
     * @param registrationStatus (optional) An optional registration status used to filter concepts.
     * @param page (optional) The number of the result page to return.
     * @param pageSize (optional) The size of each result page.
     * @return OK
     */
    getByConceptIdentifierAndPublisherIdentifierAndVersionAndPublicationLevelAndRegistrationStatusAndPageAndPageSize(conceptIdentifier: string | undefined, publisherIdentifier: string | undefined, version: string | undefined, publicationLevel: PublicationLevel | undefined, registrationStatus: RegistrationStatus | undefined, page: number | undefined, pageSize: number | undefined): Observable<SwaggerResponse<IopConceptModel[]>> {
        let url_ = this.baseUrl + "/api/ConceptView?";
        if (conceptIdentifier === null)
            throw new globalThis.Error("The parameter 'conceptIdentifier' cannot be null.");
        else if (conceptIdentifier !== undefined)
            url_ += "conceptIdentifier=" + encodeURIComponent("" + conceptIdentifier) + "&";
        if (publisherIdentifier === null)
            throw new globalThis.Error("The parameter 'publisherIdentifier' cannot be null.");
        else if (publisherIdentifier !== undefined)
            url_ += "publisherIdentifier=" + encodeURIComponent("" + publisherIdentifier) + "&";
        if (version === null)
            throw new globalThis.Error("The parameter 'version' cannot be null.");
        else if (version !== undefined)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        if (publicationLevel === null)
            throw new globalThis.Error("The parameter 'publicationLevel' cannot be null.");
        else if (publicationLevel !== undefined)
            url_ += "publicationLevel=" + encodeURIComponent("" + publicationLevel) + "&";
        if (registrationStatus === null)
            throw new globalThis.Error("The parameter 'registrationStatus' cannot be null.");
        else if (registrationStatus !== undefined)
            url_ += "registrationStatus=" + encodeURIComponent("" + registrationStatus) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetByConceptIdentifierAndPublisherIdentifierAndVersionAndPublicationLevelAndRegistrationStatusAndPageAndPageSize(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetByConceptIdentifierAndPublisherIdentifierAndVersionAndPublicationLevelAndRegistrationStatusAndPageAndPageSize(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<IopConceptModel[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<IopConceptModel[]>>;
        }));
    }

    protected processGetByConceptIdentifierAndPublisherIdentifierAndVersionAndPublicationLevelAndRegistrationStatusAndPageAndPageSize(response: HttpResponseBase): Observable<SwaggerResponse<IopConceptModel[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IopConceptModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<IopConceptModel[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Gets all the versions from a Concept by its id.
     * @return OK
     */
    getAllVersionsById(id: string): Observable<SwaggerResponse<ConceptVersionView[]>> {
        let url_ = this.baseUrl + "/api/ConceptView/{id}/allVersions";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAllVersionsById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAllVersionsById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<ConceptVersionView[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<ConceptVersionView[]>>;
        }));
    }

    protected processGetAllVersionsById(response: HttpResponseBase): Observable<SwaggerResponse<ConceptVersionView[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConceptVersionView.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<ConceptVersionView[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Gets the conceptView by id
     * @return OK
     */
    getById(id: string): Observable<SwaggerResponse<ConceptView>> {
        let url_ = this.baseUrl + "/api/ConceptView/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<ConceptView>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<ConceptView>>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<SwaggerResponse<ConceptView>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConceptView.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<ConceptView>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Gets the publication level of the concept.
     * @return OK
     */
    getPublicationLevelById(id: string): Observable<SwaggerResponse<PublicationLevelInfoModel>> {
        let url_ = this.baseUrl + "/api/ConceptView/{id}/publicationLevel";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetPublicationLevelById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetPublicationLevelById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<PublicationLevelInfoModel>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<PublicationLevelInfoModel>>;
        }));
    }

    protected processGetPublicationLevelById(response: HttpResponseBase): Observable<SwaggerResponse<PublicationLevelInfoModel>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PublicationLevelInfoModel.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<PublicationLevelInfoModel>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Gets the registration status of the concept.
     * @return OK
     */
    getRegistrationStatusById(id: string): Observable<SwaggerResponse<RegistrationStatusInfoModel>> {
        let url_ = this.baseUrl + "/api/ConceptView/{id}/registrationStatus";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetRegistrationStatusById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetRegistrationStatusById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<RegistrationStatusInfoModel>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<RegistrationStatusInfoModel>>;
        }));
    }

    protected processGetRegistrationStatusById(response: HttpResponseBase): Observable<SwaggerResponse<RegistrationStatusInfoModel>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistrationStatusInfoModel.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<RegistrationStatusInfoModel>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Returns a boolean with the information if a codelist entry already exists in a concept.
     * @param id The id of the concept.
     * @param code The code value.
     * @return OK
     */
    getCodelistEntriesExistsByIdAndCode(id: string, code: string): Observable<SwaggerResponse<boolean>> {
        let url_ = this.baseUrl + "/api/ConceptView/{id}/codelist-entries/exists?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (code === undefined || code === null)
            throw new globalThis.Error("The parameter 'code' must be defined and cannot be null.");
        else
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetCodelistEntriesExistsByIdAndCode(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetCodelistEntriesExistsByIdAndCode(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<boolean>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<boolean>>;
        }));
    }

    protected processGetCodelistEntriesExistsByIdAndCode(response: HttpResponseBase): Observable<SwaggerResponse<boolean>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<boolean>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Returns all entries of the concept (including annotations)
     * @param id The id of the concept.
     * @param page (optional) The number of the result page to return.
     * @param pageSize (optional) The size of each result page.
     * @return OK
     */
    getCodelistEntriesByIdAndPageAndPageSize(id: string, page: number | undefined, pageSize: number | undefined): Observable<SwaggerResponse<CodeListEntryDetail[]>> {
        let url_ = this.baseUrl + "/api/ConceptView/{id}/codelist-entries?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetCodelistEntriesByIdAndPageAndPageSize(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetCodelistEntriesByIdAndPageAndPageSize(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<CodeListEntryDetail[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<CodeListEntryDetail[]>>;
        }));
    }

    protected processGetCodelistEntriesByIdAndPageAndPageSize(response: HttpResponseBase): Observable<SwaggerResponse<CodeListEntryDetail[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CodeListEntryDetail.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<CodeListEntryDetail[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Returns code list entries for the specified concept that match the given code prefix,
    with optional sorting and paging for use in auto-complete scenarios.
     * @param id The id of the concept.
     * @param codePrefix (optional) An optional prefix used to filter code list entries by their code value.
     * @param sortProperty (optional) The sort property. When null, the default sort property defined in the concept will be used.
     * @param sortOrder (optional) Default is sort ascending.
     * @param page (optional) The number of the result page to return.
     * @param pageSize (optional) The size of each result page.
     * @return OK
     */
    getCodelistEntriesAutoCompleteByIdAndCodePrefixAndSortPropertyAndSortOrderAndPageAndPageSize(id: string, codePrefix: string | undefined, sortProperty: CodeListEntrySortProperty | undefined, sortOrder: SortOrder | undefined, page: number | undefined, pageSize: number | undefined): Observable<SwaggerResponse<CodelistEntryInput[]>> {
        let url_ = this.baseUrl + "/api/ConceptView/{id}/codelist-entries/auto-complete?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (codePrefix === null)
            throw new globalThis.Error("The parameter 'codePrefix' cannot be null.");
        else if (codePrefix !== undefined)
            url_ += "codePrefix=" + encodeURIComponent("" + codePrefix) + "&";
        if (sortProperty === null)
            throw new globalThis.Error("The parameter 'sortProperty' cannot be null.");
        else if (sortProperty !== undefined)
            url_ += "sortProperty=" + encodeURIComponent("" + sortProperty) + "&";
        if (sortOrder === null)
            throw new globalThis.Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetCodelistEntriesAutoCompleteByIdAndCodePrefixAndSortPropertyAndSortOrderAndPageAndPageSize(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetCodelistEntriesAutoCompleteByIdAndCodePrefixAndSortPropertyAndSortOrderAndPageAndPageSize(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<CodelistEntryInput[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<CodelistEntryInput[]>>;
        }));
    }

    protected processGetCodelistEntriesAutoCompleteByIdAndCodePrefixAndSortPropertyAndSortOrderAndPageAndPageSize(response: HttpResponseBase): Observable<SwaggerResponse<CodelistEntryInput[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CodelistEntryInput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<CodelistEntryInput[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Returns codelist entries of the concept filtered by code value
     * @param id The id of the concept.
     * @param code The code value.
     * @return OK
     */
    getCodelistEntriesByCodeByIdAndCode(id: string, code: string): Observable<SwaggerResponse<CodeListEntryDetail>> {
        let url_ = this.baseUrl + "/api/ConceptView/{id}/codelist-entries/by-code?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (code === undefined || code === null)
            throw new globalThis.Error("The parameter 'code' must be defined and cannot be null.");
        else
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetCodelistEntriesByCodeByIdAndCode(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetCodelistEntriesByCodeByIdAndCode(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<CodeListEntryDetail>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<CodeListEntryDetail>>;
        }));
    }

    protected processGetCodelistEntriesByCodeByIdAndCode(response: HttpResponseBase): Observable<SwaggerResponse<CodeListEntryDetail>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CodeListEntryDetail.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<CodeListEntryDetail>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Returns all root codelist entries of the codelist concept.
     * @param id The id of the concept.
     * @param sortProperty (optional) The sort property. When null, the default sort property defined in the concept will be used.
     * @param sortOrder (optional) Default is sort ascending.
     * @param page (optional) The number of the result page to return.
     * @param pageSize (optional) The size of each result page.
     * @return OK
     */
    getCodelistEntriesByRootByIdAndSortPropertyAndSortOrderAndPageAndPageSize(id: string, sortProperty: CodeListEntrySortProperty | undefined, sortOrder: SortOrder | undefined, page: number | undefined, pageSize: number | undefined): Observable<SwaggerResponse<CodeListEntryDetail[]>> {
        let url_ = this.baseUrl + "/api/ConceptView/{id}/codelist-entries/by-root?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (sortProperty === null)
            throw new globalThis.Error("The parameter 'sortProperty' cannot be null.");
        else if (sortProperty !== undefined)
            url_ += "sortProperty=" + encodeURIComponent("" + sortProperty) + "&";
        if (sortOrder === null)
            throw new globalThis.Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetCodelistEntriesByRootByIdAndSortPropertyAndSortOrderAndPageAndPageSize(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetCodelistEntriesByRootByIdAndSortPropertyAndSortOrderAndPageAndPageSize(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<CodeListEntryDetail[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<CodeListEntryDetail[]>>;
        }));
    }

    protected processGetCodelistEntriesByRootByIdAndSortPropertyAndSortOrderAndPageAndPageSize(response: HttpResponseBase): Observable<SwaggerResponse<CodeListEntryDetail[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CodeListEntryDetail.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<CodeListEntryDetail[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Returns all child codelist entries with the given parent_code.
     * @param id The id of the codelist concept.
     * @param code The code value.
     * @param sortProperty (optional) The sort property. When null, the default sort property defined in the concept will be used.
     * @param sortOrder (optional) Default is sort ascending.
     * @param page (optional) The number of the result page to return.
     * @param pageSize (optional) The size of each result page.
     * @return OK
     */
    getCodelistEntriesChildrenOfByIdAndCodeAndSortPropertyAndSortOrderAndPageAndPageSize(id: string, code: string, sortProperty: CodeListEntrySortProperty | undefined, sortOrder: SortOrder | undefined, page: number | undefined, pageSize: number | undefined): Observable<SwaggerResponse<CodeListEntryDetail[]>> {
        let url_ = this.baseUrl + "/api/ConceptView/{id}/codelist-entries/children-of?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (code === undefined || code === null)
            throw new globalThis.Error("The parameter 'code' must be defined and cannot be null.");
        else
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (sortProperty === null)
            throw new globalThis.Error("The parameter 'sortProperty' cannot be null.");
        else if (sortProperty !== undefined)
            url_ += "sortProperty=" + encodeURIComponent("" + sortProperty) + "&";
        if (sortOrder === null)
            throw new globalThis.Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetCodelistEntriesChildrenOfByIdAndCodeAndSortPropertyAndSortOrderAndPageAndPageSize(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetCodelistEntriesChildrenOfByIdAndCodeAndSortPropertyAndSortOrderAndPageAndPageSize(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<CodeListEntryDetail[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<CodeListEntryDetail[]>>;
        }));
    }

    protected processGetCodelistEntriesChildrenOfByIdAndCodeAndSortPropertyAndSortOrderAndPageAndPageSize(response: HttpResponseBase): Observable<SwaggerResponse<CodeListEntryDetail[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CodeListEntryDetail.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<CodeListEntryDetail[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Returns if the codelist concept has any parent code values.
     * @param id The id of the codelist concept.
     * @return OK
     */
    getCodelistEntriesHasParentCodesById(id: string): Observable<SwaggerResponse<boolean>> {
        let url_ = this.baseUrl + "/api/ConceptView/{id}/codelist-entries/has-parent-codes";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetCodelistEntriesHasParentCodesById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetCodelistEntriesHasParentCodesById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<boolean>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<boolean>>;
        }));
    }

    protected processGetCodelistEntriesHasParentCodesById(response: HttpResponseBase): Observable<SwaggerResponse<boolean>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<boolean>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Returns the page number of the code with the same parent code.
     * @param id The id of the codelist concept.
     * @param code The code value.
     * @param sortProperty (optional) The sort property. When null, the default sort property defined in the concept will be used.
     * @param sortOrder (optional) Default is sort ascending.
     * @param pageSize (optional) The size of each result page.
     * @return OK
     */
    getCodelistEntriesPageNumberFromSameParentByIdAndCodeAndSortPropertyAndSortOrderAndPageSize(id: string, code: string, sortProperty: CodeListEntrySortProperty | undefined, sortOrder: SortOrder | undefined, pageSize: number | undefined): Observable<SwaggerResponse<number>> {
        let url_ = this.baseUrl + "/api/ConceptView/{id}/codelist-entries/page-number-from-same-parent?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (code === undefined || code === null)
            throw new globalThis.Error("The parameter 'code' must be defined and cannot be null.");
        else
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (sortProperty === null)
            throw new globalThis.Error("The parameter 'sortProperty' cannot be null.");
        else if (sortProperty !== undefined)
            url_ += "sortProperty=" + encodeURIComponent("" + sortProperty) + "&";
        if (sortOrder === null)
            throw new globalThis.Error("The parameter 'sortOrder' cannot be null.");
        else if (sortOrder !== undefined)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetCodelistEntriesPageNumberFromSameParentByIdAndCodeAndSortPropertyAndSortOrderAndPageSize(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetCodelistEntriesPageNumberFromSameParentByIdAndCodeAndSortPropertyAndSortOrderAndPageSize(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<number>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<number>>;
        }));
    }

    protected processGetCodelistEntriesPageNumberFromSameParentByIdAndCodeAndSortPropertyAndSortOrderAndPageSize(response: HttpResponseBase): Observable<SwaggerResponse<number>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<number>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Exports all code list entries of the concept in the specified format.
     * @param id The id of the concept.
     * @param format The data format in which to export the code list entries.
     * @param withAnnotations (optional) When `true`, annotations are included in the export.
     * @return OK
     */
    getCodelistEntriesExportsByIdAndFormatAndWithAnnotations(id: string, format: CodeListEntriesDataFormat, withAnnotations: boolean | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/ConceptView/{id}/codelist-entries/exports/{format}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (format === undefined || format === null)
            throw new globalThis.Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        if (withAnnotations === null)
            throw new globalThis.Error("The parameter 'withAnnotations' cannot be null.");
        else if (withAnnotations !== undefined)
            url_ += "withAnnotations=" + encodeURIComponent("" + withAnnotations) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetCodelistEntriesExportsByIdAndFormatAndWithAnnotations(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetCodelistEntriesExportsByIdAndFormatAndWithAnnotations(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGetCodelistEntriesExportsByIdAndFormatAndWithAnnotations(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Searches code list entries for a given concept and language, applying optional query text,
    filters, and paging parameters.
     * @param id The id of the codelist concept.
     * @param language The language code used to localize the code list entries.
     * @param query (optional) Optional free-text query used to filter the code list entries.
     * @param filters (optional) Optional list of filter expressions applied when searching code list entries.
     * @param page (optional) The number of the result page to return.
     * @param pageSize (optional) The size of each result page.
     * @return OK
     */
    getCodelistEntriesSearchByIdAndLanguageAndQueryAndFiltersAndPageAndPageSize(id: string, language: string, query: string | undefined, filters: string[] | undefined, page: number | undefined, pageSize: number | undefined): Observable<SwaggerResponse<CodeListEntrySearchResultEntryModel[]>> {
        let url_ = this.baseUrl + "/api/ConceptView/{id}/codelist-entries/search?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (language === undefined || language === null)
            throw new globalThis.Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (filters === null)
            throw new globalThis.Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "filters=" + encodeURIComponent("" + item) + "&"; });
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetCodelistEntriesSearchByIdAndLanguageAndQueryAndFiltersAndPageAndPageSize(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetCodelistEntriesSearchByIdAndLanguageAndQueryAndFiltersAndPageAndPageSize(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<CodeListEntrySearchResultEntryModel[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<CodeListEntrySearchResultEntryModel[]>>;
        }));
    }

    protected processGetCodelistEntriesSearchByIdAndLanguageAndQueryAndFiltersAndPageAndPageSize(response: HttpResponseBase): Observable<SwaggerResponse<CodeListEntrySearchResultEntryModel[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CodeListEntrySearchResultEntryModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<CodeListEntrySearchResultEntryModel[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Gets the dataset attributes whose dcterms:conformsTo value references the specified concept
     * @param id The id of the concept.
     * @param page (optional) The number of the result page to return.
     * @param pageSize (optional) The size of each result page.
     * @return OK
     */
    getStructureReferencesByIdAndPageAndPageSize(id: string, page: number | undefined, pageSize: number | undefined): Observable<SwaggerResponse<IopConceptStructureReferenceModel[]>> {
        let url_ = this.baseUrl + "/api/ConceptView/{id}/structure-references?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetStructureReferencesByIdAndPageAndPageSize(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetStructureReferencesByIdAndPageAndPageSize(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<IopConceptStructureReferenceModel[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<IopConceptStructureReferenceModel[]>>;
        }));
    }

    protected processGetStructureReferencesByIdAndPageAndPageSize(response: HttpResponseBase): Observable<SwaggerResponse<IopConceptStructureReferenceModel[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IopConceptStructureReferenceModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<IopConceptStructureReferenceModel[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Gets the number of dataset attributes whose dcterms:conformsTo value references the specified concept
     * @param id The id of the concept.
     * @return OK
     */
    getStructureReferencesCountById(id: string): Observable<SwaggerResponse<number>> {
        let url_ = this.baseUrl + "/api/ConceptView/{id}/structure-references/count";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetStructureReferencesCountById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetStructureReferencesCountById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<number>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<number>>;
        }));
    }

    protected processGetStructureReferencesCountById(response: HttpResponseBase): Observable<SwaggerResponse<number>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<number>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * @return OK
     */
    getExportByIdAndFormat(id: string, format: DataFormat): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/ConceptView/{id}/export/{format}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (format === undefined || format === null)
            throw new globalThis.Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetExportByIdAndFormat(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetExportByIdAndFormat(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGetExportByIdAndFormat(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable({
    providedIn: 'root'
})
export class DataServiceClient extends Extensions.ApiClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(BfsIopAdminApiClientSupport) configuration: BfsIopAdminApiClientSupport, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(IOP_ADMIN_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets the DataService by id
     * @return OK
     */
    getById(id: string): Observable<SwaggerResponse<DataService>> {
        let url_ = this.baseUrl + "/api/DataService/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<DataService>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<DataService>>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<SwaggerResponse<DataService>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataService.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<DataService>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Gets the registration status of the data service.
     * @return OK
     */
    getRegistrationStatusById(id: string): Observable<SwaggerResponse<RegistrationStatusInfoModel>> {
        let url_ = this.baseUrl + "/api/DataService/{id}/registrationStatus";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetRegistrationStatusById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetRegistrationStatusById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<RegistrationStatusInfoModel>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<RegistrationStatusInfoModel>>;
        }));
    }

    protected processGetRegistrationStatusById(response: HttpResponseBase): Observable<SwaggerResponse<RegistrationStatusInfoModel>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistrationStatusInfoModel.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<RegistrationStatusInfoModel>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Get the publication level of the data service
     * @return OK
     */
    getPublicationLevelById(id: string): Observable<SwaggerResponse<PublicationLevelInfoModel>> {
        let url_ = this.baseUrl + "/api/DataService/{id}/publicationLevel";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetPublicationLevelById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetPublicationLevelById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<PublicationLevelInfoModel>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<PublicationLevelInfoModel>>;
        }));
    }

    protected processGetPublicationLevelById(response: HttpResponseBase): Observable<SwaggerResponse<PublicationLevelInfoModel>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PublicationLevelInfoModel.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<PublicationLevelInfoModel>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable({
    providedIn: 'root'
})
export class DataServiceInputClient extends Extensions.ApiClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(BfsIopAdminApiClientSupport) configuration: BfsIopAdminApiClientSupport, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(IOP_ADMIN_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Deletes the entity
     * @return No Content
     */
    deleteById(id: string): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/DataServiceInput/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processDeleteById(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Updates the entity
     * @param body (optional) 
     * @return No Content
     */
    putByBody(body: DataServiceInput | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/DataServiceInput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPutByBody(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutByBody(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPutByBody(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Add a new dataService
     * @param body (optional) The new dataService
     * @return Created
     */
    postByBody(body: DataServiceInput | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/DataServiceInput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPostByBody(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPostByBody(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPostByBody(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Returns all datasets that are linked to this data service via a relationship.
     * @param id The data service id.
     * @return OK
     */
    getServesDatasetsById(id: string): Observable<SwaggerResponse<Dataset[]>> {
        let url_ = this.baseUrl + "/api/DataServiceInput/{id}/servesDatasets";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetServesDatasetsById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetServesDatasetsById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<Dataset[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<Dataset[]>>;
        }));
    }

    protected processGetServesDatasetsById(response: HttpResponseBase): Observable<SwaggerResponse<Dataset[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Dataset.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<Dataset[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Updates the registration status of a data service.
     * @param id The data service id.
     * @param status (optional) The new registration status.
     * @return No Content
     */
    putRegistrationStatusByIdAndStatus(id: string, status: RegistrationStatus | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/DataServiceInput/{id}/registrationStatus?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPutRegistrationStatusByIdAndStatus(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutRegistrationStatusByIdAndStatus(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPutRegistrationStatusByIdAndStatus(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Updates the registration proposal of a data service.
     * @param id The data service id.
     * @param proposal (optional) The new registration proposal or empty to revert an existing proposal.
     * @return No Content
     */
    putRegistrationStatusProposalByIdAndProposal(id: string, proposal: RegistrationStatus | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/DataServiceInput/{id}/registrationStatusProposal?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (proposal === null)
            throw new globalThis.Error("The parameter 'proposal' cannot be null.");
        else if (proposal !== undefined)
            url_ += "proposal=" + encodeURIComponent("" + proposal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPutRegistrationStatusProposalByIdAndProposal(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutRegistrationStatusProposalByIdAndProposal(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPutRegistrationStatusProposalByIdAndProposal(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Updates the publication level of a data service.
     * @param id The data service id.
     * @param level (optional) The new publication level.
     * @return No Content
     */
    putPublicationLevelByIdAndLevel(id: string, level: PublicationLevel | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/DataServiceInput/{id}/publicationLevel?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (level === null)
            throw new globalThis.Error("The parameter 'level' cannot be null.");
        else if (level !== undefined)
            url_ += "level=" + encodeURIComponent("" + level) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPutPublicationLevelByIdAndLevel(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutPublicationLevelByIdAndLevel(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPutPublicationLevelByIdAndLevel(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Updates the publication level proposal of a data service.
     * @param id The data service id.
     * @param proposal (optional) The new publication level proposal or an empty value to reset an existing one.
     * @return No Content
     */
    putPublicationLevelProposalByIdAndProposal(id: string, proposal: PublicationLevel | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/DataServiceInput/{id}/publicationLevelProposal?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (proposal === null)
            throw new globalThis.Error("The parameter 'proposal' cannot be null.");
        else if (proposal !== undefined)
            url_ += "proposal=" + encodeURIComponent("" + proposal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPutPublicationLevelProposalByIdAndProposal(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutPublicationLevelProposalByIdAndProposal(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPutPublicationLevelProposalByIdAndProposal(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable({
    providedIn: 'root'
})
export class DataServicesClient extends Extensions.ApiClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(BfsIopAdminApiClientSupport) configuration: BfsIopAdminApiClientSupport, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(IOP_ADMIN_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getById(id: string): Observable<SwaggerResponse<DataServiceModel>> {
        let url_ = this.baseUrl + "/api/DataServices/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<DataServiceModel>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<DataServiceModel>>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<SwaggerResponse<DataServiceModel>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataServiceModel.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<DataServiceModel>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Gets the data services matching the given filters.
     * @param accessRights (optional) Code from RightsStatement_ACCESS_RIGHTS vocabulary.
     * @param dataServiceIdentifier (optional) 
     * @param publisherIdentifier (optional) 
     * @param publicationLevel (optional) 
     * @param registrationStatus (optional) 
     * @param page (optional) Page number.
     * @param pageSize (optional) Max number of results per page.
     * @return OK
     */
    getByAccessRightsAndDataServiceIdentifierAndPublisherIdentifierAndPublicationLevelAndRegistrationStatusAndPageAndPageSize(accessRights: string | undefined, dataServiceIdentifier: string | undefined, publisherIdentifier: string | undefined, publicationLevel: PublicationLevel | undefined, registrationStatus: RegistrationStatus | undefined, page: number | undefined, pageSize: number | undefined): Observable<SwaggerResponse<DataServiceModel[]>> {
        let url_ = this.baseUrl + "/api/DataServices?";
        if (accessRights === null)
            throw new globalThis.Error("The parameter 'accessRights' cannot be null.");
        else if (accessRights !== undefined)
            url_ += "accessRights=" + encodeURIComponent("" + accessRights) + "&";
        if (dataServiceIdentifier === null)
            throw new globalThis.Error("The parameter 'dataServiceIdentifier' cannot be null.");
        else if (dataServiceIdentifier !== undefined)
            url_ += "dataServiceIdentifier=" + encodeURIComponent("" + dataServiceIdentifier) + "&";
        if (publisherIdentifier === null)
            throw new globalThis.Error("The parameter 'publisherIdentifier' cannot be null.");
        else if (publisherIdentifier !== undefined)
            url_ += "publisherIdentifier=" + encodeURIComponent("" + publisherIdentifier) + "&";
        if (publicationLevel === null)
            throw new globalThis.Error("The parameter 'publicationLevel' cannot be null.");
        else if (publicationLevel !== undefined)
            url_ += "publicationLevel=" + encodeURIComponent("" + publicationLevel) + "&";
        if (registrationStatus === null)
            throw new globalThis.Error("The parameter 'registrationStatus' cannot be null.");
        else if (registrationStatus !== undefined)
            url_ += "registrationStatus=" + encodeURIComponent("" + registrationStatus) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetByAccessRightsAndDataServiceIdentifierAndPublisherIdentifierAndPublicationLevelAndRegistrationStatusAndPageAndPageSize(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetByAccessRightsAndDataServiceIdentifierAndPublisherIdentifierAndPublicationLevelAndRegistrationStatusAndPageAndPageSize(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<DataServiceModel[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<DataServiceModel[]>>;
        }));
    }

    protected processGetByAccessRightsAndDataServiceIdentifierAndPublisherIdentifierAndPublicationLevelAndRegistrationStatusAndPageAndPageSize(response: HttpResponseBase): Observable<SwaggerResponse<DataServiceModel[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataServiceModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<DataServiceModel[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    getNextVersionsByIdAndPageAndPageSize(id: string, page: number | undefined, pageSize: number | undefined): Observable<SwaggerResponse<DataServiceModel[]>> {
        let url_ = this.baseUrl + "/api/DataServices/{id}/next-versions?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetNextVersionsByIdAndPageAndPageSize(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetNextVersionsByIdAndPageAndPageSize(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<DataServiceModel[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<DataServiceModel[]>>;
        }));
    }

    protected processGetNextVersionsByIdAndPageAndPageSize(response: HttpResponseBase): Observable<SwaggerResponse<DataServiceModel[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataServiceModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<DataServiceModel[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * @return OK
     */
    getIdentifierExistsByIdentifier(identifier: string): Observable<SwaggerResponse<boolean>> {
        let url_ = this.baseUrl + "/api/DataServices/identifier/{identifier}/exists";
        if (identifier === undefined || identifier === null)
            throw new globalThis.Error("The parameter 'identifier' must be defined.");
        url_ = url_.replace("{identifier}", encodeURIComponent("" + identifier));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetIdentifierExistsByIdentifier(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetIdentifierExistsByIdentifier(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<boolean>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<boolean>>;
        }));
    }

    protected processGetIdentifierExistsByIdentifier(response: HttpResponseBase): Observable<SwaggerResponse<boolean>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<boolean>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * @return OK
     */
    getExportByIdAndFormat(id: string, format: DataFormat): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/DataServices/{id}/export/{format}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (format === undefined || format === null)
            throw new globalThis.Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetExportByIdAndFormat(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetExportByIdAndFormat(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGetExportByIdAndFormat(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable({
    providedIn: 'root'
})
export class DatasetClient extends Extensions.ApiClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(BfsIopAdminApiClientSupport) configuration: BfsIopAdminApiClientSupport, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(IOP_ADMIN_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets the dataset by id
     * @return OK
     */
    getById(id: string): Observable<SwaggerResponse<Dataset>> {
        let url_ = this.baseUrl + "/api/Dataset/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<Dataset>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<Dataset>>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<SwaggerResponse<Dataset>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Dataset.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<Dataset>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Gets the (authorized) data services serving the dataset.
     * @return OK
     */
    getIsServedByById(id: string): Observable<SwaggerResponse<DataServiceModel[]>> {
        let url_ = this.baseUrl + "/api/Dataset/{id}/is-served-by";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetIsServedByById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetIsServedByById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<DataServiceModel[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<DataServiceModel[]>>;
        }));
    }

    protected processGetIsServedByById(response: HttpResponseBase): Observable<SwaggerResponse<DataServiceModel[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataServiceModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<DataServiceModel[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Returns all distributions for the dataset
     * @return OK
     */
    getDistributionsById(id: string): Observable<SwaggerResponse<DistributionSummary[]>> {
        let url_ = this.baseUrl + "/api/Dataset/{id}/distributions";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetDistributionsById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetDistributionsById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<DistributionSummary[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<DistributionSummary[]>>;
        }));
    }

    protected processGetDistributionsById(response: HttpResponseBase): Observable<SwaggerResponse<DistributionSummary[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DistributionSummary.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<DistributionSummary[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Gets the registration status of the dataset.
     * @return OK
     */
    getRegistrationStatusById(id: string): Observable<SwaggerResponse<RegistrationStatusInfoModel>> {
        let url_ = this.baseUrl + "/api/Dataset/{id}/registrationStatus";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetRegistrationStatusById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetRegistrationStatusById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<RegistrationStatusInfoModel>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<RegistrationStatusInfoModel>>;
        }));
    }

    protected processGetRegistrationStatusById(response: HttpResponseBase): Observable<SwaggerResponse<RegistrationStatusInfoModel>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistrationStatusInfoModel.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<RegistrationStatusInfoModel>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Gets the publication level of the dataset.
     * @return OK
     */
    getPublicationLevelById(id: string): Observable<SwaggerResponse<PublicationLevelInfoModel>> {
        let url_ = this.baseUrl + "/api/Dataset/{id}/publicationLevel";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetPublicationLevelById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetPublicationLevelById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<PublicationLevelInfoModel>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<PublicationLevelInfoModel>>;
        }));
    }

    protected processGetPublicationLevelById(response: HttpResponseBase): Observable<SwaggerResponse<PublicationLevelInfoModel>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PublicationLevelInfoModel.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<PublicationLevelInfoModel>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * @return OK
     */
    getExportByIdAndFormat(id: string, format: DataFormat): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/Dataset/{id}/export/{format}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (format === undefined || format === null)
            throw new globalThis.Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetExportByIdAndFormat(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetExportByIdAndFormat(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGetExportByIdAndFormat(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable({
    providedIn: 'root'
})
export class DatasetInputClient extends Extensions.ApiClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(BfsIopAdminApiClientSupport) configuration: BfsIopAdminApiClientSupport, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(IOP_ADMIN_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Checks whether the identifier is in use
     * @return OK
     */
    getIdentifierExistsByIdentifier(identifier: string): Observable<SwaggerResponse<boolean>> {
        let url_ = this.baseUrl + "/api/DatasetInput/identifier/{identifier}/exists";
        if (identifier === undefined || identifier === null)
            throw new globalThis.Error("The parameter 'identifier' must be defined.");
        url_ = url_.replace("{identifier}", encodeURIComponent("" + identifier));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetIdentifierExistsByIdentifier(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetIdentifierExistsByIdentifier(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<boolean>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<boolean>>;
        }));
    }

    protected processGetIdentifierExistsByIdentifier(response: HttpResponseBase): Observable<SwaggerResponse<boolean>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<boolean>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Deletes the entity
     * @return No Content
     */
    deleteById(id: string): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/DatasetInput/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processDeleteById(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Updates the entity
     * @param body (optional) 
     * @return No Content
     */
    putByIdAndBody(id: string, body: DcatDatasetInputModel | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/DatasetInput/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPutByIdAndBody(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutByIdAndBody(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPutByIdAndBody(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Add a new dataset
     * @param body (optional) The new dataset
     * @return Created
     */
    postByBody(body: DcatDatasetInputModel | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/DatasetInput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPostByBody(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPostByBody(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPostByBody(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Updates the registration status of a dataset.
     * @param id The dataset id.
     * @param status (optional) The new registration status or proposal.
     * @return No Content
     */
    putRegistrationStatusByIdAndStatus(id: string, status: RegistrationStatus | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/DatasetInput/{id}/registrationStatus?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPutRegistrationStatusByIdAndStatus(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutRegistrationStatusByIdAndStatus(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPutRegistrationStatusByIdAndStatus(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Updates the registration proposal of a dataset.
     * @param id The dataset id.
     * @param proposal (optional) The new registration proposal or empty to revert an existing state.
     * @return No Content
     */
    putRegistrationStatusProposalByIdAndProposal(id: string, proposal: RegistrationStatus | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/DatasetInput/{id}/registrationStatusProposal?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (proposal === null)
            throw new globalThis.Error("The parameter 'proposal' cannot be null.");
        else if (proposal !== undefined)
            url_ += "proposal=" + encodeURIComponent("" + proposal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPutRegistrationStatusProposalByIdAndProposal(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutRegistrationStatusProposalByIdAndProposal(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPutRegistrationStatusProposalByIdAndProposal(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Updates the publication level of a dataset.
     * @param id The dataset id.
     * @param level (optional) The new publication level.
     * @return No Content
     */
    putPublicationLevelByIdAndLevel(id: string, level: PublicationLevel | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/DatasetInput/{id}/publicationLevel?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (level === null)
            throw new globalThis.Error("The parameter 'level' cannot be null.");
        else if (level !== undefined)
            url_ += "level=" + encodeURIComponent("" + level) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPutPublicationLevelByIdAndLevel(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutPublicationLevelByIdAndLevel(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPutPublicationLevelByIdAndLevel(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Updates the publication level proposal of a dataset.
     * @param id The dataset id.
     * @param proposal (optional) The new publication level proposal or an empty value to reset an existing one.
     * @return No Content
     */
    putPublicationLevelProposalByIdAndProposal(id: string, proposal: PublicationLevel | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/DatasetInput/{id}/publicationLevelProposal?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (proposal === null)
            throw new globalThis.Error("The parameter 'proposal' cannot be null.");
        else if (proposal !== undefined)
            url_ += "proposal=" + encodeURIComponent("" + proposal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPutPublicationLevelProposalByIdAndProposal(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutPublicationLevelProposalByIdAndProposal(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPutPublicationLevelProposalByIdAndProposal(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * @param file (optional) 
     * @return Created
     */
    postImportByBody(file: FileParameter | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/DatasetInput/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPostImportByBody(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPostImportByBody(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processPostImportByBody(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return _observableOf(new SwaggerResponse(status, _headers, result201));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Uploads a new file for the specified dataset.
     * @param id The id of the dataset.
     * @param importFile (optional) The file to be imported.
     * @return Created
     */
    postModelImportByIdAndBody(id: string, importFile: FileParameter | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/DatasetInput/{id}/model/import";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (importFile === null || importFile === undefined)
            throw new globalThis.Error("The parameter 'importFile' cannot be null.");
        else
            content_.append("importFile", importFile.data, importFile.fileName ? importFile.fileName : "importFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPostModelImportByIdAndBody(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPostModelImportByIdAndBody(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPostModelImportByIdAndBody(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Downloads the file for the specified dataset.
     * @param id The id of the dataset.
     * @param format The export linked data format
     * @return OK
     */
    getModelExportByIdAndFormat(id: string, format: LinkedDataFormat): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/DatasetInput/{id}/model/export?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (format === undefined || format === null)
            throw new globalThis.Error("The parameter 'format' must be defined and cannot be null.");
        else
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetModelExportByIdAndFormat(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetModelExportByIdAndFormat(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGetModelExportByIdAndFormat(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Checks whether file exists for the specified dataset.
     * @param id The id of the dataset.
     * @return OK
     */
    getModelExistsById(id: string): Observable<SwaggerResponse<boolean>> {
        let url_ = this.baseUrl + "/api/DatasetInput/{id}/model/exists";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetModelExistsById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetModelExistsById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<boolean>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<boolean>>;
        }));
    }

    protected processGetModelExistsById(response: HttpResponseBase): Observable<SwaggerResponse<boolean>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<boolean>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Deletes the file associated with the specified dataset.
     * @param id The id of the dataset.
     * @return No Content
     */
    deleteModelDeleteById(id: string): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/DatasetInput/{id}/model/delete";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteModelDeleteById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteModelDeleteById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processDeleteModelDeleteById(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Return dataset model in format shemaGraph.
     * @param id The id of the dataset.
     * @return OK
     */
    getModelGraphById(id: string): Observable<SwaggerResponse<SchemaGraph>> {
        let url_ = this.baseUrl + "/api/DatasetInput/{id}/model/graph";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetModelGraphById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetModelGraphById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<SchemaGraph>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<SchemaGraph>>;
        }));
    }

    protected processGetModelGraphById(response: HttpResponseBase): Observable<SwaggerResponse<SchemaGraph>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SchemaGraph.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<SchemaGraph>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Update dataset class position
     * @return No Content
     */
    putModelPositionByIdAndBody(id: string, body: { [key: string]: SchemaPoint; }): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/DatasetInput/{id}/model/position";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPutModelPositionByIdAndBody(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutModelPositionByIdAndBody(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPutModelPositionByIdAndBody(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Update dataset model class
     * @return No Content
     */
    putModelClassByIdAndBody(id: string, body: SchemaClass): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/DatasetInput/{id}/model/class";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPutModelClassByIdAndBody(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutModelClassByIdAndBody(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPutModelClassByIdAndBody(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Create a new schemaclass in the dataset structure.
     * @return Created
     */
    postModelClassByIdAndBody(id: string, body: SchemaClass): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/DatasetInput/{id}/model/class";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPostModelClassByIdAndBody(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPostModelClassByIdAndBody(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processPostModelClassByIdAndBody(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return _observableOf(new SwaggerResponse(status, _headers, result201));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Delete a PropertyShape from the dataset structure.
     * @param id The id of the dataset.
     * @param propertyUri Absolute URI of the PropertyShape to delete.
     * @return No Content
     */
    deleteModelPropertyByIdAndPropertyUri(id: string, propertyUri: string): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/DatasetInput/{id}/model/property?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (propertyUri === undefined || propertyUri === null)
            throw new globalThis.Error("The parameter 'propertyUri' must be defined and cannot be null.");
        else
            url_ += "propertyUri=" + encodeURIComponent("" + propertyUri) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteModelPropertyByIdAndPropertyUri(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteModelPropertyByIdAndPropertyUri(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processDeleteModelPropertyByIdAndPropertyUri(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Create a new PropertyShape attached to the class identified by classUri.
     * @return Created
     */
    postModelPropertyByIdAndClassUriAndBody(id: string, classUri: string, body: SchemaProperty): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/DatasetInput/{id}/model/property?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (classUri === undefined || classUri === null)
            throw new globalThis.Error("The parameter 'classUri' must be defined and cannot be null.");
        else
            url_ += "classUri=" + encodeURIComponent("" + classUri) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPostModelPropertyByIdAndClassUriAndBody(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPostModelPropertyByIdAndClassUriAndBody(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processPostModelPropertyByIdAndClassUriAndBody(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return _observableOf(new SwaggerResponse(status, _headers, result201));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Update a PropertyShape attached to the class identified by classUri.
     * @return No Content
     */
    putModelPropertyByIdAndClassUriAndBody(id: string, classUri: string, body: SchemaProperty): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/DatasetInput/{id}/model/property?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (classUri === undefined || classUri === null)
            throw new globalThis.Error("The parameter 'classUri' must be defined and cannot be null.");
        else
            url_ += "classUri=" + encodeURIComponent("" + classUri) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPutModelPropertyByIdAndClassUriAndBody(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutModelPropertyByIdAndClassUriAndBody(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPutModelPropertyByIdAndClassUriAndBody(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable({
    providedIn: 'root'
})
export class DatasetQualityInformationClient extends Extensions.ApiClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(BfsIopAdminApiClientSupport) configuration: BfsIopAdminApiClientSupport, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(IOP_ADMIN_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Creates a new set of quality informations for a given dataset.
     * @param body (optional) The set of quality informations
     * @return OK
     */
    postByBody(body: DatasetQualityInformationData | undefined): Observable<SwaggerResponse<DatasetQualityInformationData>> {
        let url_ = this.baseUrl + "/api/DatasetQualityInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPostByBody(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPostByBody(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<DatasetQualityInformationData>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<DatasetQualityInformationData>>;
        }));
    }

    protected processPostByBody(response: HttpResponseBase): Observable<SwaggerResponse<DatasetQualityInformationData>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DatasetQualityInformationData.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = DatasetQualityInformationData.fromJS(resultData201);
            return _observableOf(new SwaggerResponse(status, _headers, result201));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<DatasetQualityInformationData>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Upddate a set of quality informations for a given dataset.
     * @param body (optional) The set of quality informations
     * @return No Content
     */
    putByBody(body: DatasetQualityInformationData | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/DatasetQualityInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPutByBody(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutByBody(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPutByBody(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Deletes from a dataset all quality informaitons.
     * @param datasetId The id of the dataset to remove all quality informations from.
     * @return No Content
     */
    deleteByDatasetId(datasetId: string): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/DatasetQualityInformation/{datasetId}";
        if (datasetId === undefined || datasetId === null)
            throw new globalThis.Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteByDatasetId(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteByDatasetId(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processDeleteByDatasetId(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Lists quality informations by a dataset
     * @return OK
     */
    getByDatasetId(datasetId: string): Observable<SwaggerResponse<DatasetQualityInformationData>> {
        let url_ = this.baseUrl + "/api/DatasetQualityInformation/{datasetId}";
        if (datasetId === undefined || datasetId === null)
            throw new globalThis.Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetByDatasetId(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetByDatasetId(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<DatasetQualityInformationData>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<DatasetQualityInformationData>>;
        }));
    }

    protected processGetByDatasetId(response: HttpResponseBase): Observable<SwaggerResponse<DatasetQualityInformationData>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DatasetQualityInformationData.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<DatasetQualityInformationData>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Lists all questions.
     * @return OK
     */
    getDefinition(): Observable<SwaggerResponse<DatasetQualityQuestion[]>> {
        let url_ = this.baseUrl + "/api/DatasetQualityInformation/definition";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetDefinition(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetDefinition(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<DatasetQualityQuestion[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<DatasetQualityQuestion[]>>;
        }));
    }

    protected processGetDefinition(response: HttpResponseBase): Observable<SwaggerResponse<DatasetQualityQuestion[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DatasetQualityQuestion.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<DatasetQualityQuestion[]>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable({
    providedIn: 'root'
})
export class DatasetsClient extends Extensions.ApiClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(BfsIopAdminApiClientSupport) configuration: BfsIopAdminApiClientSupport, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(IOP_ADMIN_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getById(id: string): Observable<SwaggerResponse<DcatDatasetModel>> {
        let url_ = this.baseUrl + "/api/Datasets/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<DcatDatasetModel>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<DcatDatasetModel>>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<SwaggerResponse<DcatDatasetModel>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DcatDatasetModel.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<DcatDatasetModel>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Gets the  datasets matching the given filters.
     * @param accessRights (optional) Code from RightsStatement_ACCESS_RIGHTS vocabulary.
     * @param datasetIdentifier (optional) 
     * @param publisherIdentifier (optional) 
     * @param publicationLevel (optional) 
     * @param registrationStatus (optional) 
     * @param page (optional) Page number.
     * @param pageSize (optional) Max number of results per page.
     * @return OK
     */
    getByAccessRightsAndDatasetIdentifierAndPublisherIdentifierAndPublicationLevelAndRegistrationStatusAndPageAndPageSize(accessRights: string | undefined, datasetIdentifier: string | undefined, publisherIdentifier: string | undefined, publicationLevel: PublicationLevel | undefined, registrationStatus: RegistrationStatus | undefined, page: number | undefined, pageSize: number | undefined): Observable<SwaggerResponse<DcatDatasetModel[]>> {
        let url_ = this.baseUrl + "/api/Datasets?";
        if (accessRights === null)
            throw new globalThis.Error("The parameter 'accessRights' cannot be null.");
        else if (accessRights !== undefined)
            url_ += "accessRights=" + encodeURIComponent("" + accessRights) + "&";
        if (datasetIdentifier === null)
            throw new globalThis.Error("The parameter 'datasetIdentifier' cannot be null.");
        else if (datasetIdentifier !== undefined)
            url_ += "datasetIdentifier=" + encodeURIComponent("" + datasetIdentifier) + "&";
        if (publisherIdentifier === null)
            throw new globalThis.Error("The parameter 'publisherIdentifier' cannot be null.");
        else if (publisherIdentifier !== undefined)
            url_ += "publisherIdentifier=" + encodeURIComponent("" + publisherIdentifier) + "&";
        if (publicationLevel === null)
            throw new globalThis.Error("The parameter 'publicationLevel' cannot be null.");
        else if (publicationLevel !== undefined)
            url_ += "publicationLevel=" + encodeURIComponent("" + publicationLevel) + "&";
        if (registrationStatus === null)
            throw new globalThis.Error("The parameter 'registrationStatus' cannot be null.");
        else if (registrationStatus !== undefined)
            url_ += "registrationStatus=" + encodeURIComponent("" + registrationStatus) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetByAccessRightsAndDatasetIdentifierAndPublisherIdentifierAndPublicationLevelAndRegistrationStatusAndPageAndPageSize(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetByAccessRightsAndDatasetIdentifierAndPublisherIdentifierAndPublicationLevelAndRegistrationStatusAndPageAndPageSize(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<DcatDatasetModel[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<DcatDatasetModel[]>>;
        }));
    }

    protected processGetByAccessRightsAndDatasetIdentifierAndPublisherIdentifierAndPublicationLevelAndRegistrationStatusAndPageAndPageSize(response: HttpResponseBase): Observable<SwaggerResponse<DcatDatasetModel[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DcatDatasetModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<DcatDatasetModel[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    getNextVersionsByIdAndPageAndPageSize(id: string, page: number | undefined, pageSize: number | undefined): Observable<SwaggerResponse<DcatDatasetModel[]>> {
        let url_ = this.baseUrl + "/api/Datasets/{id}/next-versions?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetNextVersionsByIdAndPageAndPageSize(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetNextVersionsByIdAndPageAndPageSize(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<DcatDatasetModel[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<DcatDatasetModel[]>>;
        }));
    }

    protected processGetNextVersionsByIdAndPageAndPageSize(response: HttpResponseBase): Observable<SwaggerResponse<DcatDatasetModel[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DcatDatasetModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<DcatDatasetModel[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * @return OK
     */
    getDistributionsAccessServicesByDatasetIdAndDistributionId(datasetId: string, distributionId: string): Observable<SwaggerResponse<DataServiceModel[]>> {
        let url_ = this.baseUrl + "/api/Datasets/{datasetId}/distributions/{distributionId}/access-services";
        if (datasetId === undefined || datasetId === null)
            throw new globalThis.Error("The parameter 'datasetId' must be defined.");
        url_ = url_.replace("{datasetId}", encodeURIComponent("" + datasetId));
        if (distributionId === undefined || distributionId === null)
            throw new globalThis.Error("The parameter 'distributionId' must be defined.");
        url_ = url_.replace("{distributionId}", encodeURIComponent("" + distributionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetDistributionsAccessServicesByDatasetIdAndDistributionId(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetDistributionsAccessServicesByDatasetIdAndDistributionId(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<DataServiceModel[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<DataServiceModel[]>>;
        }));
    }

    protected processGetDistributionsAccessServicesByDatasetIdAndDistributionId(response: HttpResponseBase): Observable<SwaggerResponse<DataServiceModel[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DataServiceModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<DataServiceModel[]>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable({
    providedIn: 'root'
})
export class DcatCatalogInputClient extends Extensions.ApiClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(BfsIopAdminApiClientSupport) configuration: BfsIopAdminApiClientSupport, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(IOP_ADMIN_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Deletes an existing catalog record.
     * @param id The catalog id.
     * @param recordId The record id.
     * @return No Content
     */
    deleteRecordsByIdAndRecordId(id: string, recordId: string): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/DcatCatalogInput/{id}/records/{recordId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (recordId === undefined || recordId === null)
            throw new globalThis.Error("The parameter 'recordId' must be defined.");
        url_ = url_.replace("{recordId}", encodeURIComponent("" + recordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteRecordsByIdAndRecordId(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteRecordsByIdAndRecordId(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processDeleteRecordsByIdAndRecordId(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Creates a new Dcat CatalogRecordInput based on Dcat Catalog.
     * @param body (optional) The CatalogRecordInput.
     * @return OK
     */
    postRecordsByBody(body: DcatCatalogRecordInput | undefined): Observable<SwaggerResponse<DcatCatalogRecordInput>> {
        let url_ = this.baseUrl + "/api/DcatCatalogInput/records";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPostRecordsByBody(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPostRecordsByBody(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<DcatCatalogRecordInput>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<DcatCatalogRecordInput>>;
        }));
    }

    protected processPostRecordsByBody(response: HttpResponseBase): Observable<SwaggerResponse<DcatCatalogRecordInput>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DcatCatalogRecordInput.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<DcatCatalogRecordInput>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Updates an existing Dcat CatalogRecordInput based on the body content.
     * @param body (optional) The Dcat CatalogRecordInput to be modified, which is transferred via body content in json format.
     * @return No Content
     */
    putRecordsByBody(body: DcatCatalogRecordInput | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/DcatCatalogInput/records";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPutRecordsByBody(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutRecordsByBody(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPutRecordsByBody(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * List all Dcat Catalogs filtered by user.
     * @return OK
     */
    getUser(): Observable<SwaggerResponse<DcatCatalog[]>> {
        let url_ = this.baseUrl + "/api/DcatCatalogInput/user";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetUser(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetUser(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<DcatCatalog[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<DcatCatalog[]>>;
        }));
    }

    protected processGetUser(response: HttpResponseBase): Observable<SwaggerResponse<DcatCatalog[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DcatCatalog.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<DcatCatalog[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * List all Themes from Dcat Catalog.
     * @param id The Dcat Catalog id
     * @return OK
     */
    getThemesById(id: string): Observable<SwaggerResponse<DcatVocabularyEntry[]>> {
        let url_ = this.baseUrl + "/api/DcatCatalogInput/{id}/themes";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetThemesById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetThemesById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<DcatVocabularyEntry[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<DcatVocabularyEntry[]>>;
        }));
    }

    protected processGetThemesById(response: HttpResponseBase): Observable<SwaggerResponse<DcatVocabularyEntry[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DcatVocabularyEntry.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<DcatVocabularyEntry[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Returns the Dcat CatalogRecordInput with the corresponding Dcat CatalogRecordInput.PrimaryTopic.ResouceId.
     * @param resourceId The CatalogRecordInput.PrimaryTopic.ResouceId of the Dcat CatalogRecordInput to be returned.
     * @return OK
     */
    getRecordsByResourceByResourceId(resourceId: string): Observable<SwaggerResponse<DcatCatalogRecordInput[]>> {
        let url_ = this.baseUrl + "/api/DcatCatalogInput/records/byResource/{resourceId}";
        if (resourceId === undefined || resourceId === null)
            throw new globalThis.Error("The parameter 'resourceId' must be defined.");
        url_ = url_.replace("{resourceId}", encodeURIComponent("" + resourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetRecordsByResourceByResourceId(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetRecordsByResourceByResourceId(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<DcatCatalogRecordInput[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<DcatCatalogRecordInput[]>>;
        }));
    }

    protected processGetRecordsByResourceByResourceId(response: HttpResponseBase): Observable<SwaggerResponse<DcatCatalogRecordInput[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DcatCatalogRecordInput.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<DcatCatalogRecordInput[]>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable({
    providedIn: 'root'
})
export class DcatCatalogsClient extends Extensions.ApiClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(BfsIopAdminApiClientSupport) configuration: BfsIopAdminApiClientSupport, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(IOP_ADMIN_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets a DCAT catalog by id.
     * @param id The DCAT catalog id.
     * @return OK
     */
    getById(id: string): Observable<SwaggerResponse<DcatCatalogModel>> {
        let url_ = this.baseUrl + "/api/DcatCatalogs/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<DcatCatalogModel>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<DcatCatalogModel>>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<SwaggerResponse<DcatCatalogModel>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DcatCatalogModel.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<DcatCatalogModel>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable({
    providedIn: 'root'
})
export class FilterConfigurationsClient extends Extensions.ApiClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(BfsIopAdminApiClientSupport) configuration: BfsIopAdminApiClientSupport, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(IOP_ADMIN_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Returns the Filter Configuration for the given object.
     * @return OK
     */
    getById(id: string): Observable<SwaggerResponse<FilterConfigurationModel>> {
        let url_ = this.baseUrl + "/api/FilterConfigurations/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FilterConfigurationModel>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FilterConfigurationModel>>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<SwaggerResponse<FilterConfigurationModel>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FilterConfigurationModel.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No Content", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FilterConfigurationModel>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable({
    providedIn: 'root'
})
export class LindasClient extends Extensions.ApiClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(BfsIopAdminApiClientSupport) configuration: BfsIopAdminApiClientSupport, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(IOP_ADMIN_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets a LINDAS RDF download URL for the requested resource.
     * @param version (optional) 
     * @return OK
     */
    getRdfLinkByTypeAndIdentifierAndVersion(type: LindasResourceType, identifier: string, version: string | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/Lindas/rdf-link?";
        if (type === undefined || type === null)
            throw new globalThis.Error("The parameter 'type' must be defined and cannot be null.");
        else
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (identifier === undefined || identifier === null)
            throw new globalThis.Error("The parameter 'identifier' must be defined and cannot be null.");
        else
            url_ += "identifier=" + encodeURIComponent("" + identifier) + "&";
        if (version === null)
            throw new globalThis.Error("The parameter 'version' cannot be null.");
        else if (version !== undefined)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetRdfLinkByTypeAndIdentifierAndVersion(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetRdfLinkByTypeAndIdentifierAndVersion(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processGetRdfLinkByTypeAndIdentifierAndVersion(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Gets the LINDAS URI for the requested resource when it is available on ld.admin.ch.
     * @param version (optional) 
     * @return OK
     */
    getLdUriByTypeAndIdentifierAndVersion(type: LindasResourceType, identifier: string, version: string | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/Lindas/ld-uri?";
        if (type === undefined || type === null)
            throw new globalThis.Error("The parameter 'type' must be defined and cannot be null.");
        else
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (identifier === undefined || identifier === null)
            throw new globalThis.Error("The parameter 'identifier' must be defined and cannot be null.");
        else
            url_ += "identifier=" + encodeURIComponent("" + identifier) + "&";
        if (version === null)
            throw new globalThis.Error("The parameter 'version' cannot be null.");
        else if (version !== undefined)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetLdUriByTypeAndIdentifierAndVersion(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetLdUriByTypeAndIdentifierAndVersion(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processGetLdUriByTypeAndIdentifierAndVersion(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable({
    providedIn: 'root'
})
export class MappingTablesClient extends Extensions.ApiClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(BfsIopAdminApiClientSupport) configuration: BfsIopAdminApiClientSupport, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(IOP_ADMIN_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets the mapping table with the specific id.
     * @return OK
     */
    getById(id: string): Observable<SwaggerResponse<MappingTableModel>> {
        let url_ = this.baseUrl + "/api/MappingTables/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<MappingTableModel>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<MappingTableModel>>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<SwaggerResponse<MappingTableModel>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MappingTableModel.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<MappingTableModel>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Updates an existing mapping table with the specified id.
     * @param body (optional) 
     * @return No Content
     */
    putByIdAndBody(id: string, body: MappingTableInputModel | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/MappingTables/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPutByIdAndBody(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutByIdAndBody(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPutByIdAndBody(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Deletes an existing mapping table with the specified id.
     * @return No Content
     */
    deleteById(id: string): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/MappingTables/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processDeleteById(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Gets mapping tables matching the given filters.
     * @param mappingTableIdentifier (optional) 
     * @param publisherIdentifier (optional) 
     * @param version (optional) 
     * @param codeSystemUri (optional) 
     * @param publicationLevel (optional) 
     * @param registrationStatus (optional) 
     * @param page (optional) Page number.
     * @param pageSize (optional) Max number of results per page.
     * @return OK
     */
    getByMappingTableIdentifierAndPublisherIdentifierAndVersionAndCodeSystemUriAndPublicationLevelAndRegistrationStatusAndPageAndPageSize(mappingTableIdentifier: string | undefined, publisherIdentifier: string | undefined, version: string | undefined, codeSystemUri: string | undefined, publicationLevel: PublicationLevel | undefined, registrationStatus: RegistrationStatus | undefined, page: number | undefined, pageSize: number | undefined): Observable<SwaggerResponse<MappingTableModel[]>> {
        let url_ = this.baseUrl + "/api/MappingTables?";
        if (mappingTableIdentifier === null)
            throw new globalThis.Error("The parameter 'mappingTableIdentifier' cannot be null.");
        else if (mappingTableIdentifier !== undefined)
            url_ += "mappingTableIdentifier=" + encodeURIComponent("" + mappingTableIdentifier) + "&";
        if (publisherIdentifier === null)
            throw new globalThis.Error("The parameter 'publisherIdentifier' cannot be null.");
        else if (publisherIdentifier !== undefined)
            url_ += "publisherIdentifier=" + encodeURIComponent("" + publisherIdentifier) + "&";
        if (version === null)
            throw new globalThis.Error("The parameter 'version' cannot be null.");
        else if (version !== undefined)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        if (codeSystemUri === null)
            throw new globalThis.Error("The parameter 'codeSystemUri' cannot be null.");
        else if (codeSystemUri !== undefined)
            url_ += "codeSystemUri=" + encodeURIComponent("" + codeSystemUri) + "&";
        if (publicationLevel === null)
            throw new globalThis.Error("The parameter 'publicationLevel' cannot be null.");
        else if (publicationLevel !== undefined)
            url_ += "publicationLevel=" + encodeURIComponent("" + publicationLevel) + "&";
        if (registrationStatus === null)
            throw new globalThis.Error("The parameter 'registrationStatus' cannot be null.");
        else if (registrationStatus !== undefined)
            url_ += "registrationStatus=" + encodeURIComponent("" + registrationStatus) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetByMappingTableIdentifierAndPublisherIdentifierAndVersionAndCodeSystemUriAndPublicationLevelAndRegistrationStatusAndPageAndPageSize(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetByMappingTableIdentifierAndPublisherIdentifierAndVersionAndCodeSystemUriAndPublicationLevelAndRegistrationStatusAndPageAndPageSize(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<MappingTableModel[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<MappingTableModel[]>>;
        }));
    }

    protected processGetByMappingTableIdentifierAndPublisherIdentifierAndVersionAndCodeSystemUriAndPublicationLevelAndRegistrationStatusAndPageAndPageSize(response: HttpResponseBase): Observable<SwaggerResponse<MappingTableModel[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MappingTableModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<MappingTableModel[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Creates a new mapping table.
     * @param body (optional) 
     * @return Created
     */
    postByBody(body: MappingTableInputModel | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/MappingTables";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPostByBody(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPostByBody(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processPostByBody(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return _observableOf(new SwaggerResponse(status, _headers, result201));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Gets the mapping relation with the specified ids.
     * @param id Mapping table id
     * @param relationId Mapping relation id
     * @return OK
     */
    getRelationsByIdAndRelationId(id: string, relationId: string): Observable<SwaggerResponse<MappingRelationModel>> {
        let url_ = this.baseUrl + "/api/MappingTables/{id}/relations/{relationId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (relationId === undefined || relationId === null)
            throw new globalThis.Error("The parameter 'relationId' must be defined.");
        url_ = url_.replace("{relationId}", encodeURIComponent("" + relationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetRelationsByIdAndRelationId(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetRelationsByIdAndRelationId(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<MappingRelationModel>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<MappingRelationModel>>;
        }));
    }

    protected processGetRelationsByIdAndRelationId(response: HttpResponseBase): Observable<SwaggerResponse<MappingRelationModel>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MappingRelationModel.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<MappingRelationModel>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Updates an existing mapping relation.
     * @param id Mapping table id
     * @param relationId Mapping relation id
     * @param body (optional) 
     * @return No Content
     */
    putRelationsByIdAndRelationIdAndBody(id: string, relationId: string, body: MappingRelationInputModel | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/MappingTables/{id}/relations/{relationId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (relationId === undefined || relationId === null)
            throw new globalThis.Error("The parameter 'relationId' must be defined.");
        url_ = url_.replace("{relationId}", encodeURIComponent("" + relationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPutRelationsByIdAndRelationIdAndBody(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutRelationsByIdAndRelationIdAndBody(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPutRelationsByIdAndRelationIdAndBody(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Deletes the mapping relation with the specified ids.
     * @param id Mapping table id
     * @param relationId Mapping relation id
     * @return No Content
     */
    deleteRelationsByIdAndRelationId(id: string, relationId: string): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/MappingTables/{id}/relations/{relationId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (relationId === undefined || relationId === null)
            throw new globalThis.Error("The parameter 'relationId' must be defined.");
        url_ = url_.replace("{relationId}", encodeURIComponent("" + relationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteRelationsByIdAndRelationId(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteRelationsByIdAndRelationId(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processDeleteRelationsByIdAndRelationId(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Gets all the relations from a specified mapping table.
     * @param id Mapping table id
     * @param page (optional) Page number.
     * @param pageSize (optional) Max number of results per page.
     * @return OK
     */
    getRelationsByIdAndPageAndPageSize(id: string, page: number | undefined, pageSize: number | undefined): Observable<SwaggerResponse<MappingRelationModel[]>> {
        let url_ = this.baseUrl + "/api/MappingTables/{id}/relations?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetRelationsByIdAndPageAndPageSize(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetRelationsByIdAndPageAndPageSize(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<MappingRelationModel[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<MappingRelationModel[]>>;
        }));
    }

    protected processGetRelationsByIdAndPageAndPageSize(response: HttpResponseBase): Observable<SwaggerResponse<MappingRelationModel[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MappingRelationModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<MappingRelationModel[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Creates new mapping relations and adds them to a specified mapping table.
     * @param id Mapping table id
     * @param body (optional) 
     * @return Created
     */
    postRelationsByIdAndBody(id: string, body: MappingRelationInputModel[] | undefined): Observable<SwaggerResponse<string[]>> {
        let url_ = this.baseUrl + "/api/MappingTables/{id}/relations";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPostRelationsByIdAndBody(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPostRelationsByIdAndBody(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string[]>>;
        }));
    }

    protected processPostRelationsByIdAndBody(response: HttpResponseBase): Observable<SwaggerResponse<string[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData201)) {
                result201 = [] as any;
                for (let item of resultData201)
                    result201!.push(item);
            }
            else {
                result201 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result201));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Deletes all mapping relations from the mapping table with the specified id.
     * @return No Content
     */
    deleteRelationsById(id: string): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/MappingTables/{id}/relations";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteRelationsById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteRelationsById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processDeleteRelationsById(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Gets the publication level of the concept.
     * @return OK
     */
    getPublicationLevelById(id: string): Observable<SwaggerResponse<PublicationLevelInfoModel>> {
        let url_ = this.baseUrl + "/api/MappingTables/{id}/publicationLevel";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetPublicationLevelById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetPublicationLevelById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<PublicationLevelInfoModel>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<PublicationLevelInfoModel>>;
        }));
    }

    protected processGetPublicationLevelById(response: HttpResponseBase): Observable<SwaggerResponse<PublicationLevelInfoModel>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PublicationLevelInfoModel.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<PublicationLevelInfoModel>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Gets the registration status of the concept.
     * @return OK
     */
    getRegistrationStatusById(id: string): Observable<SwaggerResponse<RegistrationStatusInfoModel>> {
        let url_ = this.baseUrl + "/api/MappingTables/{id}/registrationStatus";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetRegistrationStatusById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetRegistrationStatusById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<RegistrationStatusInfoModel>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<RegistrationStatusInfoModel>>;
        }));
    }

    protected processGetRegistrationStatusById(response: HttpResponseBase): Observable<SwaggerResponse<RegistrationStatusInfoModel>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistrationStatusInfoModel.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<RegistrationStatusInfoModel>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Checks whether the identifier with version is in use.
     * @return OK
     */
    getIdentifierExistsByIdentifierAndVersion(identifier: string, version: string): Observable<SwaggerResponse<IdentifierVersionExistsResult>> {
        let url_ = this.baseUrl + "/api/MappingTables/identifier/{identifier}/{version}/exists";
        if (identifier === undefined || identifier === null)
            throw new globalThis.Error("The parameter 'identifier' must be defined.");
        url_ = url_.replace("{identifier}", encodeURIComponent("" + identifier));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetIdentifierExistsByIdentifierAndVersion(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetIdentifierExistsByIdentifierAndVersion(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<IdentifierVersionExistsResult>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<IdentifierVersionExistsResult>>;
        }));
    }

    protected processGetIdentifierExistsByIdentifierAndVersion(response: HttpResponseBase): Observable<SwaggerResponse<IdentifierVersionExistsResult>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IdentifierVersionExistsResult.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<IdentifierVersionExistsResult>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Sets the publication level proposal of the mapping table with the specified id.
     * @param proposal (optional) 
     * @return No Content
     */
    putPublicationLevelProposalByIdAndProposal(id: string, proposal: PublicationLevel | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/MappingTables/{id}/publication-level-proposal?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (proposal === null)
            throw new globalThis.Error("The parameter 'proposal' cannot be null.");
        else if (proposal !== undefined)
            url_ += "proposal=" + encodeURIComponent("" + proposal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPutPublicationLevelProposalByIdAndProposal(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutPublicationLevelProposalByIdAndProposal(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPutPublicationLevelProposalByIdAndProposal(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Sets the publication level of the mappingTable with the specified id.
     * @return No Content
     */
    putPublicationLevelByIdAndLevel(id: string, level: PublicationLevel): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/MappingTables/{id}/publication-level?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (level === undefined || level === null)
            throw new globalThis.Error("The parameter 'level' must be defined and cannot be null.");
        else
            url_ += "level=" + encodeURIComponent("" + level) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPutPublicationLevelByIdAndLevel(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutPublicationLevelByIdAndLevel(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPutPublicationLevelByIdAndLevel(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Sets the registration status proposal of the mapping table with the specified id.
     * @param proposal (optional) 
     * @return No Content
     */
    putRegistrationStatusProposalByIdAndProposal(id: string, proposal: RegistrationStatus | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/MappingTables/{id}/registration-status-proposal?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (proposal === null)
            throw new globalThis.Error("The parameter 'proposal' cannot be null.");
        else if (proposal !== undefined)
            url_ += "proposal=" + encodeURIComponent("" + proposal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPutRegistrationStatusProposalByIdAndProposal(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutRegistrationStatusProposalByIdAndProposal(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPutRegistrationStatusProposalByIdAndProposal(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Sets the registration status of the mapping table with the specified id.
     * @return No Content
     */
    putRegistrationStatusByIdAndStatus(id: string, status: RegistrationStatus): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/MappingTables/{id}/registration-status?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (status === undefined || status === null)
            throw new globalThis.Error("The parameter 'status' must be defined and cannot be null.");
        else
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPutRegistrationStatusByIdAndStatus(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutRegistrationStatusByIdAndStatus(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPutRegistrationStatusByIdAndStatus(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * @param file (optional) 
     * @return No Content
     */
    postRelationsImportsByIdAndFormatAndBody(id: string, format: MappingRelationsDataFormat, file: FileParameter | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/MappingTables/{id}/relations/imports/{format}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (format === undefined || format === null)
            throw new globalThis.Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPostRelationsImportsByIdAndFormatAndBody(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPostRelationsImportsByIdAndFormatAndBody(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPostRelationsImportsByIdAndFormatAndBody(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * @return OK
     */
    getRelationsExportsByIdAndFormat(id: string, format: MappingRelationsDataFormat): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/MappingTables/{id}/relations/exports/{format}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (format === undefined || format === null)
            throw new globalThis.Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetRelationsExportsByIdAndFormat(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetRelationsExportsByIdAndFormat(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGetRelationsExportsByIdAndFormat(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Create a new version based on a existing mapping table
     * @param id The previous mapping table id.
     * @param body (optional) The new version information.
     * @return Created
     */
    postVersionsByIdAndBody(id: string, body: MappingTableInputModel | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/MappingTables/{id}/versions";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPostVersionsByIdAndBody(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPostVersionsByIdAndBody(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPostVersionsByIdAndBody(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * @return OK
     */
    getExportByIdAndFormat(id: string, format: DataFormat): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/MappingTables/{id}/export/{format}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (format === undefined || format === null)
            throw new globalThis.Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetExportByIdAndFormat(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetExportByIdAndFormat(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGetExportByIdAndFormat(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable({
    providedIn: 'root'
})
export class MediaClient extends Extensions.ApiClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(BfsIopAdminApiClientSupport) configuration: BfsIopAdminApiClientSupport, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(IOP_ADMIN_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getByUrl(url: string): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/Media/{url}";
        if (url === undefined || url === null)
            throw new globalThis.Error("The parameter 'url' must be defined.");
        url_ = url_.replace("{url}", encodeURIComponent("" + url));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetByUrl(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetByUrl(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGetByUrl(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable({
    providedIn: 'root'
})
export class MetasearchClient extends Extensions.ApiClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(BfsIopAdminApiClientSupport) configuration: BfsIopAdminApiClientSupport, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(IOP_ADMIN_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Search the geocat catalog
     * @param language The language to use for the search
     * @param query (optional) The search query
     * @param page The number of the result page to return
     * @param pageSize The size of each result page
     * @return OK
     */
    getGeocatSearchByLanguageAndQueryAndPageAndPageSize(language: string, query: string | undefined, page: number, pageSize: number): Observable<SwaggerResponse<MetaSearchResultItem[]>> {
        let url_ = this.baseUrl + "/api/Metasearch/geocat/search?";
        if (language === undefined || language === null)
            throw new globalThis.Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetGeocatSearchByLanguageAndQueryAndPageAndPageSize(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetGeocatSearchByLanguageAndQueryAndPageAndPageSize(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<MetaSearchResultItem[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<MetaSearchResultItem[]>>;
        }));
    }

    protected processGetGeocatSearchByLanguageAndQueryAndPageAndPageSize(response: HttpResponseBase): Observable<SwaggerResponse<MetaSearchResultItem[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MetaSearchResultItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<MetaSearchResultItem[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Search the open data catalog
     * @param language The language to use for the search
     * @param query (optional) The search query
     * @param page The number of the result page to return
     * @param pageSize The size of each result page
     * @return OK
     */
    getOpendataSearchByLanguageAndQueryAndPageAndPageSize(language: string, query: string | undefined, page: number, pageSize: number): Observable<SwaggerResponse<MetaSearchResultItem[]>> {
        let url_ = this.baseUrl + "/api/Metasearch/opendata/search?";
        if (language === undefined || language === null)
            throw new globalThis.Error("The parameter 'language' must be defined and cannot be null.");
        else
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (page === undefined || page === null)
            throw new globalThis.Error("The parameter 'page' must be defined and cannot be null.");
        else
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetOpendataSearchByLanguageAndQueryAndPageAndPageSize(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetOpendataSearchByLanguageAndQueryAndPageAndPageSize(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<MetaSearchResultItem[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<MetaSearchResultItem[]>>;
        }));
    }

    protected processGetOpendataSearchByLanguageAndQueryAndPageAndPageSize(response: HttpResponseBase): Observable<SwaggerResponse<MetaSearchResultItem[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MetaSearchResultItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<MetaSearchResultItem[]>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable({
    providedIn: 'root'
})
export class PersonsClient extends Extensions.ApiClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(BfsIopAdminApiClientSupport) configuration: BfsIopAdminApiClientSupport, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(IOP_ADMIN_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Searches for persons in the iop persons list
     * @param query the search query
     * @return OK
     */
    getByQuery(query: string): Observable<SwaggerResponse<ActiveDirectoryUser[]>> {
        let url_ = this.baseUrl + "/api/Persons/{query}";
        if (query === undefined || query === null)
            throw new globalThis.Error("The parameter 'query' must be defined.");
        url_ = url_.replace("{query}", encodeURIComponent("" + query));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetByQuery(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetByQuery(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<ActiveDirectoryUser[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<ActiveDirectoryUser[]>>;
        }));
    }

    protected processGetByQuery(response: HttpResponseBase): Observable<SwaggerResponse<ActiveDirectoryUser[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActiveDirectoryUser.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<ActiveDirectoryUser[]>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable({
    providedIn: 'root'
})
export class PublicServiceInputClient extends Extensions.ApiClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(BfsIopAdminApiClientSupport) configuration: BfsIopAdminApiClientSupport, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(IOP_ADMIN_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Deletes the entity
     * @return No Content
     */
    deleteById(id: string): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/PublicServiceInput/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processDeleteById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processDeleteById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processDeleteById(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Updates the entity
     * @param body (optional) 
     * @return No Content
     */
    putByBody(body: PublicServiceInput | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/PublicServiceInput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPutByBody(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutByBody(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPutByBody(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Add a new public service
     * @param body (optional) The new public service
     * @return Created
     */
    postByBody(body: PublicServiceInput | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/PublicServiceInput";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPostByBody(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPostByBody(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPostByBody(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Checks whether the identifier is in use
     * @return OK
     */
    getIdentifierExistsByIdentifier(identifier: string): Observable<SwaggerResponse<boolean>> {
        let url_ = this.baseUrl + "/api/PublicServiceInput/identifier/{identifier}/exists";
        if (identifier === undefined || identifier === null)
            throw new globalThis.Error("The parameter 'identifier' must be defined.");
        url_ = url_.replace("{identifier}", encodeURIComponent("" + identifier));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetIdentifierExistsByIdentifier(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetIdentifierExistsByIdentifier(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<boolean>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<boolean>>;
        }));
    }

    protected processGetIdentifierExistsByIdentifier(response: HttpResponseBase): Observable<SwaggerResponse<boolean>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<boolean>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Updates the registration proposal of a public service.
     * @param id The public service id.
     * @param proposal (optional) The new registration proposal or empty to revert an existing proposal.
     * @return No Content
     */
    putRegistrationStatusProposalByIdAndProposal(id: string, proposal: RegistrationStatus | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/PublicServiceInput/{id}/registrationStatusProposal?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (proposal === null)
            throw new globalThis.Error("The parameter 'proposal' cannot be null.");
        else if (proposal !== undefined)
            url_ += "proposal=" + encodeURIComponent("" + proposal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPutRegistrationStatusProposalByIdAndProposal(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutRegistrationStatusProposalByIdAndProposal(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPutRegistrationStatusProposalByIdAndProposal(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Updates the registration status of a public service.
     * @param id The public service id.
     * @param status (optional) The new registration status.
     * @return No Content
     */
    putRegistrationStatusByIdAndStatus(id: string, status: RegistrationStatus | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/PublicServiceInput/{id}/registrationStatus?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPutRegistrationStatusByIdAndStatus(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutRegistrationStatusByIdAndStatus(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPutRegistrationStatusByIdAndStatus(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Updates the publication level proposal of a public service.
     * @param id The public service id.
     * @param proposal (optional) The new publication level proposal or an empty value to reset an existing one.
     * @return No Content
     */
    putPublicationLevelProposalByIdAndProposal(id: string, proposal: PublicationLevel | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/PublicServiceInput/{id}/publicationLevelProposal?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (proposal === null)
            throw new globalThis.Error("The parameter 'proposal' cannot be null.");
        else if (proposal !== undefined)
            url_ += "proposal=" + encodeURIComponent("" + proposal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPutPublicationLevelProposalByIdAndProposal(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutPublicationLevelProposalByIdAndProposal(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPutPublicationLevelProposalByIdAndProposal(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Updates the publication level of a public service.
     * @param id The public service id.
     * @param level (optional) The new publication level.
     * @return No Content
     */
    putPublicationLevelByIdAndLevel(id: string, level: PublicationLevel | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/PublicServiceInput/{id}/publicationLevel?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (level === null)
            throw new globalThis.Error("The parameter 'level' cannot be null.");
        else if (level !== undefined)
            url_ += "level=" + encodeURIComponent("" + level) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPutPublicationLevelByIdAndLevel(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPutPublicationLevelByIdAndLevel(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processPutPublicationLevelByIdAndLevel(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Returns datasets describing the public service.
     * @param id The public service id.
     * @return OK
     */
    getIsDescribedAtById(id: string): Observable<SwaggerResponse<Dataset[]>> {
        let url_ = this.baseUrl + "/api/PublicServiceInput/{id}/isDescribedAt";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetIsDescribedAtById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetIsDescribedAtById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<Dataset[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<Dataset[]>>;
        }));
    }

    protected processGetIsDescribedAtById(response: HttpResponseBase): Observable<SwaggerResponse<Dataset[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Dataset.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<Dataset[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Returns related public services.
     * @param id The public service id.
     * @return OK
     */
    getRelationById(id: string): Observable<SwaggerResponse<PublicServiceView[]>> {
        let url_ = this.baseUrl + "/api/PublicServiceInput/{id}/relation";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetRelationById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetRelationById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<PublicServiceView[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<PublicServiceView[]>>;
        }));
    }

    protected processGetRelationById(response: HttpResponseBase): Observable<SwaggerResponse<PublicServiceView[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PublicServiceView.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<PublicServiceView[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Returns required public services.
     * @param id The public service id.
     * @return OK
     */
    getRequiresById(id: string): Observable<SwaggerResponse<PublicServiceView[]>> {
        let url_ = this.baseUrl + "/api/PublicServiceInput/{id}/requires";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetRequiresById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetRequiresById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<PublicServiceView[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<PublicServiceView[]>>;
        }));
    }

    protected processGetRequiresById(response: HttpResponseBase): Observable<SwaggerResponse<PublicServiceView[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PublicServiceView.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<PublicServiceView[]>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable({
    providedIn: 'root'
})
export class PublicServicesClient extends Extensions.ApiClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(BfsIopAdminApiClientSupport) configuration: BfsIopAdminApiClientSupport, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(IOP_ADMIN_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getById(id: string): Observable<SwaggerResponse<PublicServiceModel>> {
        let url_ = this.baseUrl + "/api/PublicServices/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<PublicServiceModel>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<PublicServiceModel>>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<SwaggerResponse<PublicServiceModel>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PublicServiceModel.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<PublicServiceModel>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Gets the public services matching the given filters.
     * @param publicServiceIdentifier (optional) 
     * @param publisherIdentifier (optional) 
     * @param publicationLevel (optional) 
     * @param registrationStatus (optional) 
     * @param page (optional) Page number.
     * @param pageSize (optional) Max number of results per page.
     * @return OK
     */
    getByPublicServiceIdentifierAndPublisherIdentifierAndPublicationLevelAndRegistrationStatusAndPageAndPageSize(publicServiceIdentifier: string | undefined, publisherIdentifier: string | undefined, publicationLevel: PublicationLevel | undefined, registrationStatus: RegistrationStatus | undefined, page: number | undefined, pageSize: number | undefined): Observable<SwaggerResponse<PublicServiceModel[]>> {
        let url_ = this.baseUrl + "/api/PublicServices?";
        if (publicServiceIdentifier === null)
            throw new globalThis.Error("The parameter 'publicServiceIdentifier' cannot be null.");
        else if (publicServiceIdentifier !== undefined)
            url_ += "publicServiceIdentifier=" + encodeURIComponent("" + publicServiceIdentifier) + "&";
        if (publisherIdentifier === null)
            throw new globalThis.Error("The parameter 'publisherIdentifier' cannot be null.");
        else if (publisherIdentifier !== undefined)
            url_ += "publisherIdentifier=" + encodeURIComponent("" + publisherIdentifier) + "&";
        if (publicationLevel === null)
            throw new globalThis.Error("The parameter 'publicationLevel' cannot be null.");
        else if (publicationLevel !== undefined)
            url_ += "publicationLevel=" + encodeURIComponent("" + publicationLevel) + "&";
        if (registrationStatus === null)
            throw new globalThis.Error("The parameter 'registrationStatus' cannot be null.");
        else if (registrationStatus !== undefined)
            url_ += "registrationStatus=" + encodeURIComponent("" + registrationStatus) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetByPublicServiceIdentifierAndPublisherIdentifierAndPublicationLevelAndRegistrationStatusAndPageAndPageSize(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetByPublicServiceIdentifierAndPublisherIdentifierAndPublicationLevelAndRegistrationStatusAndPageAndPageSize(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<PublicServiceModel[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<PublicServiceModel[]>>;
        }));
    }

    protected processGetByPublicServiceIdentifierAndPublisherIdentifierAndPublicationLevelAndRegistrationStatusAndPageAndPageSize(response: HttpResponseBase): Observable<SwaggerResponse<PublicServiceModel[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PublicServiceModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<PublicServiceModel[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Checks whether a channel with the given identifier exists.
     * @return OK
     */
    getChannelsIdentifierExistsByIdentifier(identifier: string): Observable<SwaggerResponse<boolean>> {
        let url_ = this.baseUrl + "/api/PublicServices/channels/identifier/{identifier}/exists";
        if (identifier === undefined || identifier === null)
            throw new globalThis.Error("The parameter 'identifier' must be defined.");
        url_ = url_.replace("{identifier}", encodeURIComponent("" + identifier));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetChannelsIdentifierExistsByIdentifier(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetChannelsIdentifierExistsByIdentifier(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<boolean>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<boolean>>;
        }));
    }

    protected processGetChannelsIdentifierExistsByIdentifier(response: HttpResponseBase): Observable<SwaggerResponse<boolean>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<boolean>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * @return OK
     */
    getExportByIdAndFormat(id: string, format: DataFormat): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/PublicServices/{id}/export/{format}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (format === undefined || format === null)
            throw new globalThis.Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetExportByIdAndFormat(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetExportByIdAndFormat(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGetExportByIdAndFormat(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable({
    providedIn: 'root'
})
export class PublicServiceViewClient extends Extensions.ApiClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(BfsIopAdminApiClientSupport) configuration: BfsIopAdminApiClientSupport, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(IOP_ADMIN_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets the public service view by id.
     * @return OK
     */
    getById(id: string): Observable<SwaggerResponse<PublicServiceView>> {
        let url_ = this.baseUrl + "/api/PublicServiceView/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<PublicServiceView>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<PublicServiceView>>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<SwaggerResponse<PublicServiceView>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PublicServiceView.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<PublicServiceView>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Gets the registration status of the public service.
     * @return OK
     */
    getRegistrationStatusById(id: string): Observable<SwaggerResponse<RegistrationStatusInfoModel>> {
        let url_ = this.baseUrl + "/api/PublicServiceView/{id}/registrationStatus";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetRegistrationStatusById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetRegistrationStatusById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<RegistrationStatusInfoModel>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<RegistrationStatusInfoModel>>;
        }));
    }

    protected processGetRegistrationStatusById(response: HttpResponseBase): Observable<SwaggerResponse<RegistrationStatusInfoModel>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistrationStatusInfoModel.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<RegistrationStatusInfoModel>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Gets the publication level of the public service.
     * @return OK
     */
    getPublicationLevelById(id: string): Observable<SwaggerResponse<PublicationLevelInfoModel>> {
        let url_ = this.baseUrl + "/api/PublicServiceView/{id}/publicationLevel";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetPublicationLevelById(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetPublicationLevelById(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<PublicationLevelInfoModel>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<PublicationLevelInfoModel>>;
        }));
    }

    protected processGetPublicationLevelById(response: HttpResponseBase): Observable<SwaggerResponse<PublicationLevelInfoModel>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PublicationLevelInfoModel.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<PublicationLevelInfoModel>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable({
    providedIn: 'root'
})
export class UsersClient extends Extensions.ApiClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(BfsIopAdminApiClientSupport) configuration: BfsIopAdminApiClientSupport, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(IOP_ADMIN_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieves the information about the current logged user.
     * @return OK
     */
    getUserInfo(): Observable<SwaggerResponse<UserModel>> {
        let url_ = this.baseUrl + "/api/Users/user-info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetUserInfo(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetUserInfo(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<UserModel>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<UserModel>>;
        }));
    }

    protected processGetUserInfo(response: HttpResponseBase): Observable<SwaggerResponse<UserModel>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserModel.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<UserModel>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable({
    providedIn: 'root'
})
export class VocabularyClient extends Extensions.ApiClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(BfsIopAdminApiClientSupport) configuration: BfsIopAdminApiClientSupport, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(IOP_ADMIN_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieves all vocabulary entries of the specified vocabulary
     * @return OK
     */
    getByIdentifier(identifier: string): Observable<SwaggerResponse<VocabularyEntry[]>> {
        let url_ = this.baseUrl + "/api/Vocabulary/{identifier}";
        if (identifier === undefined || identifier === null)
            throw new globalThis.Error("The parameter 'identifier' must be defined.");
        url_ = url_.replace("{identifier}", encodeURIComponent("" + identifier));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetByIdentifier(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetByIdentifier(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<VocabularyEntry[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<VocabularyEntry[]>>;
        }));
    }

    protected processGetByIdentifier(response: HttpResponseBase): Observable<SwaggerResponse<VocabularyEntry[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VocabularyEntry.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<VocabularyEntry[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Returns all the vocabulary configurations.
     * @return OK
     */
    getConfigurations(): Observable<SwaggerResponse<VocabularyConfigModel[]>> {
        let url_ = this.baseUrl + "/api/Vocabulary/configurations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetConfigurations(r as any));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetConfigurations(r as any));
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<VocabularyConfigModel[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<VocabularyConfigModel[]>>;
        }));
    }

    protected processGetConfigurations(response: HttpResponseBase): Observable<SwaggerResponse<VocabularyConfigModel[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VocabularyConfigModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<VocabularyConfigModel[]>>(new SwaggerResponse(status, _headers, null as any));
    }
}

export class ActiveDirectoryUser implements IActiveDirectoryUser {
    displayName?: string | undefined;
    email?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    orgUnitName?: string | undefined;

    constructor(data?: IActiveDirectoryUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.email = _data["email"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.orgUnitName = _data["orgUnitName"];
        }
    }

    static fromJS(data: any): ActiveDirectoryUser {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveDirectoryUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["orgUnitName"] = this.orgUnitName;
        return data;
    }
}

export interface IActiveDirectoryUser {
    displayName?: string | undefined;
    email?: string | undefined;
    firstname?: string | undefined;
    lastname?: string | undefined;
    orgUnitName?: string | undefined;
}

export class Agent implements IAgent {
    classification?: VocabularyEntry | undefined;
    contactPoint?: VCardModel | undefined;
    description?: MultiLanguageModel | undefined;
    homePage?: string | undefined;
    id?: string;
    identifier?: string | undefined;
    images?: ResourceModel[] | undefined;
    name?: MultiLanguage | undefined;
    prefLabel?: MultiLanguage | undefined;
    spatial?: string[] | undefined;
    spatialCH?: VocabularyEntry[] | undefined;
    subAgents?: IdNameModel[] | undefined;
    subAgentOf?: IdNameModel[] | undefined;
    system?: SystemInfoModel | undefined;
    uid?: string | undefined;

    constructor(data?: IAgent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.classification = _data["classification"] ? VocabularyEntry.fromJS(_data["classification"]) : undefined as any;
            this.contactPoint = _data["contactPoint"] ? VCardModel.fromJS(_data["contactPoint"]) : undefined as any;
            this.description = _data["description"] ? MultiLanguageModel.fromJS(_data["description"]) : undefined as any;
            this.homePage = _data["homePage"];
            this.id = _data["id"];
            this.identifier = _data["identifier"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ResourceModel.fromJS(item));
            }
            this.name = _data["name"] ? MultiLanguage.fromJS(_data["name"]) : undefined as any;
            this.prefLabel = _data["prefLabel"] ? MultiLanguage.fromJS(_data["prefLabel"]) : undefined as any;
            if (Array.isArray(_data["spatial"])) {
                this.spatial = [] as any;
                for (let item of _data["spatial"])
                    this.spatial!.push(item);
            }
            if (Array.isArray(_data["spatialCH"])) {
                this.spatialCH = [] as any;
                for (let item of _data["spatialCH"])
                    this.spatialCH!.push(VocabularyEntry.fromJS(item));
            }
            if (Array.isArray(_data["subAgents"])) {
                this.subAgents = [] as any;
                for (let item of _data["subAgents"])
                    this.subAgents!.push(IdNameModel.fromJS(item));
            }
            if (Array.isArray(_data["subAgentOf"])) {
                this.subAgentOf = [] as any;
                for (let item of _data["subAgentOf"])
                    this.subAgentOf!.push(IdNameModel.fromJS(item));
            }
            this.system = _data["system"] ? SystemInfoModel.fromJS(_data["system"]) : undefined as any;
            this.uid = _data["uid"];
        }
    }

    static fromJS(data: any): Agent {
        data = typeof data === 'object' ? data : {};
        let result = new Agent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["classification"] = this.classification ? this.classification.toJSON() : undefined as any;
        data["contactPoint"] = this.contactPoint ? this.contactPoint.toJSON() : undefined as any;
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        data["homePage"] = this.homePage;
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item ? item.toJSON() : undefined as any);
        }
        data["name"] = this.name ? this.name.toJSON() : undefined as any;
        data["prefLabel"] = this.prefLabel ? this.prefLabel.toJSON() : undefined as any;
        if (Array.isArray(this.spatial)) {
            data["spatial"] = [];
            for (let item of this.spatial)
                data["spatial"].push(item);
        }
        if (Array.isArray(this.spatialCH)) {
            data["spatialCH"] = [];
            for (let item of this.spatialCH)
                data["spatialCH"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.subAgents)) {
            data["subAgents"] = [];
            for (let item of this.subAgents)
                data["subAgents"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.subAgentOf)) {
            data["subAgentOf"] = [];
            for (let item of this.subAgentOf)
                data["subAgentOf"].push(item ? item.toJSON() : undefined as any);
        }
        data["system"] = this.system ? this.system.toJSON() : undefined as any;
        data["uid"] = this.uid;
        return data;
    }
}

export interface IAgent {
    classification?: VocabularyEntry | undefined;
    contactPoint?: VCardModel | undefined;
    description?: MultiLanguageModel | undefined;
    homePage?: string | undefined;
    id?: string;
    identifier?: string | undefined;
    images?: ResourceModel[] | undefined;
    name?: MultiLanguage | undefined;
    prefLabel?: MultiLanguage | undefined;
    spatial?: string[] | undefined;
    spatialCH?: VocabularyEntry[] | undefined;
    subAgents?: IdNameModel[] | undefined;
    subAgentOf?: IdNameModel[] | undefined;
    system?: SystemInfoModel | undefined;
    uid?: string | undefined;
}

export class AgentModel implements IAgentModel {
    classification?: VocabularyEntryModel | undefined;
    contactPoint?: VCardModel | undefined;
    description?: MultiLanguageModel | undefined;
    homePage?: string | undefined;
    id?: string;
    identifier!: string | undefined;
    images?: ResourceModel[] | undefined;
    name!: MultiLanguageModel | undefined;
    prefLabel!: MultiLanguageModel | undefined;
    system!: SystemInfoModel | undefined;
    spatial?: string[] | undefined;
    spatialCH?: VocabularyEntryModel[] | undefined;
    subAgents?: IdNameModel[] | undefined;
    uid?: string | undefined;

    constructor(data?: IAgentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.classification = _data["classification"] ? VocabularyEntryModel.fromJS(_data["classification"]) : undefined as any;
            this.contactPoint = _data["contactPoint"] ? VCardModel.fromJS(_data["contactPoint"]) : undefined as any;
            this.description = _data["description"] ? MultiLanguageModel.fromJS(_data["description"]) : undefined as any;
            this.homePage = _data["homePage"];
            this.id = _data["id"];
            this.identifier = _data["identifier"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ResourceModel.fromJS(item));
            }
            this.name = _data["name"] ? MultiLanguageModel.fromJS(_data["name"]) : undefined as any;
            this.prefLabel = _data["prefLabel"] ? MultiLanguageModel.fromJS(_data["prefLabel"]) : undefined as any;
            this.system = _data["system"] ? SystemInfoModel.fromJS(_data["system"]) : undefined as any;
            if (Array.isArray(_data["spatial"])) {
                this.spatial = [] as any;
                for (let item of _data["spatial"])
                    this.spatial!.push(item);
            }
            if (Array.isArray(_data["spatialCH"])) {
                this.spatialCH = [] as any;
                for (let item of _data["spatialCH"])
                    this.spatialCH!.push(VocabularyEntryModel.fromJS(item));
            }
            if (Array.isArray(_data["subAgents"])) {
                this.subAgents = [] as any;
                for (let item of _data["subAgents"])
                    this.subAgents!.push(IdNameModel.fromJS(item));
            }
            this.uid = _data["uid"];
        }
    }

    static fromJS(data: any): AgentModel {
        data = typeof data === 'object' ? data : {};
        let result = new AgentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["classification"] = this.classification ? this.classification.toJSON() : undefined as any;
        data["contactPoint"] = this.contactPoint ? this.contactPoint.toJSON() : undefined as any;
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        data["homePage"] = this.homePage;
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item ? item.toJSON() : undefined as any);
        }
        data["name"] = this.name ? this.name.toJSON() : undefined as any;
        data["prefLabel"] = this.prefLabel ? this.prefLabel.toJSON() : undefined as any;
        data["system"] = this.system ? this.system.toJSON() : undefined as any;
        if (Array.isArray(this.spatial)) {
            data["spatial"] = [];
            for (let item of this.spatial)
                data["spatial"].push(item);
        }
        if (Array.isArray(this.spatialCH)) {
            data["spatialCH"] = [];
            for (let item of this.spatialCH)
                data["spatialCH"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.subAgents)) {
            data["subAgents"] = [];
            for (let item of this.subAgents)
                data["subAgents"].push(item ? item.toJSON() : undefined as any);
        }
        data["uid"] = this.uid;
        return data;
    }
}

export interface IAgentModel {
    classification?: VocabularyEntryModel | undefined;
    contactPoint?: VCardModel | undefined;
    description?: MultiLanguageModel | undefined;
    homePage?: string | undefined;
    id?: string;
    identifier: string | undefined;
    images?: ResourceModel[] | undefined;
    name: MultiLanguageModel | undefined;
    prefLabel: MultiLanguageModel | undefined;
    system: SystemInfoModel | undefined;
    spatial?: string[] | undefined;
    spatialCH?: VocabularyEntryModel[] | undefined;
    subAgents?: IdNameModel[] | undefined;
    uid?: string | undefined;
}

export class AgentStatisticsResult implements IAgentStatisticsResult {
    publisher!: AgentModel | undefined;
    types?: SearchResourceTypeSearchCountResultItem[] | undefined;

    constructor(data?: IAgentStatisticsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.publisher = _data["publisher"] ? AgentModel.fromJS(_data["publisher"]) : undefined as any;
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(SearchResourceTypeSearchCountResultItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AgentStatisticsResult {
        data = typeof data === 'object' ? data : {};
        let result = new AgentStatisticsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publisher"] = this.publisher ? this.publisher.toJSON() : undefined as any;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAgentStatisticsResult {
    publisher: AgentModel | undefined;
    types?: SearchResourceTypeSearchCountResultItem[] | undefined;
}

export enum AllowActionResourceType {
    Dataset = "Dataset",
    DataService = "DataService",
    DcatCatalogRecord = "DcatCatalogRecord",
    Concept = "Concept",
    PublicService = "PublicService",
    MappingTable = "MappingTable",
}

export class AllowActionResult implements IAllowActionResult {
    actionType?: AllowActionType;
    value?: boolean;
    message?: string | undefined;
    messageDetailsCode?: number | undefined;
    resourceType?: AllowActionResourceType | undefined;

    constructor(data?: IAllowActionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actionType = _data["actionType"];
            this.value = _data["value"];
            this.message = _data["message"];
            this.messageDetailsCode = _data["messageDetailsCode"];
            this.resourceType = _data["resourceType"];
        }
    }

    static fromJS(data: any): AllowActionResult {
        data = typeof data === 'object' ? data : {};
        let result = new AllowActionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actionType"] = this.actionType;
        data["value"] = this.value;
        data["message"] = this.message;
        data["messageDetailsCode"] = this.messageDetailsCode;
        data["resourceType"] = this.resourceType;
        return data;
    }
}

export interface IAllowActionResult {
    actionType?: AllowActionType;
    value?: boolean;
    message?: string | undefined;
    messageDetailsCode?: number | undefined;
    resourceType?: AllowActionResourceType | undefined;
}

export enum AllowActionType {
    Read = "Read",
    Create = "Create",
    Edit = "Edit",
    Delete = "Delete",
    Version = "Version",
    Lock = "Lock",
    Unlock = "Unlock",
}

export class Annotation implements IAnnotation {
    id?: string;
    identifier?: string | undefined;
    text?: MultiLanguage | undefined;
    position?: number;
    title?: string | undefined;
    type?: string | undefined;
    uri?: string | undefined;

    constructor(data?: IAnnotation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
            this.text = _data["text"] ? MultiLanguage.fromJS(_data["text"]) : undefined as any;
            this.position = _data["position"];
            this.title = _data["title"];
            this.type = _data["type"];
            this.uri = _data["uri"];
        }
    }

    static fromJS(data: any): Annotation {
        data = typeof data === 'object' ? data : {};
        let result = new Annotation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        data["text"] = this.text ? this.text.toJSON() : undefined as any;
        data["position"] = this.position;
        data["title"] = this.title;
        data["type"] = this.type;
        data["uri"] = this.uri;
        return data;
    }
}

export interface IAnnotation {
    id?: string;
    identifier?: string | undefined;
    text?: MultiLanguage | undefined;
    position?: number;
    title?: string | undefined;
    type?: string | undefined;
    uri?: string | undefined;
}

export class AnnotationInputModel implements IAnnotationInputModel {
    identifier?: string | undefined;
    text?: MultiLanguageModel | undefined;
    title?: string | undefined;
    type!: string | undefined;
    uri?: string | undefined;

    constructor(data?: IAnnotationInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.text = _data["text"] ? MultiLanguageModel.fromJS(_data["text"]) : undefined as any;
            this.title = _data["title"];
            this.type = _data["type"];
            this.uri = _data["uri"];
        }
    }

    static fromJS(data: any): AnnotationInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new AnnotationInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["text"] = this.text ? this.text.toJSON() : undefined as any;
        data["title"] = this.title;
        data["type"] = this.type;
        data["uri"] = this.uri;
        return data;
    }
}

export interface IAnnotationInputModel {
    identifier?: string | undefined;
    text?: MultiLanguageModel | undefined;
    title?: string | undefined;
    type: string | undefined;
    uri?: string | undefined;
}

export class AnnotationModel implements IAnnotationModel {
    id?: string;
    codeListEntryId!: string;
    identifier?: string | undefined;
    text?: MultiLanguageModel | undefined;
    title?: string | undefined;
    type!: string | undefined;
    uri?: string | undefined;

    constructor(data?: IAnnotationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.codeListEntryId = _data["codeListEntryId"];
            this.identifier = _data["identifier"];
            this.text = _data["text"] ? MultiLanguageModel.fromJS(_data["text"]) : undefined as any;
            this.title = _data["title"];
            this.type = _data["type"];
            this.uri = _data["uri"];
        }
    }

    static fromJS(data: any): AnnotationModel {
        data = typeof data === 'object' ? data : {};
        let result = new AnnotationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["codeListEntryId"] = this.codeListEntryId;
        data["identifier"] = this.identifier;
        data["text"] = this.text ? this.text.toJSON() : undefined as any;
        data["title"] = this.title;
        data["type"] = this.type;
        data["uri"] = this.uri;
        return data;
    }
}

export interface IAnnotationModel {
    id?: string;
    codeListEntryId: string;
    identifier?: string | undefined;
    text?: MultiLanguageModel | undefined;
    title?: string | undefined;
    type: string | undefined;
    uri?: string | undefined;
}

export enum BusinessRole {
    Unknown = "Unknown",
    InteroperabilityService = "InteroperabilityService",
    LocalDataSteward = "LocalDataSteward",
    Submitter = "Submitter",
    StewardshipOrganisationViewer = "StewardshipOrganisationViewer",
    SwissDataSteward = "SwissDataSteward",
}

export class CatalogEntry implements ICatalogEntry {
    accessRights?: VocabularyEntry | undefined;
    businessEvents?: VocabularyEntry[] | undefined;
    conceptValueType?: ConceptType | undefined;
    description?: MultiLanguage | undefined;
    formats?: VocabularyEntry[] | undefined;
    id?: string;
    identifiers?: string[] | undefined;
    lifeEvents?: VocabularyEntry[] | undefined;
    publicationLevel?: PublicationLevel;
    publicationLevelProposal?: PublicationLevel | undefined;
    publisherName?: MultiLanguage | undefined;
    registrationStatus?: RegistrationStatus;
    registrationStatusProposal?: RegistrationStatus | undefined;
    structure?: SearchStructureOption | undefined;
    system?: SystemInfoModel | undefined;
    themes?: VocabularyEntry[] | undefined;
    title?: MultiLanguage | undefined;
    type?: string | undefined;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
    version?: string | undefined;

    constructor(data?: ICatalogEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessRights = _data["accessRights"] ? VocabularyEntry.fromJS(_data["accessRights"]) : undefined as any;
            if (Array.isArray(_data["businessEvents"])) {
                this.businessEvents = [] as any;
                for (let item of _data["businessEvents"])
                    this.businessEvents!.push(VocabularyEntry.fromJS(item));
            }
            this.conceptValueType = _data["conceptValueType"];
            this.description = _data["description"] ? MultiLanguage.fromJS(_data["description"]) : undefined as any;
            if (Array.isArray(_data["formats"])) {
                this.formats = [] as any;
                for (let item of _data["formats"])
                    this.formats!.push(VocabularyEntry.fromJS(item));
            }
            this.id = _data["id"];
            if (Array.isArray(_data["identifiers"])) {
                this.identifiers = [] as any;
                for (let item of _data["identifiers"])
                    this.identifiers!.push(item);
            }
            if (Array.isArray(_data["lifeEvents"])) {
                this.lifeEvents = [] as any;
                for (let item of _data["lifeEvents"])
                    this.lifeEvents!.push(VocabularyEntry.fromJS(item));
            }
            this.publicationLevel = _data["publicationLevel"];
            this.publicationLevelProposal = _data["publicationLevelProposal"];
            this.publisherName = _data["publisherName"] ? MultiLanguage.fromJS(_data["publisherName"]) : undefined as any;
            this.registrationStatus = _data["registrationStatus"];
            this.registrationStatusProposal = _data["registrationStatusProposal"];
            this.structure = _data["structure"];
            this.system = _data["system"] ? SystemInfoModel.fromJS(_data["system"]) : undefined as any;
            if (Array.isArray(_data["themes"])) {
                this.themes = [] as any;
                for (let item of _data["themes"])
                    this.themes!.push(VocabularyEntry.fromJS(item));
            }
            this.title = _data["title"] ? MultiLanguage.fromJS(_data["title"]) : undefined as any;
            this.type = _data["type"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : undefined as any;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : undefined as any;
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): CatalogEntry {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessRights"] = this.accessRights ? this.accessRights.toJSON() : undefined as any;
        if (Array.isArray(this.businessEvents)) {
            data["businessEvents"] = [];
            for (let item of this.businessEvents)
                data["businessEvents"].push(item ? item.toJSON() : undefined as any);
        }
        data["conceptValueType"] = this.conceptValueType;
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        if (Array.isArray(this.formats)) {
            data["formats"] = [];
            for (let item of this.formats)
                data["formats"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        if (Array.isArray(this.identifiers)) {
            data["identifiers"] = [];
            for (let item of this.identifiers)
                data["identifiers"].push(item);
        }
        if (Array.isArray(this.lifeEvents)) {
            data["lifeEvents"] = [];
            for (let item of this.lifeEvents)
                data["lifeEvents"].push(item ? item.toJSON() : undefined as any);
        }
        data["publicationLevel"] = this.publicationLevel;
        data["publicationLevelProposal"] = this.publicationLevelProposal;
        data["publisherName"] = this.publisherName ? this.publisherName.toJSON() : undefined as any;
        data["registrationStatus"] = this.registrationStatus;
        data["registrationStatusProposal"] = this.registrationStatusProposal;
        data["structure"] = this.structure;
        data["system"] = this.system ? this.system.toJSON() : undefined as any;
        if (Array.isArray(this.themes)) {
            data["themes"] = [];
            for (let item of this.themes)
                data["themes"].push(item ? item.toJSON() : undefined as any);
        }
        data["title"] = this.title ? this.title.toJSON() : undefined as any;
        data["type"] = this.type;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : undefined as any;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : undefined as any;
        data["version"] = this.version;
        return data;
    }
}

export interface ICatalogEntry {
    accessRights?: VocabularyEntry | undefined;
    businessEvents?: VocabularyEntry[] | undefined;
    conceptValueType?: ConceptType | undefined;
    description?: MultiLanguage | undefined;
    formats?: VocabularyEntry[] | undefined;
    id?: string;
    identifiers?: string[] | undefined;
    lifeEvents?: VocabularyEntry[] | undefined;
    publicationLevel?: PublicationLevel;
    publicationLevelProposal?: PublicationLevel | undefined;
    publisherName?: MultiLanguage | undefined;
    registrationStatus?: RegistrationStatus;
    registrationStatusProposal?: RegistrationStatus | undefined;
    structure?: SearchStructureOption | undefined;
    system?: SystemInfoModel | undefined;
    themes?: VocabularyEntry[] | undefined;
    title?: MultiLanguage | undefined;
    type?: string | undefined;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
    version?: string | undefined;
}

export class ChannelInputModel implements IChannelInputModel {
    address?: MultiLanguageModel | undefined;
    description?: MultiLanguageModel | undefined;
    email?: string | undefined;
    fax?: string | undefined;
    id?: string | undefined;
    identifier!: string | undefined;
    mobile?: string | undefined;
    openingHours?: string | undefined;
    ownedBy?: IdentifierInputModel[] | undefined;
    phone?: string | undefined;
    type?: CodeInputModel | undefined;
    url?: string | undefined;

    constructor(data?: IChannelInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"] ? MultiLanguageModel.fromJS(_data["address"]) : undefined as any;
            this.description = _data["description"] ? MultiLanguageModel.fromJS(_data["description"]) : undefined as any;
            this.email = _data["email"];
            this.fax = _data["fax"];
            this.id = _data["id"];
            this.identifier = _data["identifier"];
            this.mobile = _data["mobile"];
            this.openingHours = _data["openingHours"];
            if (Array.isArray(_data["ownedBy"])) {
                this.ownedBy = [] as any;
                for (let item of _data["ownedBy"])
                    this.ownedBy!.push(IdentifierInputModel.fromJS(item));
            }
            this.phone = _data["phone"];
            this.type = _data["type"] ? CodeInputModel.fromJS(_data["type"]) : undefined as any;
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): ChannelInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        data["email"] = this.email;
        data["fax"] = this.fax;
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        data["mobile"] = this.mobile;
        data["openingHours"] = this.openingHours;
        if (Array.isArray(this.ownedBy)) {
            data["ownedBy"] = [];
            for (let item of this.ownedBy)
                data["ownedBy"].push(item ? item.toJSON() : undefined as any);
        }
        data["phone"] = this.phone;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["url"] = this.url;
        return data;
    }
}

export interface IChannelInputModel {
    address?: MultiLanguageModel | undefined;
    description?: MultiLanguageModel | undefined;
    email?: string | undefined;
    fax?: string | undefined;
    id?: string | undefined;
    identifier: string | undefined;
    mobile?: string | undefined;
    openingHours?: string | undefined;
    ownedBy?: IdentifierInputModel[] | undefined;
    phone?: string | undefined;
    type?: CodeInputModel | undefined;
    url?: string | undefined;
}

export class ChannelModel implements IChannelModel {
    address?: MultiLanguageModel | undefined;
    description?: MultiLanguageModel | undefined;
    email?: string | undefined;
    fax?: string | undefined;
    id!: string;
    identifier!: string | undefined;
    mobile?: string | undefined;
    openingHours?: string | undefined;
    ownedBy?: AgentModel[] | undefined;
    phone?: string | undefined;
    type?: VocabularyEntryModel | undefined;
    url?: string | undefined;

    constructor(data?: IChannelModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.address = _data["address"] ? MultiLanguageModel.fromJS(_data["address"]) : undefined as any;
            this.description = _data["description"] ? MultiLanguageModel.fromJS(_data["description"]) : undefined as any;
            this.email = _data["email"];
            this.fax = _data["fax"];
            this.id = _data["id"];
            this.identifier = _data["identifier"];
            this.mobile = _data["mobile"];
            this.openingHours = _data["openingHours"];
            if (Array.isArray(_data["ownedBy"])) {
                this.ownedBy = [] as any;
                for (let item of _data["ownedBy"])
                    this.ownedBy!.push(AgentModel.fromJS(item));
            }
            this.phone = _data["phone"];
            this.type = _data["type"] ? VocabularyEntryModel.fromJS(_data["type"]) : undefined as any;
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): ChannelModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        data["email"] = this.email;
        data["fax"] = this.fax;
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        data["mobile"] = this.mobile;
        data["openingHours"] = this.openingHours;
        if (Array.isArray(this.ownedBy)) {
            data["ownedBy"] = [];
            for (let item of this.ownedBy)
                data["ownedBy"].push(item ? item.toJSON() : undefined as any);
        }
        data["phone"] = this.phone;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["url"] = this.url;
        return data;
    }
}

export interface IChannelModel {
    address?: MultiLanguageModel | undefined;
    description?: MultiLanguageModel | undefined;
    email?: string | undefined;
    fax?: string | undefined;
    id: string;
    identifier: string | undefined;
    mobile?: string | undefined;
    openingHours?: string | undefined;
    ownedBy?: AgentModel[] | undefined;
    phone?: string | undefined;
    type?: VocabularyEntryModel | undefined;
    url?: string | undefined;
}

export class ChecksumInputModel implements IChecksumInputModel {
    algorithm!: CodeInputModel | undefined;
    checksumValue!: string | undefined;

    constructor(data?: IChecksumInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.algorithm = _data["algorithm"] ? CodeInputModel.fromJS(_data["algorithm"]) : undefined as any;
            this.checksumValue = _data["checksumValue"];
        }
    }

    static fromJS(data: any): ChecksumInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChecksumInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["algorithm"] = this.algorithm ? this.algorithm.toJSON() : undefined as any;
        data["checksumValue"] = this.checksumValue;
        return data;
    }
}

export interface IChecksumInputModel {
    algorithm: CodeInputModel | undefined;
    checksumValue: string | undefined;
}

export class ChecksumModel implements IChecksumModel {
    algorithm?: VocabularyEntryModel | undefined;
    checksumValue?: string | undefined;

    constructor(data?: IChecksumModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.algorithm = _data["algorithm"] ? VocabularyEntryModel.fromJS(_data["algorithm"]) : undefined as any;
            this.checksumValue = _data["checksumValue"];
        }
    }

    static fromJS(data: any): ChecksumModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChecksumModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["algorithm"] = this.algorithm ? this.algorithm.toJSON() : undefined as any;
        data["checksumValue"] = this.checksumValue;
        return data;
    }
}

export interface IChecksumModel {
    algorithm?: VocabularyEntryModel | undefined;
    checksumValue?: string | undefined;
}

export class CodeInputModel implements ICodeInputModel {
    code!: string | undefined;

    constructor(data?: ICodeInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): CodeInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new CodeInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        return data;
    }
}

export interface ICodeInputModel {
    code: string | undefined;
}

export enum CodeListEntriesDataFormat {
    Json = "Json",
    Csv = "Csv",
}

export class CodeListEntryDetail implements ICodeListEntryDetail {
    description?: MultiLanguage | undefined;
    id?: string;
    name?: MultiLanguage | undefined;
    parentCode?: string | undefined;
    value?: string | undefined;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
    conceptId?: string | undefined;
    annotations?: Annotation[] | undefined;
    hasChildren?: boolean;

    constructor(data?: ICodeListEntryDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"] ? MultiLanguage.fromJS(_data["description"]) : undefined as any;
            this.id = _data["id"];
            this.name = _data["name"] ? MultiLanguage.fromJS(_data["name"]) : undefined as any;
            this.parentCode = _data["parentCode"];
            this.value = _data["value"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : undefined as any;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : undefined as any;
            this.conceptId = _data["conceptId"];
            if (Array.isArray(_data["annotations"])) {
                this.annotations = [] as any;
                for (let item of _data["annotations"])
                    this.annotations!.push(Annotation.fromJS(item));
            }
            this.hasChildren = _data["hasChildren"];
        }
    }

    static fromJS(data: any): CodeListEntryDetail {
        data = typeof data === 'object' ? data : {};
        let result = new CodeListEntryDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        data["id"] = this.id;
        data["name"] = this.name ? this.name.toJSON() : undefined as any;
        data["parentCode"] = this.parentCode;
        data["value"] = this.value;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : undefined as any;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : undefined as any;
        data["conceptId"] = this.conceptId;
        if (Array.isArray(this.annotations)) {
            data["annotations"] = [];
            for (let item of this.annotations)
                data["annotations"].push(item ? item.toJSON() : undefined as any);
        }
        data["hasChildren"] = this.hasChildren;
        return data;
    }
}

export interface ICodeListEntryDetail {
    description?: MultiLanguage | undefined;
    id?: string;
    name?: MultiLanguage | undefined;
    parentCode?: string | undefined;
    value?: string | undefined;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
    conceptId?: string | undefined;
    annotations?: Annotation[] | undefined;
    hasChildren?: boolean;
}

export class CodeListEntryModel implements ICodeListEntryModel {
    annotations?: AnnotationModel[] | undefined;
    code!: string | undefined;
    conceptId!: string;
    description?: MultiLanguageModel | undefined;
    id?: string;
    name!: MultiLanguageModel | undefined;
    parentCode?: string | undefined;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;

    constructor(data?: ICodeListEntryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["annotations"])) {
                this.annotations = [] as any;
                for (let item of _data["annotations"])
                    this.annotations!.push(AnnotationModel.fromJS(item));
            }
            this.code = _data["code"];
            this.conceptId = _data["conceptId"];
            this.description = _data["description"] ? MultiLanguageModel.fromJS(_data["description"]) : undefined as any;
            this.id = _data["id"];
            this.name = _data["name"] ? MultiLanguageModel.fromJS(_data["name"]) : undefined as any;
            this.parentCode = _data["parentCode"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : undefined as any;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CodeListEntryModel {
        data = typeof data === 'object' ? data : {};
        let result = new CodeListEntryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.annotations)) {
            data["annotations"] = [];
            for (let item of this.annotations)
                data["annotations"].push(item ? item.toJSON() : undefined as any);
        }
        data["code"] = this.code;
        data["conceptId"] = this.conceptId;
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        data["id"] = this.id;
        data["name"] = this.name ? this.name.toJSON() : undefined as any;
        data["parentCode"] = this.parentCode;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : undefined as any;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : undefined as any;
        return data;
    }
}

export interface ICodeListEntryModel {
    annotations?: AnnotationModel[] | undefined;
    code: string | undefined;
    conceptId: string;
    description?: MultiLanguageModel | undefined;
    id?: string;
    name: MultiLanguageModel | undefined;
    parentCode?: string | undefined;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
}

export class CodeListEntrySearchResultEntryModel implements ICodeListEntrySearchResultEntryModel {
    entry!: CodeListEntryModel | undefined;
    score!: number;
    path?: CodeListEntrySearchResultPathModel[] | undefined;

    constructor(data?: ICodeListEntrySearchResultEntryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entry = _data["entry"] ? CodeListEntryModel.fromJS(_data["entry"]) : undefined as any;
            this.score = _data["score"];
            if (Array.isArray(_data["path"])) {
                this.path = [] as any;
                for (let item of _data["path"])
                    this.path!.push(CodeListEntrySearchResultPathModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CodeListEntrySearchResultEntryModel {
        data = typeof data === 'object' ? data : {};
        let result = new CodeListEntrySearchResultEntryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entry"] = this.entry ? this.entry.toJSON() : undefined as any;
        data["score"] = this.score;
        if (Array.isArray(this.path)) {
            data["path"] = [];
            for (let item of this.path)
                data["path"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICodeListEntrySearchResultEntryModel {
    entry: CodeListEntryModel | undefined;
    score: number;
    path?: CodeListEntrySearchResultPathModel[] | undefined;
}

export class CodeListEntrySearchResultPathModel implements ICodeListEntrySearchResultPathModel {
    parentCode?: string | undefined;
    code!: string | undefined;
    name!: MultiLanguageModel | undefined;

    constructor(data?: ICodeListEntrySearchResultPathModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentCode = _data["parentCode"];
            this.code = _data["code"];
            this.name = _data["name"] ? MultiLanguageModel.fromJS(_data["name"]) : undefined as any;
        }
    }

    static fromJS(data: any): CodeListEntrySearchResultPathModel {
        data = typeof data === 'object' ? data : {};
        let result = new CodeListEntrySearchResultPathModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentCode"] = this.parentCode;
        data["code"] = this.code;
        data["name"] = this.name ? this.name.toJSON() : undefined as any;
        return data;
    }
}

export interface ICodeListEntrySearchResultPathModel {
    parentCode?: string | undefined;
    code: string | undefined;
    name: MultiLanguageModel | undefined;
}

export enum CodeListEntrySortProperty {
    Code = "Code",
    Position = "Position",
}

export enum CodeListEntryValueType {
    String = "String",
    Numeric = "Numeric",
}

export enum CodeListEntryValueTypeEnum {
    String = "String",
    Numeric = "Numeric",
}

export class CodelistEntryInput implements ICodelistEntryInput {
    description?: MultiLanguage | undefined;
    id?: string;
    name?: MultiLanguage | undefined;
    parentCode?: string | undefined;
    value?: string | undefined;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
    conceptId?: string | undefined;

    constructor(data?: ICodelistEntryInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"] ? MultiLanguage.fromJS(_data["description"]) : undefined as any;
            this.id = _data["id"];
            this.name = _data["name"] ? MultiLanguage.fromJS(_data["name"]) : undefined as any;
            this.parentCode = _data["parentCode"];
            this.value = _data["value"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : undefined as any;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : undefined as any;
            this.conceptId = _data["conceptId"];
        }
    }

    static fromJS(data: any): CodelistEntryInput {
        data = typeof data === 'object' ? data : {};
        let result = new CodelistEntryInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        data["id"] = this.id;
        data["name"] = this.name ? this.name.toJSON() : undefined as any;
        data["parentCode"] = this.parentCode;
        data["value"] = this.value;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : undefined as any;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : undefined as any;
        data["conceptId"] = this.conceptId;
        return data;
    }
}

export interface ICodelistEntryInput {
    description?: MultiLanguage | undefined;
    id?: string;
    name?: MultiLanguage | undefined;
    parentCode?: string | undefined;
    value?: string | undefined;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
    conceptId?: string | undefined;
}

export class ConceptInput implements IConceptInput {
    codelistEntryValueMaxLength?: number | undefined;
    codeListEntryValueType?: CodeListEntryValueTypeEnum | undefined;
    codeListEntryDefaultSortProperty?: CodeListEntrySortProperty | undefined;
    conceptType?: ConceptType;
    conformsTo?: Resource[] | undefined;
    description?: MultiLanguage | undefined;
    id?: string;
    identifiers?: string[] | undefined;
    keywords?: KeywordModel[] | undefined;
    maxLength?: number | undefined;
    maxValue?: number | undefined;
    measurementUnit?: string | undefined;
    minLength?: number | undefined;
    minValue?: number | undefined;
    name?: MultiLanguage | undefined;
    nbDecimal?: number | undefined;
    pattern?: string | undefined;
    replaces?: IdModel[] | undefined;
    publisher!: IdentifierInputModel | undefined;
    responsibleDeputy?: Person | undefined;
    responsiblePerson?: Person | undefined;
    themeCodes?: string[] | undefined;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
    version?: string | undefined;

    constructor(data?: IConceptInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codelistEntryValueMaxLength = _data["codelistEntryValueMaxLength"];
            this.codeListEntryValueType = _data["codeListEntryValueType"];
            this.codeListEntryDefaultSortProperty = _data["codeListEntryDefaultSortProperty"];
            this.conceptType = _data["conceptType"];
            if (Array.isArray(_data["conformsTo"])) {
                this.conformsTo = [] as any;
                for (let item of _data["conformsTo"])
                    this.conformsTo!.push(Resource.fromJS(item));
            }
            this.description = _data["description"] ? MultiLanguage.fromJS(_data["description"]) : undefined as any;
            this.id = _data["id"];
            if (Array.isArray(_data["identifiers"])) {
                this.identifiers = [] as any;
                for (let item of _data["identifiers"])
                    this.identifiers!.push(item);
            }
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(KeywordModel.fromJS(item));
            }
            this.maxLength = _data["maxLength"];
            this.maxValue = _data["maxValue"];
            this.measurementUnit = _data["measurementUnit"];
            this.minLength = _data["minLength"];
            this.minValue = _data["minValue"];
            this.name = _data["name"] ? MultiLanguage.fromJS(_data["name"]) : undefined as any;
            this.nbDecimal = _data["nbDecimal"];
            this.pattern = _data["pattern"];
            if (Array.isArray(_data["replaces"])) {
                this.replaces = [] as any;
                for (let item of _data["replaces"])
                    this.replaces!.push(IdModel.fromJS(item));
            }
            this.publisher = _data["publisher"] ? IdentifierInputModel.fromJS(_data["publisher"]) : undefined as any;
            this.responsibleDeputy = _data["responsibleDeputy"] ? Person.fromJS(_data["responsibleDeputy"]) : undefined as any;
            this.responsiblePerson = _data["responsiblePerson"] ? Person.fromJS(_data["responsiblePerson"]) : undefined as any;
            if (Array.isArray(_data["themeCodes"])) {
                this.themeCodes = [] as any;
                for (let item of _data["themeCodes"])
                    this.themeCodes!.push(item);
            }
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : undefined as any;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : undefined as any;
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): ConceptInput {
        data = typeof data === 'object' ? data : {};
        let result = new ConceptInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codelistEntryValueMaxLength"] = this.codelistEntryValueMaxLength;
        data["codeListEntryValueType"] = this.codeListEntryValueType;
        data["codeListEntryDefaultSortProperty"] = this.codeListEntryDefaultSortProperty;
        data["conceptType"] = this.conceptType;
        if (Array.isArray(this.conformsTo)) {
            data["conformsTo"] = [];
            for (let item of this.conformsTo)
                data["conformsTo"].push(item ? item.toJSON() : undefined as any);
        }
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        data["id"] = this.id;
        if (Array.isArray(this.identifiers)) {
            data["identifiers"] = [];
            for (let item of this.identifiers)
                data["identifiers"].push(item);
        }
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item ? item.toJSON() : undefined as any);
        }
        data["maxLength"] = this.maxLength;
        data["maxValue"] = this.maxValue;
        data["measurementUnit"] = this.measurementUnit;
        data["minLength"] = this.minLength;
        data["minValue"] = this.minValue;
        data["name"] = this.name ? this.name.toJSON() : undefined as any;
        data["nbDecimal"] = this.nbDecimal;
        data["pattern"] = this.pattern;
        if (Array.isArray(this.replaces)) {
            data["replaces"] = [];
            for (let item of this.replaces)
                data["replaces"].push(item ? item.toJSON() : undefined as any);
        }
        data["publisher"] = this.publisher ? this.publisher.toJSON() : undefined as any;
        data["responsibleDeputy"] = this.responsibleDeputy ? this.responsibleDeputy.toJSON() : undefined as any;
        data["responsiblePerson"] = this.responsiblePerson ? this.responsiblePerson.toJSON() : undefined as any;
        if (Array.isArray(this.themeCodes)) {
            data["themeCodes"] = [];
            for (let item of this.themeCodes)
                data["themeCodes"].push(item);
        }
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : undefined as any;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : undefined as any;
        data["version"] = this.version;
        return data;
    }
}

export interface IConceptInput {
    codelistEntryValueMaxLength?: number | undefined;
    codeListEntryValueType?: CodeListEntryValueTypeEnum | undefined;
    codeListEntryDefaultSortProperty?: CodeListEntrySortProperty | undefined;
    conceptType?: ConceptType;
    conformsTo?: Resource[] | undefined;
    description?: MultiLanguage | undefined;
    id?: string;
    identifiers?: string[] | undefined;
    keywords?: KeywordModel[] | undefined;
    maxLength?: number | undefined;
    maxValue?: number | undefined;
    measurementUnit?: string | undefined;
    minLength?: number | undefined;
    minValue?: number | undefined;
    name?: MultiLanguage | undefined;
    nbDecimal?: number | undefined;
    pattern?: string | undefined;
    replaces?: IdModel[] | undefined;
    publisher: IdentifierInputModel | undefined;
    responsibleDeputy?: Person | undefined;
    responsiblePerson?: Person | undefined;
    themeCodes?: string[] | undefined;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
    version?: string | undefined;
}

export class ConceptInputCreateVersion implements IConceptInputCreateVersion {
    description?: MultiLanguage | undefined;
    id?: string;
    identifiers?: string[] | undefined;
    name?: MultiLanguage | undefined;
    previousVersionId?: string;
    responsibleDeputy?: Person | undefined;
    responsiblePerson?: Person | undefined;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
    version?: string | undefined;

    constructor(data?: IConceptInputCreateVersion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"] ? MultiLanguage.fromJS(_data["description"]) : undefined as any;
            this.id = _data["id"];
            if (Array.isArray(_data["identifiers"])) {
                this.identifiers = [] as any;
                for (let item of _data["identifiers"])
                    this.identifiers!.push(item);
            }
            this.name = _data["name"] ? MultiLanguage.fromJS(_data["name"]) : undefined as any;
            this.previousVersionId = _data["previousVersionId"];
            this.responsibleDeputy = _data["responsibleDeputy"] ? Person.fromJS(_data["responsibleDeputy"]) : undefined as any;
            this.responsiblePerson = _data["responsiblePerson"] ? Person.fromJS(_data["responsiblePerson"]) : undefined as any;
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : undefined as any;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : undefined as any;
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): ConceptInputCreateVersion {
        data = typeof data === 'object' ? data : {};
        let result = new ConceptInputCreateVersion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        data["id"] = this.id;
        if (Array.isArray(this.identifiers)) {
            data["identifiers"] = [];
            for (let item of this.identifiers)
                data["identifiers"].push(item);
        }
        data["name"] = this.name ? this.name.toJSON() : undefined as any;
        data["previousVersionId"] = this.previousVersionId;
        data["responsibleDeputy"] = this.responsibleDeputy ? this.responsibleDeputy.toJSON() : undefined as any;
        data["responsiblePerson"] = this.responsiblePerson ? this.responsiblePerson.toJSON() : undefined as any;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : undefined as any;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : undefined as any;
        data["version"] = this.version;
        return data;
    }
}

export interface IConceptInputCreateVersion {
    description?: MultiLanguage | undefined;
    id?: string;
    identifiers?: string[] | undefined;
    name?: MultiLanguage | undefined;
    previousVersionId?: string;
    responsibleDeputy?: Person | undefined;
    responsiblePerson?: Person | undefined;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
    version?: string | undefined;
}

export class ConceptReferenceModel implements IConceptReferenceModel {
    uri!: string | undefined;
    name?: MultiLanguageModel | undefined;
    conceptId?: string | undefined;

    constructor(data?: IConceptReferenceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uri = _data["uri"];
            this.name = _data["name"] ? MultiLanguageModel.fromJS(_data["name"]) : undefined as any;
            this.conceptId = _data["conceptId"];
        }
    }

    static fromJS(data: any): ConceptReferenceModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConceptReferenceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uri"] = this.uri;
        data["name"] = this.name ? this.name.toJSON() : undefined as any;
        data["conceptId"] = this.conceptId;
        return data;
    }
}

export interface IConceptReferenceModel {
    uri: string | undefined;
    name?: MultiLanguageModel | undefined;
    conceptId?: string | undefined;
}

export enum ConceptType {
    CodeList = "CodeList",
    Date = "Date",
    Numeric = "Numeric",
    String = "String",
}

export class ConceptVersionView implements IConceptVersionView {
    conceptId?: string;
    name?: MultiLanguage | undefined;
    conceptType?: ConceptType;
    version?: string | undefined;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
    registrationStatus?: RegistrationStatus;
    publicationLevel?: PublicationLevel;

    constructor(data?: IConceptVersionView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conceptId = _data["conceptId"];
            this.name = _data["name"] ? MultiLanguage.fromJS(_data["name"]) : undefined as any;
            this.conceptType = _data["conceptType"];
            this.version = _data["version"];
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : undefined as any;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : undefined as any;
            this.registrationStatus = _data["registrationStatus"];
            this.publicationLevel = _data["publicationLevel"];
        }
    }

    static fromJS(data: any): ConceptVersionView {
        data = typeof data === 'object' ? data : {};
        let result = new ConceptVersionView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conceptId"] = this.conceptId;
        data["name"] = this.name ? this.name.toJSON() : undefined as any;
        data["conceptType"] = this.conceptType;
        data["version"] = this.version;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : undefined as any;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : undefined as any;
        data["registrationStatus"] = this.registrationStatus;
        data["publicationLevel"] = this.publicationLevel;
        return data;
    }
}

export interface IConceptVersionView {
    conceptId?: string;
    name?: MultiLanguage | undefined;
    conceptType?: ConceptType;
    version?: string | undefined;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
    registrationStatus?: RegistrationStatus;
    publicationLevel?: PublicationLevel;
}

export class ConceptView implements IConceptView {
    codelistEntryValueMaxLength?: number | undefined;
    codeListEntryValueType?: CodeListEntryValueTypeEnum | undefined;
    codeListEntryDefaultSortProperty?: CodeListEntrySortProperty | undefined;
    codeListId?: string | undefined;
    conceptType?: ConceptType;
    conformsTo?: Resource[] | undefined;
    description?: MultiLanguage | undefined;
    id?: string;
    identifiers?: string[] | undefined;
    isLocked?: boolean;
    keywords?: KeywordModel[] | undefined;
    maxLength?: number | undefined;
    maxValue?: number | undefined;
    measurementUnit?: string | undefined;
    minLength?: number | undefined;
    minValue?: number | undefined;
    name?: MultiLanguage | undefined;
    nbDecimal?: number | undefined;
    pattern?: string | undefined;
    replaces?: ConceptReferenceModel[] | undefined;
    isReplacedBy?: ConceptReferenceModel[] | undefined;
    publisher!: AgentModel | undefined;
    responsibleDeputy?: Person | undefined;
    responsiblePerson?: Person | undefined;
    system?: SystemInfoModel | undefined;
    themes?: VocabularyEntry[] | undefined;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
    version?: string | undefined;

    constructor(data?: IConceptView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.codelistEntryValueMaxLength = _data["codelistEntryValueMaxLength"];
            this.codeListEntryValueType = _data["codeListEntryValueType"];
            this.codeListEntryDefaultSortProperty = _data["codeListEntryDefaultSortProperty"];
            this.codeListId = _data["codeListId"];
            this.conceptType = _data["conceptType"];
            if (Array.isArray(_data["conformsTo"])) {
                this.conformsTo = [] as any;
                for (let item of _data["conformsTo"])
                    this.conformsTo!.push(Resource.fromJS(item));
            }
            this.description = _data["description"] ? MultiLanguage.fromJS(_data["description"]) : undefined as any;
            this.id = _data["id"];
            if (Array.isArray(_data["identifiers"])) {
                this.identifiers = [] as any;
                for (let item of _data["identifiers"])
                    this.identifiers!.push(item);
            }
            this.isLocked = _data["isLocked"];
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(KeywordModel.fromJS(item));
            }
            this.maxLength = _data["maxLength"];
            this.maxValue = _data["maxValue"];
            this.measurementUnit = _data["measurementUnit"];
            this.minLength = _data["minLength"];
            this.minValue = _data["minValue"];
            this.name = _data["name"] ? MultiLanguage.fromJS(_data["name"]) : undefined as any;
            this.nbDecimal = _data["nbDecimal"];
            this.pattern = _data["pattern"];
            if (Array.isArray(_data["replaces"])) {
                this.replaces = [] as any;
                for (let item of _data["replaces"])
                    this.replaces!.push(ConceptReferenceModel.fromJS(item));
            }
            if (Array.isArray(_data["isReplacedBy"])) {
                this.isReplacedBy = [] as any;
                for (let item of _data["isReplacedBy"])
                    this.isReplacedBy!.push(ConceptReferenceModel.fromJS(item));
            }
            this.publisher = _data["publisher"] ? AgentModel.fromJS(_data["publisher"]) : undefined as any;
            this.responsibleDeputy = _data["responsibleDeputy"] ? Person.fromJS(_data["responsibleDeputy"]) : undefined as any;
            this.responsiblePerson = _data["responsiblePerson"] ? Person.fromJS(_data["responsiblePerson"]) : undefined as any;
            this.system = _data["system"] ? SystemInfoModel.fromJS(_data["system"]) : undefined as any;
            if (Array.isArray(_data["themes"])) {
                this.themes = [] as any;
                for (let item of _data["themes"])
                    this.themes!.push(VocabularyEntry.fromJS(item));
            }
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : undefined as any;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : undefined as any;
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): ConceptView {
        data = typeof data === 'object' ? data : {};
        let result = new ConceptView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["codelistEntryValueMaxLength"] = this.codelistEntryValueMaxLength;
        data["codeListEntryValueType"] = this.codeListEntryValueType;
        data["codeListEntryDefaultSortProperty"] = this.codeListEntryDefaultSortProperty;
        data["codeListId"] = this.codeListId;
        data["conceptType"] = this.conceptType;
        if (Array.isArray(this.conformsTo)) {
            data["conformsTo"] = [];
            for (let item of this.conformsTo)
                data["conformsTo"].push(item ? item.toJSON() : undefined as any);
        }
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        data["id"] = this.id;
        if (Array.isArray(this.identifiers)) {
            data["identifiers"] = [];
            for (let item of this.identifiers)
                data["identifiers"].push(item);
        }
        data["isLocked"] = this.isLocked;
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item ? item.toJSON() : undefined as any);
        }
        data["maxLength"] = this.maxLength;
        data["maxValue"] = this.maxValue;
        data["measurementUnit"] = this.measurementUnit;
        data["minLength"] = this.minLength;
        data["minValue"] = this.minValue;
        data["name"] = this.name ? this.name.toJSON() : undefined as any;
        data["nbDecimal"] = this.nbDecimal;
        data["pattern"] = this.pattern;
        if (Array.isArray(this.replaces)) {
            data["replaces"] = [];
            for (let item of this.replaces)
                data["replaces"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.isReplacedBy)) {
            data["isReplacedBy"] = [];
            for (let item of this.isReplacedBy)
                data["isReplacedBy"].push(item ? item.toJSON() : undefined as any);
        }
        data["publisher"] = this.publisher ? this.publisher.toJSON() : undefined as any;
        data["responsibleDeputy"] = this.responsibleDeputy ? this.responsibleDeputy.toJSON() : undefined as any;
        data["responsiblePerson"] = this.responsiblePerson ? this.responsiblePerson.toJSON() : undefined as any;
        data["system"] = this.system ? this.system.toJSON() : undefined as any;
        if (Array.isArray(this.themes)) {
            data["themes"] = [];
            for (let item of this.themes)
                data["themes"].push(item ? item.toJSON() : undefined as any);
        }
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : undefined as any;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : undefined as any;
        data["version"] = this.version;
        return data;
    }
}

export interface IConceptView {
    codelistEntryValueMaxLength?: number | undefined;
    codeListEntryValueType?: CodeListEntryValueTypeEnum | undefined;
    codeListEntryDefaultSortProperty?: CodeListEntrySortProperty | undefined;
    codeListId?: string | undefined;
    conceptType?: ConceptType;
    conformsTo?: Resource[] | undefined;
    description?: MultiLanguage | undefined;
    id?: string;
    identifiers?: string[] | undefined;
    isLocked?: boolean;
    keywords?: KeywordModel[] | undefined;
    maxLength?: number | undefined;
    maxValue?: number | undefined;
    measurementUnit?: string | undefined;
    minLength?: number | undefined;
    minValue?: number | undefined;
    name?: MultiLanguage | undefined;
    nbDecimal?: number | undefined;
    pattern?: string | undefined;
    replaces?: ConceptReferenceModel[] | undefined;
    isReplacedBy?: ConceptReferenceModel[] | undefined;
    publisher: AgentModel | undefined;
    responsibleDeputy?: Person | undefined;
    responsiblePerson?: Person | undefined;
    system?: SystemInfoModel | undefined;
    themes?: VocabularyEntry[] | undefined;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
    version?: string | undefined;
}

export enum CreationType {
    Manual = "Manual",
    Automated = "Automated",
}

export enum DataFormat {
    Json = "Json",
}

export class DataService implements IDataService {
    accessRights?: VocabularyEntry | undefined;
    conformTos?: Resource[] | undefined;
    contactPoints?: Vcard[] | undefined;
    description?: MultiLanguage | undefined;
    documents?: Resource[] | undefined;
    endpointDescriptions?: Resource[] | undefined;
    endpointUrls?: Resource[] | undefined;
    id?: string;
    identifiers?: string[] | undefined;
    issued?: Date | undefined;
    keywords?: KeywordModel[] | undefined;
    landingPages?: Resource[] | undefined;
    license?: VocabularyEntry | undefined;
    modified?: Date | undefined;
    nextVersions?: DataServiceVersionSummary[] | undefined;
    previousVersion?: DataServiceVersionSummary | undefined;
    publicationLevel?: PublicationLevel;
    publicationLevelProposal?: PublicationLevel | undefined;
    publisherName?: MultiLanguage | undefined;
    registrationStatus?: RegistrationStatus;
    registrationStatusProposal?: RegistrationStatus | undefined;
    responsibleDeputy?: IopPersonModel | undefined;
    responsiblePerson?: IopPersonModel | undefined;
    servesDatasets?: IdLabel[] | undefined;
    status?: string | undefined;
    system?: SystemInfoModel | undefined;
    themes?: VocabularyEntry[] | undefined;
    title?: MultiLanguage | undefined;
    version?: string | undefined;
    versionNotes?: MultiLanguage | undefined;

    constructor(data?: IDataService) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessRights = _data["accessRights"] ? VocabularyEntry.fromJS(_data["accessRights"]) : undefined as any;
            if (Array.isArray(_data["conformTos"])) {
                this.conformTos = [] as any;
                for (let item of _data["conformTos"])
                    this.conformTos!.push(Resource.fromJS(item));
            }
            if (Array.isArray(_data["contactPoints"])) {
                this.contactPoints = [] as any;
                for (let item of _data["contactPoints"])
                    this.contactPoints!.push(Vcard.fromJS(item));
            }
            this.description = _data["description"] ? MultiLanguage.fromJS(_data["description"]) : undefined as any;
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(Resource.fromJS(item));
            }
            if (Array.isArray(_data["endpointDescriptions"])) {
                this.endpointDescriptions = [] as any;
                for (let item of _data["endpointDescriptions"])
                    this.endpointDescriptions!.push(Resource.fromJS(item));
            }
            if (Array.isArray(_data["endpointUrls"])) {
                this.endpointUrls = [] as any;
                for (let item of _data["endpointUrls"])
                    this.endpointUrls!.push(Resource.fromJS(item));
            }
            this.id = _data["id"];
            if (Array.isArray(_data["identifiers"])) {
                this.identifiers = [] as any;
                for (let item of _data["identifiers"])
                    this.identifiers!.push(item);
            }
            this.issued = _data["issued"] ? new Date(_data["issued"].toString()) : undefined as any;
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(KeywordModel.fromJS(item));
            }
            if (Array.isArray(_data["landingPages"])) {
                this.landingPages = [] as any;
                for (let item of _data["landingPages"])
                    this.landingPages!.push(Resource.fromJS(item));
            }
            this.license = _data["license"] ? VocabularyEntry.fromJS(_data["license"]) : undefined as any;
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            if (Array.isArray(_data["nextVersions"])) {
                this.nextVersions = [] as any;
                for (let item of _data["nextVersions"])
                    this.nextVersions!.push(DataServiceVersionSummary.fromJS(item));
            }
            this.previousVersion = _data["previousVersion"] ? DataServiceVersionSummary.fromJS(_data["previousVersion"]) : undefined as any;
            this.publicationLevel = _data["publicationLevel"];
            this.publicationLevelProposal = _data["publicationLevelProposal"];
            this.publisherName = _data["publisherName"] ? MultiLanguage.fromJS(_data["publisherName"]) : undefined as any;
            this.registrationStatus = _data["registrationStatus"];
            this.registrationStatusProposal = _data["registrationStatusProposal"];
            this.responsibleDeputy = _data["responsibleDeputy"] ? IopPersonModel.fromJS(_data["responsibleDeputy"]) : undefined as any;
            this.responsiblePerson = _data["responsiblePerson"] ? IopPersonModel.fromJS(_data["responsiblePerson"]) : undefined as any;
            if (Array.isArray(_data["servesDatasets"])) {
                this.servesDatasets = [] as any;
                for (let item of _data["servesDatasets"])
                    this.servesDatasets!.push(IdLabel.fromJS(item));
            }
            this.status = _data["status"];
            this.system = _data["system"] ? SystemInfoModel.fromJS(_data["system"]) : undefined as any;
            if (Array.isArray(_data["themes"])) {
                this.themes = [] as any;
                for (let item of _data["themes"])
                    this.themes!.push(VocabularyEntry.fromJS(item));
            }
            this.title = _data["title"] ? MultiLanguage.fromJS(_data["title"]) : undefined as any;
            this.version = _data["version"];
            this.versionNotes = _data["versionNotes"] ? MultiLanguage.fromJS(_data["versionNotes"]) : undefined as any;
        }
    }

    static fromJS(data: any): DataService {
        data = typeof data === 'object' ? data : {};
        let result = new DataService();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessRights"] = this.accessRights ? this.accessRights.toJSON() : undefined as any;
        if (Array.isArray(this.conformTos)) {
            data["conformTos"] = [];
            for (let item of this.conformTos)
                data["conformTos"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.contactPoints)) {
            data["contactPoints"] = [];
            for (let item of this.contactPoints)
                data["contactPoints"].push(item ? item.toJSON() : undefined as any);
        }
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.endpointDescriptions)) {
            data["endpointDescriptions"] = [];
            for (let item of this.endpointDescriptions)
                data["endpointDescriptions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.endpointUrls)) {
            data["endpointUrls"] = [];
            for (let item of this.endpointUrls)
                data["endpointUrls"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        if (Array.isArray(this.identifiers)) {
            data["identifiers"] = [];
            for (let item of this.identifiers)
                data["identifiers"].push(item);
        }
        data["issued"] = this.issued ? this.issued.toISOString() : undefined as any;
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.landingPages)) {
            data["landingPages"] = [];
            for (let item of this.landingPages)
                data["landingPages"].push(item ? item.toJSON() : undefined as any);
        }
        data["license"] = this.license ? this.license.toJSON() : undefined as any;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        if (Array.isArray(this.nextVersions)) {
            data["nextVersions"] = [];
            for (let item of this.nextVersions)
                data["nextVersions"].push(item ? item.toJSON() : undefined as any);
        }
        data["previousVersion"] = this.previousVersion ? this.previousVersion.toJSON() : undefined as any;
        data["publicationLevel"] = this.publicationLevel;
        data["publicationLevelProposal"] = this.publicationLevelProposal;
        data["publisherName"] = this.publisherName ? this.publisherName.toJSON() : undefined as any;
        data["registrationStatus"] = this.registrationStatus;
        data["registrationStatusProposal"] = this.registrationStatusProposal;
        data["responsibleDeputy"] = this.responsibleDeputy ? this.responsibleDeputy.toJSON() : undefined as any;
        data["responsiblePerson"] = this.responsiblePerson ? this.responsiblePerson.toJSON() : undefined as any;
        if (Array.isArray(this.servesDatasets)) {
            data["servesDatasets"] = [];
            for (let item of this.servesDatasets)
                data["servesDatasets"].push(item ? item.toJSON() : undefined as any);
        }
        data["status"] = this.status;
        data["system"] = this.system ? this.system.toJSON() : undefined as any;
        if (Array.isArray(this.themes)) {
            data["themes"] = [];
            for (let item of this.themes)
                data["themes"].push(item ? item.toJSON() : undefined as any);
        }
        data["title"] = this.title ? this.title.toJSON() : undefined as any;
        data["version"] = this.version;
        data["versionNotes"] = this.versionNotes ? this.versionNotes.toJSON() : undefined as any;
        return data;
    }
}

export interface IDataService {
    accessRights?: VocabularyEntry | undefined;
    conformTos?: Resource[] | undefined;
    contactPoints?: Vcard[] | undefined;
    description?: MultiLanguage | undefined;
    documents?: Resource[] | undefined;
    endpointDescriptions?: Resource[] | undefined;
    endpointUrls?: Resource[] | undefined;
    id?: string;
    identifiers?: string[] | undefined;
    issued?: Date | undefined;
    keywords?: KeywordModel[] | undefined;
    landingPages?: Resource[] | undefined;
    license?: VocabularyEntry | undefined;
    modified?: Date | undefined;
    nextVersions?: DataServiceVersionSummary[] | undefined;
    previousVersion?: DataServiceVersionSummary | undefined;
    publicationLevel?: PublicationLevel;
    publicationLevelProposal?: PublicationLevel | undefined;
    publisherName?: MultiLanguage | undefined;
    registrationStatus?: RegistrationStatus;
    registrationStatusProposal?: RegistrationStatus | undefined;
    responsibleDeputy?: IopPersonModel | undefined;
    responsiblePerson?: IopPersonModel | undefined;
    servesDatasets?: IdLabel[] | undefined;
    status?: string | undefined;
    system?: SystemInfoModel | undefined;
    themes?: VocabularyEntry[] | undefined;
    title?: MultiLanguage | undefined;
    version?: string | undefined;
    versionNotes?: MultiLanguage | undefined;
}

export class DataServiceInput implements IDataServiceInput {
    accessRightCode?: string | undefined;
    conformTos?: Resource[] | undefined;
    contactPoints?: Vcard[] | undefined;
    description?: MultiLanguage | undefined;
    documents?: Resource[] | undefined;
    endpointDescriptions?: Resource[] | undefined;
    endpointUrls?: Resource[] | undefined;
    id?: string;
    identifiers?: string[] | undefined;
    issued?: Date | undefined;
    keywords?: KeywordModel[] | undefined;
    landingPages?: Resource[] | undefined;
    license?: VocabularyEntry | undefined;
    modified?: Date | undefined;
    previousVersion?: IdModel | undefined;
    publisher?: IdentifierInputModel | undefined;
    responsibleDeputy?: EmailInputModel | undefined;
    responsiblePerson?: EmailInputModel | undefined;
    servesDatasets?: IdModel[] | undefined;
    themeCodes?: string[] | undefined;
    title?: MultiLanguage | undefined;
    version?: string | undefined;
    versionNotes?: MultiLanguage | undefined;

    constructor(data?: IDataServiceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessRightCode = _data["accessRightCode"];
            if (Array.isArray(_data["conformTos"])) {
                this.conformTos = [] as any;
                for (let item of _data["conformTos"])
                    this.conformTos!.push(Resource.fromJS(item));
            }
            if (Array.isArray(_data["contactPoints"])) {
                this.contactPoints = [] as any;
                for (let item of _data["contactPoints"])
                    this.contactPoints!.push(Vcard.fromJS(item));
            }
            this.description = _data["description"] ? MultiLanguage.fromJS(_data["description"]) : undefined as any;
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(Resource.fromJS(item));
            }
            if (Array.isArray(_data["endpointDescriptions"])) {
                this.endpointDescriptions = [] as any;
                for (let item of _data["endpointDescriptions"])
                    this.endpointDescriptions!.push(Resource.fromJS(item));
            }
            if (Array.isArray(_data["endpointUrls"])) {
                this.endpointUrls = [] as any;
                for (let item of _data["endpointUrls"])
                    this.endpointUrls!.push(Resource.fromJS(item));
            }
            this.id = _data["id"];
            if (Array.isArray(_data["identifiers"])) {
                this.identifiers = [] as any;
                for (let item of _data["identifiers"])
                    this.identifiers!.push(item);
            }
            this.issued = _data["issued"] ? new Date(_data["issued"].toString()) : undefined as any;
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(KeywordModel.fromJS(item));
            }
            if (Array.isArray(_data["landingPages"])) {
                this.landingPages = [] as any;
                for (let item of _data["landingPages"])
                    this.landingPages!.push(Resource.fromJS(item));
            }
            this.license = _data["license"] ? VocabularyEntry.fromJS(_data["license"]) : undefined as any;
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.previousVersion = _data["previousVersion"] ? IdModel.fromJS(_data["previousVersion"]) : undefined as any;
            this.publisher = _data["publisher"] ? IdentifierInputModel.fromJS(_data["publisher"]) : undefined as any;
            this.responsibleDeputy = _data["responsibleDeputy"] ? EmailInputModel.fromJS(_data["responsibleDeputy"]) : undefined as any;
            this.responsiblePerson = _data["responsiblePerson"] ? EmailInputModel.fromJS(_data["responsiblePerson"]) : undefined as any;
            if (Array.isArray(_data["servesDatasets"])) {
                this.servesDatasets = [] as any;
                for (let item of _data["servesDatasets"])
                    this.servesDatasets!.push(IdModel.fromJS(item));
            }
            if (Array.isArray(_data["themeCodes"])) {
                this.themeCodes = [] as any;
                for (let item of _data["themeCodes"])
                    this.themeCodes!.push(item);
            }
            this.title = _data["title"] ? MultiLanguage.fromJS(_data["title"]) : undefined as any;
            this.version = _data["version"];
            this.versionNotes = _data["versionNotes"] ? MultiLanguage.fromJS(_data["versionNotes"]) : undefined as any;
        }
    }

    static fromJS(data: any): DataServiceInput {
        data = typeof data === 'object' ? data : {};
        let result = new DataServiceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessRightCode"] = this.accessRightCode;
        if (Array.isArray(this.conformTos)) {
            data["conformTos"] = [];
            for (let item of this.conformTos)
                data["conformTos"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.contactPoints)) {
            data["contactPoints"] = [];
            for (let item of this.contactPoints)
                data["contactPoints"].push(item ? item.toJSON() : undefined as any);
        }
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.endpointDescriptions)) {
            data["endpointDescriptions"] = [];
            for (let item of this.endpointDescriptions)
                data["endpointDescriptions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.endpointUrls)) {
            data["endpointUrls"] = [];
            for (let item of this.endpointUrls)
                data["endpointUrls"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        if (Array.isArray(this.identifiers)) {
            data["identifiers"] = [];
            for (let item of this.identifiers)
                data["identifiers"].push(item);
        }
        data["issued"] = this.issued ? this.issued.toISOString() : undefined as any;
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.landingPages)) {
            data["landingPages"] = [];
            for (let item of this.landingPages)
                data["landingPages"].push(item ? item.toJSON() : undefined as any);
        }
        data["license"] = this.license ? this.license.toJSON() : undefined as any;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["previousVersion"] = this.previousVersion ? this.previousVersion.toJSON() : undefined as any;
        data["publisher"] = this.publisher ? this.publisher.toJSON() : undefined as any;
        data["responsibleDeputy"] = this.responsibleDeputy ? this.responsibleDeputy.toJSON() : undefined as any;
        data["responsiblePerson"] = this.responsiblePerson ? this.responsiblePerson.toJSON() : undefined as any;
        if (Array.isArray(this.servesDatasets)) {
            data["servesDatasets"] = [];
            for (let item of this.servesDatasets)
                data["servesDatasets"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.themeCodes)) {
            data["themeCodes"] = [];
            for (let item of this.themeCodes)
                data["themeCodes"].push(item);
        }
        data["title"] = this.title ? this.title.toJSON() : undefined as any;
        data["version"] = this.version;
        data["versionNotes"] = this.versionNotes ? this.versionNotes.toJSON() : undefined as any;
        return data;
    }
}

export interface IDataServiceInput {
    accessRightCode?: string | undefined;
    conformTos?: Resource[] | undefined;
    contactPoints?: Vcard[] | undefined;
    description?: MultiLanguage | undefined;
    documents?: Resource[] | undefined;
    endpointDescriptions?: Resource[] | undefined;
    endpointUrls?: Resource[] | undefined;
    id?: string;
    identifiers?: string[] | undefined;
    issued?: Date | undefined;
    keywords?: KeywordModel[] | undefined;
    landingPages?: Resource[] | undefined;
    license?: VocabularyEntry | undefined;
    modified?: Date | undefined;
    previousVersion?: IdModel | undefined;
    publisher?: IdentifierInputModel | undefined;
    responsibleDeputy?: EmailInputModel | undefined;
    responsiblePerson?: EmailInputModel | undefined;
    servesDatasets?: IdModel[] | undefined;
    themeCodes?: string[] | undefined;
    title?: MultiLanguage | undefined;
    version?: string | undefined;
    versionNotes?: MultiLanguage | undefined;
}

export class DataServiceModel implements IDataServiceModel {
    accessRights?: VocabularyEntryModel | undefined;
    conformsTo?: ResourceModel[] | undefined;
    contactPoints?: VCardModel[] | undefined;
    description?: MultiLanguageModel | undefined;
    documentation?: ResourceModel[] | undefined;
    endpointDescriptions?: ResourceModel[] | undefined;
    endpointUrls?: ResourceModel[] | undefined;
    id?: string;
    identifiers?: string[] | undefined;
    issued?: Date | undefined;
    keywords?: KeywordModel[] | undefined;
    landingPages?: ResourceModel[] | undefined;
    license?: VocabularyEntryModel | undefined;
    modified?: Date | undefined;
    previousVersion?: IdModel | undefined;
    publicationLevel?: PublicationLevel;
    publicationLevelProposal?: PublicationLevel | undefined;
    publisher?: AgentModel | undefined;
    registrationStatus?: RegistrationStatus;
    registrationStatusProposal?: RegistrationStatus | undefined;
    responsibleDeputy?: IopPersonModel | undefined;
    responsiblePerson?: IopPersonModel | undefined;
    servesDatasets?: IdModel[] | undefined;
    system!: SystemInfoModel | undefined;
    themes?: VocabularyEntryModel[] | undefined;
    title?: MultiLanguageModel | undefined;
    version?: string | undefined;
    versionNotes?: MultiLanguageModel | undefined;

    constructor(data?: IDataServiceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessRights = _data["accessRights"] ? VocabularyEntryModel.fromJS(_data["accessRights"]) : undefined as any;
            if (Array.isArray(_data["conformsTo"])) {
                this.conformsTo = [] as any;
                for (let item of _data["conformsTo"])
                    this.conformsTo!.push(ResourceModel.fromJS(item));
            }
            if (Array.isArray(_data["contactPoints"])) {
                this.contactPoints = [] as any;
                for (let item of _data["contactPoints"])
                    this.contactPoints!.push(VCardModel.fromJS(item));
            }
            this.description = _data["description"] ? MultiLanguageModel.fromJS(_data["description"]) : undefined as any;
            if (Array.isArray(_data["documentation"])) {
                this.documentation = [] as any;
                for (let item of _data["documentation"])
                    this.documentation!.push(ResourceModel.fromJS(item));
            }
            if (Array.isArray(_data["endpointDescriptions"])) {
                this.endpointDescriptions = [] as any;
                for (let item of _data["endpointDescriptions"])
                    this.endpointDescriptions!.push(ResourceModel.fromJS(item));
            }
            if (Array.isArray(_data["endpointUrls"])) {
                this.endpointUrls = [] as any;
                for (let item of _data["endpointUrls"])
                    this.endpointUrls!.push(ResourceModel.fromJS(item));
            }
            this.id = _data["id"];
            if (Array.isArray(_data["identifiers"])) {
                this.identifiers = [] as any;
                for (let item of _data["identifiers"])
                    this.identifiers!.push(item);
            }
            this.issued = _data["issued"] ? new Date(_data["issued"].toString()) : undefined as any;
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(KeywordModel.fromJS(item));
            }
            if (Array.isArray(_data["landingPages"])) {
                this.landingPages = [] as any;
                for (let item of _data["landingPages"])
                    this.landingPages!.push(ResourceModel.fromJS(item));
            }
            this.license = _data["license"] ? VocabularyEntryModel.fromJS(_data["license"]) : undefined as any;
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.previousVersion = _data["previousVersion"] ? IdModel.fromJS(_data["previousVersion"]) : undefined as any;
            this.publicationLevel = _data["publicationLevel"];
            this.publicationLevelProposal = _data["publicationLevelProposal"];
            this.publisher = _data["publisher"] ? AgentModel.fromJS(_data["publisher"]) : undefined as any;
            this.registrationStatus = _data["registrationStatus"];
            this.registrationStatusProposal = _data["registrationStatusProposal"];
            this.responsibleDeputy = _data["responsibleDeputy"] ? IopPersonModel.fromJS(_data["responsibleDeputy"]) : undefined as any;
            this.responsiblePerson = _data["responsiblePerson"] ? IopPersonModel.fromJS(_data["responsiblePerson"]) : undefined as any;
            if (Array.isArray(_data["servesDatasets"])) {
                this.servesDatasets = [] as any;
                for (let item of _data["servesDatasets"])
                    this.servesDatasets!.push(IdModel.fromJS(item));
            }
            this.system = _data["system"] ? SystemInfoModel.fromJS(_data["system"]) : undefined as any;
            if (Array.isArray(_data["themes"])) {
                this.themes = [] as any;
                for (let item of _data["themes"])
                    this.themes!.push(VocabularyEntryModel.fromJS(item));
            }
            this.title = _data["title"] ? MultiLanguageModel.fromJS(_data["title"]) : undefined as any;
            this.version = _data["version"];
            this.versionNotes = _data["versionNotes"] ? MultiLanguageModel.fromJS(_data["versionNotes"]) : undefined as any;
        }
    }

    static fromJS(data: any): DataServiceModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataServiceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessRights"] = this.accessRights ? this.accessRights.toJSON() : undefined as any;
        if (Array.isArray(this.conformsTo)) {
            data["conformsTo"] = [];
            for (let item of this.conformsTo)
                data["conformsTo"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.contactPoints)) {
            data["contactPoints"] = [];
            for (let item of this.contactPoints)
                data["contactPoints"].push(item ? item.toJSON() : undefined as any);
        }
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        if (Array.isArray(this.documentation)) {
            data["documentation"] = [];
            for (let item of this.documentation)
                data["documentation"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.endpointDescriptions)) {
            data["endpointDescriptions"] = [];
            for (let item of this.endpointDescriptions)
                data["endpointDescriptions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.endpointUrls)) {
            data["endpointUrls"] = [];
            for (let item of this.endpointUrls)
                data["endpointUrls"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        if (Array.isArray(this.identifiers)) {
            data["identifiers"] = [];
            for (let item of this.identifiers)
                data["identifiers"].push(item);
        }
        data["issued"] = this.issued ? this.issued.toISOString() : undefined as any;
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.landingPages)) {
            data["landingPages"] = [];
            for (let item of this.landingPages)
                data["landingPages"].push(item ? item.toJSON() : undefined as any);
        }
        data["license"] = this.license ? this.license.toJSON() : undefined as any;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["previousVersion"] = this.previousVersion ? this.previousVersion.toJSON() : undefined as any;
        data["publicationLevel"] = this.publicationLevel;
        data["publicationLevelProposal"] = this.publicationLevelProposal;
        data["publisher"] = this.publisher ? this.publisher.toJSON() : undefined as any;
        data["registrationStatus"] = this.registrationStatus;
        data["registrationStatusProposal"] = this.registrationStatusProposal;
        data["responsibleDeputy"] = this.responsibleDeputy ? this.responsibleDeputy.toJSON() : undefined as any;
        data["responsiblePerson"] = this.responsiblePerson ? this.responsiblePerson.toJSON() : undefined as any;
        if (Array.isArray(this.servesDatasets)) {
            data["servesDatasets"] = [];
            for (let item of this.servesDatasets)
                data["servesDatasets"].push(item ? item.toJSON() : undefined as any);
        }
        data["system"] = this.system ? this.system.toJSON() : undefined as any;
        if (Array.isArray(this.themes)) {
            data["themes"] = [];
            for (let item of this.themes)
                data["themes"].push(item ? item.toJSON() : undefined as any);
        }
        data["title"] = this.title ? this.title.toJSON() : undefined as any;
        data["version"] = this.version;
        data["versionNotes"] = this.versionNotes ? this.versionNotes.toJSON() : undefined as any;
        return data;
    }
}

export interface IDataServiceModel {
    accessRights?: VocabularyEntryModel | undefined;
    conformsTo?: ResourceModel[] | undefined;
    contactPoints?: VCardModel[] | undefined;
    description?: MultiLanguageModel | undefined;
    documentation?: ResourceModel[] | undefined;
    endpointDescriptions?: ResourceModel[] | undefined;
    endpointUrls?: ResourceModel[] | undefined;
    id?: string;
    identifiers?: string[] | undefined;
    issued?: Date | undefined;
    keywords?: KeywordModel[] | undefined;
    landingPages?: ResourceModel[] | undefined;
    license?: VocabularyEntryModel | undefined;
    modified?: Date | undefined;
    previousVersion?: IdModel | undefined;
    publicationLevel?: PublicationLevel;
    publicationLevelProposal?: PublicationLevel | undefined;
    publisher?: AgentModel | undefined;
    registrationStatus?: RegistrationStatus;
    registrationStatusProposal?: RegistrationStatus | undefined;
    responsibleDeputy?: IopPersonModel | undefined;
    responsiblePerson?: IopPersonModel | undefined;
    servesDatasets?: IdModel[] | undefined;
    system: SystemInfoModel | undefined;
    themes?: VocabularyEntryModel[] | undefined;
    title?: MultiLanguageModel | undefined;
    version?: string | undefined;
    versionNotes?: MultiLanguageModel | undefined;
}

export class DataServiceVersionSummary implements IDataServiceVersionSummary {
    endpointUrls?: Resource[] | undefined;
    id?: string;
    title?: MultiLanguage | undefined;
    version?: string | undefined;

    constructor(data?: IDataServiceVersionSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["endpointUrls"])) {
                this.endpointUrls = [] as any;
                for (let item of _data["endpointUrls"])
                    this.endpointUrls!.push(Resource.fromJS(item));
            }
            this.id = _data["id"];
            this.title = _data["title"] ? MultiLanguage.fromJS(_data["title"]) : undefined as any;
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): DataServiceVersionSummary {
        data = typeof data === 'object' ? data : {};
        let result = new DataServiceVersionSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.endpointUrls)) {
            data["endpointUrls"] = [];
            for (let item of this.endpointUrls)
                data["endpointUrls"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        data["title"] = this.title ? this.title.toJSON() : undefined as any;
        data["version"] = this.version;
        return data;
    }
}

export interface IDataServiceVersionSummary {
    endpointUrls?: Resource[] | undefined;
    id?: string;
    title?: MultiLanguage | undefined;
    version?: string | undefined;
}

export class Dataset implements IDataset {
    accessRights?: VocabularyEntry | undefined;
    confidentialityPerson?: VocabularyEntry | undefined;
    conformTos?: Resource[] | undefined;
    contactPoints?: Vcard[] | undefined;
    dataOwner?: string | undefined;
    description?: MultiLanguage | undefined;
    distributions?: DcatDistributionModel[] | undefined;
    documents?: Resource[] | undefined;
    frequency?: VocabularyEntry | undefined;
    geoIvId?: VocabularyEntry[] | undefined;
    id?: string;
    identifiers?: string[] | undefined;
    image?: Resource[] | undefined;
    isReferencedBy?: Resource[] | undefined;
    keywords?: KeywordModel[] | undefined;
    landingPages?: Resource[] | undefined;
    languages?: string[] | undefined;
    lastUpdated?: Date | undefined;
    nextVersions?: DatasetVersionSummary[] | undefined;
    previousVersion?: DatasetVersionSummary | undefined;
    processId?: string | undefined;
    publicationLevel?: PublicationLevel;
    publicationLevelProposal?: PublicationLevel | undefined;
    published?: Date | undefined;
    publisherName?: MultiLanguage | undefined;
    qualifiedAttribution?: QualifiedAttribution[] | undefined;
    qualifiedAttributionComplement?: MultiLanguage | undefined;
    qualifiedRelation?: QualifiedRelation[] | undefined;
    registrationStatus?: RegistrationStatus;
    registrationStatusProposal?: RegistrationStatus | undefined;
    relations?: Resource[] | undefined;
    responsiblePerson?: Person | undefined;
    responsiblePersonDeputy?: Person | undefined;
    retentionPeriod?: Date | undefined;
    retentionPeriodDescription?: MultiLanguage | undefined;
    system?: SystemInfoModel | undefined;
    spatialCoverages?: string[] | undefined;
    status?: string | undefined;
    temporalCoverage?: PeriodOfTime[] | undefined;
    themes?: VocabularyEntry[] | undefined;
    title?: MultiLanguage | undefined;
    version?: string | undefined;
    versionNotes?: MultiLanguage | undefined;

    constructor(data?: IDataset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessRights = _data["accessRights"] ? VocabularyEntry.fromJS(_data["accessRights"]) : undefined as any;
            this.confidentialityPerson = _data["confidentialityPerson"] ? VocabularyEntry.fromJS(_data["confidentialityPerson"]) : undefined as any;
            if (Array.isArray(_data["conformTos"])) {
                this.conformTos = [] as any;
                for (let item of _data["conformTos"])
                    this.conformTos!.push(Resource.fromJS(item));
            }
            if (Array.isArray(_data["contactPoints"])) {
                this.contactPoints = [] as any;
                for (let item of _data["contactPoints"])
                    this.contactPoints!.push(Vcard.fromJS(item));
            }
            this.dataOwner = _data["dataOwner"];
            this.description = _data["description"] ? MultiLanguage.fromJS(_data["description"]) : undefined as any;
            if (Array.isArray(_data["distributions"])) {
                this.distributions = [] as any;
                for (let item of _data["distributions"])
                    this.distributions!.push(DcatDistributionModel.fromJS(item));
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(Resource.fromJS(item));
            }
            this.frequency = _data["frequency"] ? VocabularyEntry.fromJS(_data["frequency"]) : undefined as any;
            if (Array.isArray(_data["geoIvId"])) {
                this.geoIvId = [] as any;
                for (let item of _data["geoIvId"])
                    this.geoIvId!.push(VocabularyEntry.fromJS(item));
            }
            this.id = _data["id"];
            if (Array.isArray(_data["identifiers"])) {
                this.identifiers = [] as any;
                for (let item of _data["identifiers"])
                    this.identifiers!.push(item);
            }
            if (Array.isArray(_data["image"])) {
                this.image = [] as any;
                for (let item of _data["image"])
                    this.image!.push(Resource.fromJS(item));
            }
            if (Array.isArray(_data["isReferencedBy"])) {
                this.isReferencedBy = [] as any;
                for (let item of _data["isReferencedBy"])
                    this.isReferencedBy!.push(Resource.fromJS(item));
            }
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(KeywordModel.fromJS(item));
            }
            if (Array.isArray(_data["landingPages"])) {
                this.landingPages = [] as any;
                for (let item of _data["landingPages"])
                    this.landingPages!.push(Resource.fromJS(item));
            }
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(item);
            }
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : undefined as any;
            if (Array.isArray(_data["nextVersions"])) {
                this.nextVersions = [] as any;
                for (let item of _data["nextVersions"])
                    this.nextVersions!.push(DatasetVersionSummary.fromJS(item));
            }
            this.previousVersion = _data["previousVersion"] ? DatasetVersionSummary.fromJS(_data["previousVersion"]) : undefined as any;
            this.processId = _data["processId"];
            this.publicationLevel = _data["publicationLevel"];
            this.publicationLevelProposal = _data["publicationLevelProposal"];
            this.published = _data["published"] ? new Date(_data["published"].toString()) : undefined as any;
            this.publisherName = _data["publisherName"] ? MultiLanguage.fromJS(_data["publisherName"]) : undefined as any;
            if (Array.isArray(_data["qualifiedAttribution"])) {
                this.qualifiedAttribution = [] as any;
                for (let item of _data["qualifiedAttribution"])
                    this.qualifiedAttribution!.push(QualifiedAttribution.fromJS(item));
            }
            this.qualifiedAttributionComplement = _data["qualifiedAttributionComplement"] ? MultiLanguage.fromJS(_data["qualifiedAttributionComplement"]) : undefined as any;
            if (Array.isArray(_data["qualifiedRelation"])) {
                this.qualifiedRelation = [] as any;
                for (let item of _data["qualifiedRelation"])
                    this.qualifiedRelation!.push(QualifiedRelation.fromJS(item));
            }
            this.registrationStatus = _data["registrationStatus"];
            this.registrationStatusProposal = _data["registrationStatusProposal"];
            if (Array.isArray(_data["relations"])) {
                this.relations = [] as any;
                for (let item of _data["relations"])
                    this.relations!.push(Resource.fromJS(item));
            }
            this.responsiblePerson = _data["responsiblePerson"] ? Person.fromJS(_data["responsiblePerson"]) : undefined as any;
            this.responsiblePersonDeputy = _data["responsiblePersonDeputy"] ? Person.fromJS(_data["responsiblePersonDeputy"]) : undefined as any;
            this.retentionPeriod = _data["retentionPeriod"] ? new Date(_data["retentionPeriod"].toString()) : undefined as any;
            this.retentionPeriodDescription = _data["retentionPeriodDescription"] ? MultiLanguage.fromJS(_data["retentionPeriodDescription"]) : undefined as any;
            this.system = _data["system"] ? SystemInfoModel.fromJS(_data["system"]) : undefined as any;
            if (Array.isArray(_data["spatialCoverages"])) {
                this.spatialCoverages = [] as any;
                for (let item of _data["spatialCoverages"])
                    this.spatialCoverages!.push(item);
            }
            this.status = _data["status"];
            if (Array.isArray(_data["temporalCoverage"])) {
                this.temporalCoverage = [] as any;
                for (let item of _data["temporalCoverage"])
                    this.temporalCoverage!.push(PeriodOfTime.fromJS(item));
            }
            if (Array.isArray(_data["themes"])) {
                this.themes = [] as any;
                for (let item of _data["themes"])
                    this.themes!.push(VocabularyEntry.fromJS(item));
            }
            this.title = _data["title"] ? MultiLanguage.fromJS(_data["title"]) : undefined as any;
            this.version = _data["version"];
            this.versionNotes = _data["versionNotes"] ? MultiLanguage.fromJS(_data["versionNotes"]) : undefined as any;
        }
    }

    static fromJS(data: any): Dataset {
        data = typeof data === 'object' ? data : {};
        let result = new Dataset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessRights"] = this.accessRights ? this.accessRights.toJSON() : undefined as any;
        data["confidentialityPerson"] = this.confidentialityPerson ? this.confidentialityPerson.toJSON() : undefined as any;
        if (Array.isArray(this.conformTos)) {
            data["conformTos"] = [];
            for (let item of this.conformTos)
                data["conformTos"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.contactPoints)) {
            data["contactPoints"] = [];
            for (let item of this.contactPoints)
                data["contactPoints"].push(item ? item.toJSON() : undefined as any);
        }
        data["dataOwner"] = this.dataOwner;
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        if (Array.isArray(this.distributions)) {
            data["distributions"] = [];
            for (let item of this.distributions)
                data["distributions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item ? item.toJSON() : undefined as any);
        }
        data["frequency"] = this.frequency ? this.frequency.toJSON() : undefined as any;
        if (Array.isArray(this.geoIvId)) {
            data["geoIvId"] = [];
            for (let item of this.geoIvId)
                data["geoIvId"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        if (Array.isArray(this.identifiers)) {
            data["identifiers"] = [];
            for (let item of this.identifiers)
                data["identifiers"].push(item);
        }
        if (Array.isArray(this.image)) {
            data["image"] = [];
            for (let item of this.image)
                data["image"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.isReferencedBy)) {
            data["isReferencedBy"] = [];
            for (let item of this.isReferencedBy)
                data["isReferencedBy"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.landingPages)) {
            data["landingPages"] = [];
            for (let item of this.landingPages)
                data["landingPages"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item);
        }
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : undefined as any;
        if (Array.isArray(this.nextVersions)) {
            data["nextVersions"] = [];
            for (let item of this.nextVersions)
                data["nextVersions"].push(item ? item.toJSON() : undefined as any);
        }
        data["previousVersion"] = this.previousVersion ? this.previousVersion.toJSON() : undefined as any;
        data["processId"] = this.processId;
        data["publicationLevel"] = this.publicationLevel;
        data["publicationLevelProposal"] = this.publicationLevelProposal;
        data["published"] = this.published ? this.published.toISOString() : undefined as any;
        data["publisherName"] = this.publisherName ? this.publisherName.toJSON() : undefined as any;
        if (Array.isArray(this.qualifiedAttribution)) {
            data["qualifiedAttribution"] = [];
            for (let item of this.qualifiedAttribution)
                data["qualifiedAttribution"].push(item ? item.toJSON() : undefined as any);
        }
        data["qualifiedAttributionComplement"] = this.qualifiedAttributionComplement ? this.qualifiedAttributionComplement.toJSON() : undefined as any;
        if (Array.isArray(this.qualifiedRelation)) {
            data["qualifiedRelation"] = [];
            for (let item of this.qualifiedRelation)
                data["qualifiedRelation"].push(item ? item.toJSON() : undefined as any);
        }
        data["registrationStatus"] = this.registrationStatus;
        data["registrationStatusProposal"] = this.registrationStatusProposal;
        if (Array.isArray(this.relations)) {
            data["relations"] = [];
            for (let item of this.relations)
                data["relations"].push(item ? item.toJSON() : undefined as any);
        }
        data["responsiblePerson"] = this.responsiblePerson ? this.responsiblePerson.toJSON() : undefined as any;
        data["responsiblePersonDeputy"] = this.responsiblePersonDeputy ? this.responsiblePersonDeputy.toJSON() : undefined as any;
        data["retentionPeriod"] = this.retentionPeriod ? this.retentionPeriod.toISOString() : undefined as any;
        data["retentionPeriodDescription"] = this.retentionPeriodDescription ? this.retentionPeriodDescription.toJSON() : undefined as any;
        data["system"] = this.system ? this.system.toJSON() : undefined as any;
        if (Array.isArray(this.spatialCoverages)) {
            data["spatialCoverages"] = [];
            for (let item of this.spatialCoverages)
                data["spatialCoverages"].push(item);
        }
        data["status"] = this.status;
        if (Array.isArray(this.temporalCoverage)) {
            data["temporalCoverage"] = [];
            for (let item of this.temporalCoverage)
                data["temporalCoverage"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.themes)) {
            data["themes"] = [];
            for (let item of this.themes)
                data["themes"].push(item ? item.toJSON() : undefined as any);
        }
        data["title"] = this.title ? this.title.toJSON() : undefined as any;
        data["version"] = this.version;
        data["versionNotes"] = this.versionNotes ? this.versionNotes.toJSON() : undefined as any;
        return data;
    }
}

export interface IDataset {
    accessRights?: VocabularyEntry | undefined;
    confidentialityPerson?: VocabularyEntry | undefined;
    conformTos?: Resource[] | undefined;
    contactPoints?: Vcard[] | undefined;
    dataOwner?: string | undefined;
    description?: MultiLanguage | undefined;
    distributions?: DcatDistributionModel[] | undefined;
    documents?: Resource[] | undefined;
    frequency?: VocabularyEntry | undefined;
    geoIvId?: VocabularyEntry[] | undefined;
    id?: string;
    identifiers?: string[] | undefined;
    image?: Resource[] | undefined;
    isReferencedBy?: Resource[] | undefined;
    keywords?: KeywordModel[] | undefined;
    landingPages?: Resource[] | undefined;
    languages?: string[] | undefined;
    lastUpdated?: Date | undefined;
    nextVersions?: DatasetVersionSummary[] | undefined;
    previousVersion?: DatasetVersionSummary | undefined;
    processId?: string | undefined;
    publicationLevel?: PublicationLevel;
    publicationLevelProposal?: PublicationLevel | undefined;
    published?: Date | undefined;
    publisherName?: MultiLanguage | undefined;
    qualifiedAttribution?: QualifiedAttribution[] | undefined;
    qualifiedAttributionComplement?: MultiLanguage | undefined;
    qualifiedRelation?: QualifiedRelation[] | undefined;
    registrationStatus?: RegistrationStatus;
    registrationStatusProposal?: RegistrationStatus | undefined;
    relations?: Resource[] | undefined;
    responsiblePerson?: Person | undefined;
    responsiblePersonDeputy?: Person | undefined;
    retentionPeriod?: Date | undefined;
    retentionPeriodDescription?: MultiLanguage | undefined;
    system?: SystemInfoModel | undefined;
    spatialCoverages?: string[] | undefined;
    status?: string | undefined;
    temporalCoverage?: PeriodOfTime[] | undefined;
    themes?: VocabularyEntry[] | undefined;
    title?: MultiLanguage | undefined;
    version?: string | undefined;
    versionNotes?: MultiLanguage | undefined;
}

export class DatasetQualityAnswerOption implements IDatasetQualityAnswerOption {
    detail?: MultiLanguage | undefined;
    detailMandatory?: boolean;
    id?: string;
    name?: MultiLanguage | undefined;
    value?: string | undefined;

    constructor(data?: IDatasetQualityAnswerOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.detail = _data["detail"] ? MultiLanguage.fromJS(_data["detail"]) : undefined as any;
            this.detailMandatory = _data["detailMandatory"];
            this.id = _data["id"];
            this.name = _data["name"] ? MultiLanguage.fromJS(_data["name"]) : undefined as any;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): DatasetQualityAnswerOption {
        data = typeof data === 'object' ? data : {};
        let result = new DatasetQualityAnswerOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["detail"] = this.detail ? this.detail.toJSON() : undefined as any;
        data["detailMandatory"] = this.detailMandatory;
        data["id"] = this.id;
        data["name"] = this.name ? this.name.toJSON() : undefined as any;
        data["value"] = this.value;
        return data;
    }
}

export interface IDatasetQualityAnswerOption {
    detail?: MultiLanguage | undefined;
    detailMandatory?: boolean;
    id?: string;
    name?: MultiLanguage | undefined;
    value?: string | undefined;
}

export class DatasetQualityInformation implements IDatasetQualityInformation {
    answerId?: string;
    detail?: string | undefined;
    id?: string;
    questionId?: string;

    constructor(data?: IDatasetQualityInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.answerId = _data["answerId"];
            this.detail = _data["detail"];
            this.id = _data["id"];
            this.questionId = _data["questionId"];
        }
    }

    static fromJS(data: any): DatasetQualityInformation {
        data = typeof data === 'object' ? data : {};
        let result = new DatasetQualityInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["answerId"] = this.answerId;
        data["detail"] = this.detail;
        data["id"] = this.id;
        data["questionId"] = this.questionId;
        return data;
    }
}

export interface IDatasetQualityInformation {
    answerId?: string;
    detail?: string | undefined;
    id?: string;
    questionId?: string;
}

export class DatasetQualityInformationData implements IDatasetQualityInformationData {
    datasetId?: string;
    documentation?: DatasetQualityInformationLink[] | undefined;
    qualityInformations?: DatasetQualityInformation[] | undefined;

    constructor(data?: IDatasetQualityInformationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datasetId = _data["datasetId"];
            if (Array.isArray(_data["documentation"])) {
                this.documentation = [] as any;
                for (let item of _data["documentation"])
                    this.documentation!.push(DatasetQualityInformationLink.fromJS(item));
            }
            if (Array.isArray(_data["qualityInformations"])) {
                this.qualityInformations = [] as any;
                for (let item of _data["qualityInformations"])
                    this.qualityInformations!.push(DatasetQualityInformation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DatasetQualityInformationData {
        data = typeof data === 'object' ? data : {};
        let result = new DatasetQualityInformationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datasetId"] = this.datasetId;
        if (Array.isArray(this.documentation)) {
            data["documentation"] = [];
            for (let item of this.documentation)
                data["documentation"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.qualityInformations)) {
            data["qualityInformations"] = [];
            for (let item of this.qualityInformations)
                data["qualityInformations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDatasetQualityInformationData {
    datasetId?: string;
    documentation?: DatasetQualityInformationLink[] | undefined;
    qualityInformations?: DatasetQualityInformation[] | undefined;
}

export class DatasetQualityInformationLink implements IDatasetQualityInformationLink {
    href?: string | undefined;
    id?: string;
    label?: MultiLanguage | undefined;

    constructor(data?: IDatasetQualityInformationLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.href = _data["href"];
            this.id = _data["id"];
            this.label = _data["label"] ? MultiLanguage.fromJS(_data["label"]) : undefined as any;
        }
    }

    static fromJS(data: any): DatasetQualityInformationLink {
        data = typeof data === 'object' ? data : {};
        let result = new DatasetQualityInformationLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["href"] = this.href;
        data["id"] = this.id;
        data["label"] = this.label ? this.label.toJSON() : undefined as any;
        return data;
    }
}

export interface IDatasetQualityInformationLink {
    href?: string | undefined;
    id?: string;
    label?: MultiLanguage | undefined;
}

export class DatasetQualityQuestion implements IDatasetQualityQuestion {
    answerOptions?: DatasetQualityAnswerOption[] | undefined;
    id?: string;
    mandatory?: boolean;
    order?: number;
    question?: MultiLanguage | undefined;

    constructor(data?: IDatasetQualityQuestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["answerOptions"])) {
                this.answerOptions = [] as any;
                for (let item of _data["answerOptions"])
                    this.answerOptions!.push(DatasetQualityAnswerOption.fromJS(item));
            }
            this.id = _data["id"];
            this.mandatory = _data["mandatory"];
            this.order = _data["order"];
            this.question = _data["question"] ? MultiLanguage.fromJS(_data["question"]) : undefined as any;
        }
    }

    static fromJS(data: any): DatasetQualityQuestion {
        data = typeof data === 'object' ? data : {};
        let result = new DatasetQualityQuestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.answerOptions)) {
            data["answerOptions"] = [];
            for (let item of this.answerOptions)
                data["answerOptions"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        data["mandatory"] = this.mandatory;
        data["order"] = this.order;
        data["question"] = this.question ? this.question.toJSON() : undefined as any;
        return data;
    }
}

export interface IDatasetQualityQuestion {
    answerOptions?: DatasetQualityAnswerOption[] | undefined;
    id?: string;
    mandatory?: boolean;
    order?: number;
    question?: MultiLanguage | undefined;
}

export class DatasetReferenceModel implements IDatasetReferenceModel {
    datasetId?: string;
    identifier?: string | undefined;
    title?: MultiLanguageModel | undefined;
    publisherName?: MultiLanguageModel | undefined;

    constructor(data?: IDatasetReferenceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datasetId = _data["datasetId"];
            this.identifier = _data["identifier"];
            this.title = _data["title"] ? MultiLanguageModel.fromJS(_data["title"]) : undefined as any;
            this.publisherName = _data["publisherName"] ? MultiLanguageModel.fromJS(_data["publisherName"]) : undefined as any;
        }
    }

    static fromJS(data: any): DatasetReferenceModel {
        data = typeof data === 'object' ? data : {};
        let result = new DatasetReferenceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datasetId"] = this.datasetId;
        data["identifier"] = this.identifier;
        data["title"] = this.title ? this.title.toJSON() : undefined as any;
        data["publisherName"] = this.publisherName ? this.publisherName.toJSON() : undefined as any;
        return data;
    }
}

export interface IDatasetReferenceModel {
    datasetId?: string;
    identifier?: string | undefined;
    title?: MultiLanguageModel | undefined;
    publisherName?: MultiLanguageModel | undefined;
}

export class DatasetVersionSummary implements IDatasetVersionSummary {
    id?: string;
    identifiers?: string[] | undefined;
    title?: MultiLanguage | undefined;
    version?: string | undefined;

    constructor(data?: IDatasetVersionSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["identifiers"])) {
                this.identifiers = [] as any;
                for (let item of _data["identifiers"])
                    this.identifiers!.push(item);
            }
            this.title = _data["title"] ? MultiLanguage.fromJS(_data["title"]) : undefined as any;
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): DatasetVersionSummary {
        data = typeof data === 'object' ? data : {};
        let result = new DatasetVersionSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.identifiers)) {
            data["identifiers"] = [];
            for (let item of this.identifiers)
                data["identifiers"].push(item);
        }
        data["title"] = this.title ? this.title.toJSON() : undefined as any;
        data["version"] = this.version;
        return data;
    }
}

export interface IDatasetVersionSummary {
    id?: string;
    identifiers?: string[] | undefined;
    title?: MultiLanguage | undefined;
    version?: string | undefined;
}

export class DcatCatalog implements IDcatCatalog {
    description?: MultiLanguage | undefined;
    id?: string;
    publisher?: Agent | undefined;
    themeTaxonomy?: string[] | undefined;
    title?: MultiLanguage | undefined;
    system?: SystemInfoModel | undefined;

    constructor(data?: IDcatCatalog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"] ? MultiLanguage.fromJS(_data["description"]) : undefined as any;
            this.id = _data["id"];
            this.publisher = _data["publisher"] ? Agent.fromJS(_data["publisher"]) : undefined as any;
            if (Array.isArray(_data["themeTaxonomy"])) {
                this.themeTaxonomy = [] as any;
                for (let item of _data["themeTaxonomy"])
                    this.themeTaxonomy!.push(item);
            }
            this.title = _data["title"] ? MultiLanguage.fromJS(_data["title"]) : undefined as any;
            this.system = _data["system"] ? SystemInfoModel.fromJS(_data["system"]) : undefined as any;
        }
    }

    static fromJS(data: any): DcatCatalog {
        data = typeof data === 'object' ? data : {};
        let result = new DcatCatalog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        data["id"] = this.id;
        data["publisher"] = this.publisher ? this.publisher.toJSON() : undefined as any;
        if (Array.isArray(this.themeTaxonomy)) {
            data["themeTaxonomy"] = [];
            for (let item of this.themeTaxonomy)
                data["themeTaxonomy"].push(item);
        }
        data["title"] = this.title ? this.title.toJSON() : undefined as any;
        data["system"] = this.system ? this.system.toJSON() : undefined as any;
        return data;
    }
}

export interface IDcatCatalog {
    description?: MultiLanguage | undefined;
    id?: string;
    publisher?: Agent | undefined;
    themeTaxonomy?: string[] | undefined;
    title?: MultiLanguage | undefined;
    system?: SystemInfoModel | undefined;
}

export class DcatCatalogModel implements IDcatCatalogModel {
    description!: MultiLanguageModel | undefined;
    id?: string;
    publisher!: AgentModel | undefined;
    system!: SystemInfoModel | undefined;
    themeTaxonomy?: string[] | undefined;
    title!: MultiLanguageModel | undefined;

    constructor(data?: IDcatCatalogModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"] ? MultiLanguageModel.fromJS(_data["description"]) : undefined as any;
            this.id = _data["id"];
            this.publisher = _data["publisher"] ? AgentModel.fromJS(_data["publisher"]) : undefined as any;
            this.system = _data["system"] ? SystemInfoModel.fromJS(_data["system"]) : undefined as any;
            if (Array.isArray(_data["themeTaxonomy"])) {
                this.themeTaxonomy = [] as any;
                for (let item of _data["themeTaxonomy"])
                    this.themeTaxonomy!.push(item);
            }
            this.title = _data["title"] ? MultiLanguageModel.fromJS(_data["title"]) : undefined as any;
        }
    }

    static fromJS(data: any): DcatCatalogModel {
        data = typeof data === 'object' ? data : {};
        let result = new DcatCatalogModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        data["id"] = this.id;
        data["publisher"] = this.publisher ? this.publisher.toJSON() : undefined as any;
        data["system"] = this.system ? this.system.toJSON() : undefined as any;
        if (Array.isArray(this.themeTaxonomy)) {
            data["themeTaxonomy"] = [];
            for (let item of this.themeTaxonomy)
                data["themeTaxonomy"].push(item);
        }
        data["title"] = this.title ? this.title.toJSON() : undefined as any;
        return data;
    }
}

export interface IDcatCatalogModel {
    description: MultiLanguageModel | undefined;
    id?: string;
    publisher: AgentModel | undefined;
    system: SystemInfoModel | undefined;
    themeTaxonomy?: string[] | undefined;
    title: MultiLanguageModel | undefined;
}

export class DcatCatalogRecordInput implements IDcatCatalogRecordInput {
    catalogId?: string;
    catalogTitle?: MultiLanguage | undefined;
    id?: string;
    primaryTopic?: DcatCatalogResource | undefined;
    themes?: DcatVocabularyEntry[] | undefined;

    constructor(data?: IDcatCatalogRecordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.catalogId = _data["catalogId"];
            this.catalogTitle = _data["catalogTitle"] ? MultiLanguage.fromJS(_data["catalogTitle"]) : undefined as any;
            this.id = _data["id"];
            this.primaryTopic = _data["primaryTopic"] ? DcatCatalogResource.fromJS(_data["primaryTopic"]) : undefined as any;
            if (Array.isArray(_data["themes"])) {
                this.themes = [] as any;
                for (let item of _data["themes"])
                    this.themes!.push(DcatVocabularyEntry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DcatCatalogRecordInput {
        data = typeof data === 'object' ? data : {};
        let result = new DcatCatalogRecordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["catalogId"] = this.catalogId;
        data["catalogTitle"] = this.catalogTitle ? this.catalogTitle.toJSON() : undefined as any;
        data["id"] = this.id;
        data["primaryTopic"] = this.primaryTopic ? this.primaryTopic.toJSON() : undefined as any;
        if (Array.isArray(this.themes)) {
            data["themes"] = [];
            for (let item of this.themes)
                data["themes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDcatCatalogRecordInput {
    catalogId?: string;
    catalogTitle?: MultiLanguage | undefined;
    id?: string;
    primaryTopic?: DcatCatalogResource | undefined;
    themes?: DcatVocabularyEntry[] | undefined;
}

export class DcatCatalogResource implements IDcatCatalogResource {
    id?: string;
    resourceId?: string;
    resourceType?: string | undefined;

    constructor(data?: IDcatCatalogResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.resourceId = _data["resourceId"];
            this.resourceType = _data["resourceType"];
        }
    }

    static fromJS(data: any): DcatCatalogResource {
        data = typeof data === 'object' ? data : {};
        let result = new DcatCatalogResource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["resourceId"] = this.resourceId;
        data["resourceType"] = this.resourceType;
        return data;
    }
}

export interface IDcatCatalogResource {
    id?: string;
    resourceId?: string;
    resourceType?: string | undefined;
}

export class DcatDatasetInputModel implements IDcatDatasetInputModel {
    accessRights!: CodeInputModel | undefined;
    confidentialityPerson?: CodeInputModel | undefined;
    conformsTo?: ResourceModel[] | undefined;
    contactPoints?: VCardModel[] | undefined;
    dataOwner?: string | undefined;
    description!: MultiLanguageModel | undefined;
    distributions?: DcatDistributionInputModel[] | undefined;
    documentation?: ResourceModel[] | undefined;
    frequency?: CodeInputModel | undefined;
    geoIvIds?: CodeInputModel[] | undefined;
    identifiers?: string[] | undefined;
    images?: ResourceModel[] | undefined;
    isReferencedBy?: ResourceModel[] | undefined;
    issued?: Date | undefined;
    keywords?: KeywordModel[] | undefined;
    landingPages?: ResourceModel[] | undefined;
    languages?: CodeInputModel[] | undefined;
    modified?: Date | undefined;
    previousVersion?: IdModel | undefined;
    processId?: string | undefined;
    publisher!: IdentifierInputModel | undefined;
    qualifiedAttributions?: DcatQualifiedAttributionInputModel[] | undefined;
    qualifiedAttributionComplement?: MultiLanguageModel | undefined;
    qualifiedRelations?: DcatQualifiedRelationInputModel[] | undefined;
    relations?: ResourceModel[] | undefined;
    responsibleDeputy?: EmailInputModel | undefined;
    responsiblePerson?: EmailInputModel | undefined;
    retentionPeriod?: Date | undefined;
    retentionPeriodComplement?: MultiLanguageModel | undefined;
    spatial?: string[] | undefined;
    temporalCoverage?: PeriodOfTimeModel[] | undefined;
    themes?: CodeInputModel[] | undefined;
    title!: MultiLanguageModel | undefined;
    version?: string | undefined;
    versionNotes?: MultiLanguageModel | undefined;

    constructor(data?: IDcatDatasetInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessRights = _data["accessRights"] ? CodeInputModel.fromJS(_data["accessRights"]) : undefined as any;
            this.confidentialityPerson = _data["confidentialityPerson"] ? CodeInputModel.fromJS(_data["confidentialityPerson"]) : undefined as any;
            if (Array.isArray(_data["conformsTo"])) {
                this.conformsTo = [] as any;
                for (let item of _data["conformsTo"])
                    this.conformsTo!.push(ResourceModel.fromJS(item));
            }
            if (Array.isArray(_data["contactPoints"])) {
                this.contactPoints = [] as any;
                for (let item of _data["contactPoints"])
                    this.contactPoints!.push(VCardModel.fromJS(item));
            }
            this.dataOwner = _data["dataOwner"];
            this.description = _data["description"] ? MultiLanguageModel.fromJS(_data["description"]) : undefined as any;
            if (Array.isArray(_data["distributions"])) {
                this.distributions = [] as any;
                for (let item of _data["distributions"])
                    this.distributions!.push(DcatDistributionInputModel.fromJS(item));
            }
            if (Array.isArray(_data["documentation"])) {
                this.documentation = [] as any;
                for (let item of _data["documentation"])
                    this.documentation!.push(ResourceModel.fromJS(item));
            }
            this.frequency = _data["frequency"] ? CodeInputModel.fromJS(_data["frequency"]) : undefined as any;
            if (Array.isArray(_data["geoIvIds"])) {
                this.geoIvIds = [] as any;
                for (let item of _data["geoIvIds"])
                    this.geoIvIds!.push(CodeInputModel.fromJS(item));
            }
            if (Array.isArray(_data["identifiers"])) {
                this.identifiers = [] as any;
                for (let item of _data["identifiers"])
                    this.identifiers!.push(item);
            }
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ResourceModel.fromJS(item));
            }
            if (Array.isArray(_data["isReferencedBy"])) {
                this.isReferencedBy = [] as any;
                for (let item of _data["isReferencedBy"])
                    this.isReferencedBy!.push(ResourceModel.fromJS(item));
            }
            this.issued = _data["issued"] ? new Date(_data["issued"].toString()) : undefined as any;
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(KeywordModel.fromJS(item));
            }
            if (Array.isArray(_data["landingPages"])) {
                this.landingPages = [] as any;
                for (let item of _data["landingPages"])
                    this.landingPages!.push(ResourceModel.fromJS(item));
            }
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(CodeInputModel.fromJS(item));
            }
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.previousVersion = _data["previousVersion"] ? IdModel.fromJS(_data["previousVersion"]) : undefined as any;
            this.processId = _data["processId"];
            this.publisher = _data["publisher"] ? IdentifierInputModel.fromJS(_data["publisher"]) : undefined as any;
            if (Array.isArray(_data["qualifiedAttributions"])) {
                this.qualifiedAttributions = [] as any;
                for (let item of _data["qualifiedAttributions"])
                    this.qualifiedAttributions!.push(DcatQualifiedAttributionInputModel.fromJS(item));
            }
            this.qualifiedAttributionComplement = _data["qualifiedAttributionComplement"] ? MultiLanguageModel.fromJS(_data["qualifiedAttributionComplement"]) : undefined as any;
            if (Array.isArray(_data["qualifiedRelations"])) {
                this.qualifiedRelations = [] as any;
                for (let item of _data["qualifiedRelations"])
                    this.qualifiedRelations!.push(DcatQualifiedRelationInputModel.fromJS(item));
            }
            if (Array.isArray(_data["relations"])) {
                this.relations = [] as any;
                for (let item of _data["relations"])
                    this.relations!.push(ResourceModel.fromJS(item));
            }
            this.responsibleDeputy = _data["responsibleDeputy"] ? EmailInputModel.fromJS(_data["responsibleDeputy"]) : undefined as any;
            this.responsiblePerson = _data["responsiblePerson"] ? EmailInputModel.fromJS(_data["responsiblePerson"]) : undefined as any;
            this.retentionPeriod = _data["retentionPeriod"] ? new Date(_data["retentionPeriod"].toString()) : undefined as any;
            this.retentionPeriodComplement = _data["retentionPeriodComplement"] ? MultiLanguageModel.fromJS(_data["retentionPeriodComplement"]) : undefined as any;
            if (Array.isArray(_data["spatial"])) {
                this.spatial = [] as any;
                for (let item of _data["spatial"])
                    this.spatial!.push(item);
            }
            if (Array.isArray(_data["temporalCoverage"])) {
                this.temporalCoverage = [] as any;
                for (let item of _data["temporalCoverage"])
                    this.temporalCoverage!.push(PeriodOfTimeModel.fromJS(item));
            }
            if (Array.isArray(_data["themes"])) {
                this.themes = [] as any;
                for (let item of _data["themes"])
                    this.themes!.push(CodeInputModel.fromJS(item));
            }
            this.title = _data["title"] ? MultiLanguageModel.fromJS(_data["title"]) : undefined as any;
            this.version = _data["version"];
            this.versionNotes = _data["versionNotes"] ? MultiLanguageModel.fromJS(_data["versionNotes"]) : undefined as any;
        }
    }

    static fromJS(data: any): DcatDatasetInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new DcatDatasetInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessRights"] = this.accessRights ? this.accessRights.toJSON() : undefined as any;
        data["confidentialityPerson"] = this.confidentialityPerson ? this.confidentialityPerson.toJSON() : undefined as any;
        if (Array.isArray(this.conformsTo)) {
            data["conformsTo"] = [];
            for (let item of this.conformsTo)
                data["conformsTo"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.contactPoints)) {
            data["contactPoints"] = [];
            for (let item of this.contactPoints)
                data["contactPoints"].push(item ? item.toJSON() : undefined as any);
        }
        data["dataOwner"] = this.dataOwner;
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        if (Array.isArray(this.distributions)) {
            data["distributions"] = [];
            for (let item of this.distributions)
                data["distributions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.documentation)) {
            data["documentation"] = [];
            for (let item of this.documentation)
                data["documentation"].push(item ? item.toJSON() : undefined as any);
        }
        data["frequency"] = this.frequency ? this.frequency.toJSON() : undefined as any;
        if (Array.isArray(this.geoIvIds)) {
            data["geoIvIds"] = [];
            for (let item of this.geoIvIds)
                data["geoIvIds"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.identifiers)) {
            data["identifiers"] = [];
            for (let item of this.identifiers)
                data["identifiers"].push(item);
        }
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.isReferencedBy)) {
            data["isReferencedBy"] = [];
            for (let item of this.isReferencedBy)
                data["isReferencedBy"].push(item ? item.toJSON() : undefined as any);
        }
        data["issued"] = this.issued ? this.issued.toISOString() : undefined as any;
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.landingPages)) {
            data["landingPages"] = [];
            for (let item of this.landingPages)
                data["landingPages"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item ? item.toJSON() : undefined as any);
        }
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["previousVersion"] = this.previousVersion ? this.previousVersion.toJSON() : undefined as any;
        data["processId"] = this.processId;
        data["publisher"] = this.publisher ? this.publisher.toJSON() : undefined as any;
        if (Array.isArray(this.qualifiedAttributions)) {
            data["qualifiedAttributions"] = [];
            for (let item of this.qualifiedAttributions)
                data["qualifiedAttributions"].push(item ? item.toJSON() : undefined as any);
        }
        data["qualifiedAttributionComplement"] = this.qualifiedAttributionComplement ? this.qualifiedAttributionComplement.toJSON() : undefined as any;
        if (Array.isArray(this.qualifiedRelations)) {
            data["qualifiedRelations"] = [];
            for (let item of this.qualifiedRelations)
                data["qualifiedRelations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.relations)) {
            data["relations"] = [];
            for (let item of this.relations)
                data["relations"].push(item ? item.toJSON() : undefined as any);
        }
        data["responsibleDeputy"] = this.responsibleDeputy ? this.responsibleDeputy.toJSON() : undefined as any;
        data["responsiblePerson"] = this.responsiblePerson ? this.responsiblePerson.toJSON() : undefined as any;
        data["retentionPeriod"] = this.retentionPeriod ? this.retentionPeriod.toISOString() : undefined as any;
        data["retentionPeriodComplement"] = this.retentionPeriodComplement ? this.retentionPeriodComplement.toJSON() : undefined as any;
        if (Array.isArray(this.spatial)) {
            data["spatial"] = [];
            for (let item of this.spatial)
                data["spatial"].push(item);
        }
        if (Array.isArray(this.temporalCoverage)) {
            data["temporalCoverage"] = [];
            for (let item of this.temporalCoverage)
                data["temporalCoverage"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.themes)) {
            data["themes"] = [];
            for (let item of this.themes)
                data["themes"].push(item ? item.toJSON() : undefined as any);
        }
        data["title"] = this.title ? this.title.toJSON() : undefined as any;
        data["version"] = this.version;
        data["versionNotes"] = this.versionNotes ? this.versionNotes.toJSON() : undefined as any;
        return data;
    }
}

export interface IDcatDatasetInputModel {
    accessRights: CodeInputModel | undefined;
    confidentialityPerson?: CodeInputModel | undefined;
    conformsTo?: ResourceModel[] | undefined;
    contactPoints?: VCardModel[] | undefined;
    dataOwner?: string | undefined;
    description: MultiLanguageModel | undefined;
    distributions?: DcatDistributionInputModel[] | undefined;
    documentation?: ResourceModel[] | undefined;
    frequency?: CodeInputModel | undefined;
    geoIvIds?: CodeInputModel[] | undefined;
    identifiers?: string[] | undefined;
    images?: ResourceModel[] | undefined;
    isReferencedBy?: ResourceModel[] | undefined;
    issued?: Date | undefined;
    keywords?: KeywordModel[] | undefined;
    landingPages?: ResourceModel[] | undefined;
    languages?: CodeInputModel[] | undefined;
    modified?: Date | undefined;
    previousVersion?: IdModel | undefined;
    processId?: string | undefined;
    publisher: IdentifierInputModel | undefined;
    qualifiedAttributions?: DcatQualifiedAttributionInputModel[] | undefined;
    qualifiedAttributionComplement?: MultiLanguageModel | undefined;
    qualifiedRelations?: DcatQualifiedRelationInputModel[] | undefined;
    relations?: ResourceModel[] | undefined;
    responsibleDeputy?: EmailInputModel | undefined;
    responsiblePerson?: EmailInputModel | undefined;
    retentionPeriod?: Date | undefined;
    retentionPeriodComplement?: MultiLanguageModel | undefined;
    spatial?: string[] | undefined;
    temporalCoverage?: PeriodOfTimeModel[] | undefined;
    themes?: CodeInputModel[] | undefined;
    title: MultiLanguageModel | undefined;
    version?: string | undefined;
    versionNotes?: MultiLanguageModel | undefined;
}

export class DcatDatasetModel implements IDcatDatasetModel {
    accessRights?: VocabularyEntryModel | undefined;
    confidentialityPerson?: VocabularyEntryModel | undefined;
    conformsTo?: ResourceModel[] | undefined;
    contactPoints?: VCardModel[] | undefined;
    dataOwner?: string | undefined;
    description?: MultiLanguageModel | undefined;
    distributions?: DcatDistributionModel[] | undefined;
    documentation?: ResourceModel[] | undefined;
    frequency?: VocabularyEntryModel | undefined;
    geoIvIds?: VocabularyEntryModel[] | undefined;
    id?: string;
    identifiers?: string[] | undefined;
    images?: ResourceModel[] | undefined;
    isReferencedBy?: ResourceModel[] | undefined;
    issued?: Date | undefined;
    keywords?: KeywordModel[] | undefined;
    landingPages?: ResourceModel[] | undefined;
    languages?: VocabularyEntryModel[] | undefined;
    modified?: Date | undefined;
    previousVersion?: IdModel | undefined;
    processId?: string | undefined;
    publicationLevel?: PublicationLevel;
    publicationLevelProposal?: PublicationLevel | undefined;
    publisher?: AgentModel | undefined;
    qualifiedAttributions?: DcatQualifiedAttributionModel[] | undefined;
    qualifiedAttributionComplement?: MultiLanguageModel | undefined;
    qualifiedRelations?: DcatQualifiedRelationModel[] | undefined;
    registrationStatus?: RegistrationStatus;
    registrationStatusProposal?: RegistrationStatus | undefined;
    relations?: ResourceModel[] | undefined;
    responsibleDeputy?: IopPersonModel | undefined;
    responsiblePerson?: IopPersonModel | undefined;
    retentionPeriod?: Date | undefined;
    retentionPeriodComplement?: MultiLanguageModel | undefined;
    system!: SystemInfoModel | undefined;
    spatial?: string[] | undefined;
    temporalCoverage?: PeriodOfTimeModel[] | undefined;
    themes?: VocabularyEntryModel[] | undefined;
    title?: MultiLanguageModel | undefined;
    version?: string | undefined;
    versionNotes?: MultiLanguageModel | undefined;

    constructor(data?: IDcatDatasetModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessRights = _data["accessRights"] ? VocabularyEntryModel.fromJS(_data["accessRights"]) : undefined as any;
            this.confidentialityPerson = _data["confidentialityPerson"] ? VocabularyEntryModel.fromJS(_data["confidentialityPerson"]) : undefined as any;
            if (Array.isArray(_data["conformsTo"])) {
                this.conformsTo = [] as any;
                for (let item of _data["conformsTo"])
                    this.conformsTo!.push(ResourceModel.fromJS(item));
            }
            if (Array.isArray(_data["contactPoints"])) {
                this.contactPoints = [] as any;
                for (let item of _data["contactPoints"])
                    this.contactPoints!.push(VCardModel.fromJS(item));
            }
            this.dataOwner = _data["dataOwner"];
            this.description = _data["description"] ? MultiLanguageModel.fromJS(_data["description"]) : undefined as any;
            if (Array.isArray(_data["distributions"])) {
                this.distributions = [] as any;
                for (let item of _data["distributions"])
                    this.distributions!.push(DcatDistributionModel.fromJS(item));
            }
            if (Array.isArray(_data["documentation"])) {
                this.documentation = [] as any;
                for (let item of _data["documentation"])
                    this.documentation!.push(ResourceModel.fromJS(item));
            }
            this.frequency = _data["frequency"] ? VocabularyEntryModel.fromJS(_data["frequency"]) : undefined as any;
            if (Array.isArray(_data["geoIvIds"])) {
                this.geoIvIds = [] as any;
                for (let item of _data["geoIvIds"])
                    this.geoIvIds!.push(VocabularyEntryModel.fromJS(item));
            }
            this.id = _data["id"];
            if (Array.isArray(_data["identifiers"])) {
                this.identifiers = [] as any;
                for (let item of _data["identifiers"])
                    this.identifiers!.push(item);
            }
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ResourceModel.fromJS(item));
            }
            if (Array.isArray(_data["isReferencedBy"])) {
                this.isReferencedBy = [] as any;
                for (let item of _data["isReferencedBy"])
                    this.isReferencedBy!.push(ResourceModel.fromJS(item));
            }
            this.issued = _data["issued"] ? new Date(_data["issued"].toString()) : undefined as any;
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(KeywordModel.fromJS(item));
            }
            if (Array.isArray(_data["landingPages"])) {
                this.landingPages = [] as any;
                for (let item of _data["landingPages"])
                    this.landingPages!.push(ResourceModel.fromJS(item));
            }
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(VocabularyEntryModel.fromJS(item));
            }
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.previousVersion = _data["previousVersion"] ? IdModel.fromJS(_data["previousVersion"]) : undefined as any;
            this.processId = _data["processId"];
            this.publicationLevel = _data["publicationLevel"];
            this.publicationLevelProposal = _data["publicationLevelProposal"];
            this.publisher = _data["publisher"] ? AgentModel.fromJS(_data["publisher"]) : undefined as any;
            if (Array.isArray(_data["qualifiedAttributions"])) {
                this.qualifiedAttributions = [] as any;
                for (let item of _data["qualifiedAttributions"])
                    this.qualifiedAttributions!.push(DcatQualifiedAttributionModel.fromJS(item));
            }
            this.qualifiedAttributionComplement = _data["qualifiedAttributionComplement"] ? MultiLanguageModel.fromJS(_data["qualifiedAttributionComplement"]) : undefined as any;
            if (Array.isArray(_data["qualifiedRelations"])) {
                this.qualifiedRelations = [] as any;
                for (let item of _data["qualifiedRelations"])
                    this.qualifiedRelations!.push(DcatQualifiedRelationModel.fromJS(item));
            }
            this.registrationStatus = _data["registrationStatus"];
            this.registrationStatusProposal = _data["registrationStatusProposal"];
            if (Array.isArray(_data["relations"])) {
                this.relations = [] as any;
                for (let item of _data["relations"])
                    this.relations!.push(ResourceModel.fromJS(item));
            }
            this.responsibleDeputy = _data["responsibleDeputy"] ? IopPersonModel.fromJS(_data["responsibleDeputy"]) : undefined as any;
            this.responsiblePerson = _data["responsiblePerson"] ? IopPersonModel.fromJS(_data["responsiblePerson"]) : undefined as any;
            this.retentionPeriod = _data["retentionPeriod"] ? new Date(_data["retentionPeriod"].toString()) : undefined as any;
            this.retentionPeriodComplement = _data["retentionPeriodComplement"] ? MultiLanguageModel.fromJS(_data["retentionPeriodComplement"]) : undefined as any;
            this.system = _data["system"] ? SystemInfoModel.fromJS(_data["system"]) : undefined as any;
            if (Array.isArray(_data["spatial"])) {
                this.spatial = [] as any;
                for (let item of _data["spatial"])
                    this.spatial!.push(item);
            }
            if (Array.isArray(_data["temporalCoverage"])) {
                this.temporalCoverage = [] as any;
                for (let item of _data["temporalCoverage"])
                    this.temporalCoverage!.push(PeriodOfTimeModel.fromJS(item));
            }
            if (Array.isArray(_data["themes"])) {
                this.themes = [] as any;
                for (let item of _data["themes"])
                    this.themes!.push(VocabularyEntryModel.fromJS(item));
            }
            this.title = _data["title"] ? MultiLanguageModel.fromJS(_data["title"]) : undefined as any;
            this.version = _data["version"];
            this.versionNotes = _data["versionNotes"] ? MultiLanguageModel.fromJS(_data["versionNotes"]) : undefined as any;
        }
    }

    static fromJS(data: any): DcatDatasetModel {
        data = typeof data === 'object' ? data : {};
        let result = new DcatDatasetModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessRights"] = this.accessRights ? this.accessRights.toJSON() : undefined as any;
        data["confidentialityPerson"] = this.confidentialityPerson ? this.confidentialityPerson.toJSON() : undefined as any;
        if (Array.isArray(this.conformsTo)) {
            data["conformsTo"] = [];
            for (let item of this.conformsTo)
                data["conformsTo"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.contactPoints)) {
            data["contactPoints"] = [];
            for (let item of this.contactPoints)
                data["contactPoints"].push(item ? item.toJSON() : undefined as any);
        }
        data["dataOwner"] = this.dataOwner;
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        if (Array.isArray(this.distributions)) {
            data["distributions"] = [];
            for (let item of this.distributions)
                data["distributions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.documentation)) {
            data["documentation"] = [];
            for (let item of this.documentation)
                data["documentation"].push(item ? item.toJSON() : undefined as any);
        }
        data["frequency"] = this.frequency ? this.frequency.toJSON() : undefined as any;
        if (Array.isArray(this.geoIvIds)) {
            data["geoIvIds"] = [];
            for (let item of this.geoIvIds)
                data["geoIvIds"].push(item ? item.toJSON() : undefined as any);
        }
        data["id"] = this.id;
        if (Array.isArray(this.identifiers)) {
            data["identifiers"] = [];
            for (let item of this.identifiers)
                data["identifiers"].push(item);
        }
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.isReferencedBy)) {
            data["isReferencedBy"] = [];
            for (let item of this.isReferencedBy)
                data["isReferencedBy"].push(item ? item.toJSON() : undefined as any);
        }
        data["issued"] = this.issued ? this.issued.toISOString() : undefined as any;
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.landingPages)) {
            data["landingPages"] = [];
            for (let item of this.landingPages)
                data["landingPages"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item ? item.toJSON() : undefined as any);
        }
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["previousVersion"] = this.previousVersion ? this.previousVersion.toJSON() : undefined as any;
        data["processId"] = this.processId;
        data["publicationLevel"] = this.publicationLevel;
        data["publicationLevelProposal"] = this.publicationLevelProposal;
        data["publisher"] = this.publisher ? this.publisher.toJSON() : undefined as any;
        if (Array.isArray(this.qualifiedAttributions)) {
            data["qualifiedAttributions"] = [];
            for (let item of this.qualifiedAttributions)
                data["qualifiedAttributions"].push(item ? item.toJSON() : undefined as any);
        }
        data["qualifiedAttributionComplement"] = this.qualifiedAttributionComplement ? this.qualifiedAttributionComplement.toJSON() : undefined as any;
        if (Array.isArray(this.qualifiedRelations)) {
            data["qualifiedRelations"] = [];
            for (let item of this.qualifiedRelations)
                data["qualifiedRelations"].push(item ? item.toJSON() : undefined as any);
        }
        data["registrationStatus"] = this.registrationStatus;
        data["registrationStatusProposal"] = this.registrationStatusProposal;
        if (Array.isArray(this.relations)) {
            data["relations"] = [];
            for (let item of this.relations)
                data["relations"].push(item ? item.toJSON() : undefined as any);
        }
        data["responsibleDeputy"] = this.responsibleDeputy ? this.responsibleDeputy.toJSON() : undefined as any;
        data["responsiblePerson"] = this.responsiblePerson ? this.responsiblePerson.toJSON() : undefined as any;
        data["retentionPeriod"] = this.retentionPeriod ? this.retentionPeriod.toISOString() : undefined as any;
        data["retentionPeriodComplement"] = this.retentionPeriodComplement ? this.retentionPeriodComplement.toJSON() : undefined as any;
        data["system"] = this.system ? this.system.toJSON() : undefined as any;
        if (Array.isArray(this.spatial)) {
            data["spatial"] = [];
            for (let item of this.spatial)
                data["spatial"].push(item);
        }
        if (Array.isArray(this.temporalCoverage)) {
            data["temporalCoverage"] = [];
            for (let item of this.temporalCoverage)
                data["temporalCoverage"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.themes)) {
            data["themes"] = [];
            for (let item of this.themes)
                data["themes"].push(item ? item.toJSON() : undefined as any);
        }
        data["title"] = this.title ? this.title.toJSON() : undefined as any;
        data["version"] = this.version;
        data["versionNotes"] = this.versionNotes ? this.versionNotes.toJSON() : undefined as any;
        return data;
    }
}

export interface IDcatDatasetModel {
    accessRights?: VocabularyEntryModel | undefined;
    confidentialityPerson?: VocabularyEntryModel | undefined;
    conformsTo?: ResourceModel[] | undefined;
    contactPoints?: VCardModel[] | undefined;
    dataOwner?: string | undefined;
    description?: MultiLanguageModel | undefined;
    distributions?: DcatDistributionModel[] | undefined;
    documentation?: ResourceModel[] | undefined;
    frequency?: VocabularyEntryModel | undefined;
    geoIvIds?: VocabularyEntryModel[] | undefined;
    id?: string;
    identifiers?: string[] | undefined;
    images?: ResourceModel[] | undefined;
    isReferencedBy?: ResourceModel[] | undefined;
    issued?: Date | undefined;
    keywords?: KeywordModel[] | undefined;
    landingPages?: ResourceModel[] | undefined;
    languages?: VocabularyEntryModel[] | undefined;
    modified?: Date | undefined;
    previousVersion?: IdModel | undefined;
    processId?: string | undefined;
    publicationLevel?: PublicationLevel;
    publicationLevelProposal?: PublicationLevel | undefined;
    publisher?: AgentModel | undefined;
    qualifiedAttributions?: DcatQualifiedAttributionModel[] | undefined;
    qualifiedAttributionComplement?: MultiLanguageModel | undefined;
    qualifiedRelations?: DcatQualifiedRelationModel[] | undefined;
    registrationStatus?: RegistrationStatus;
    registrationStatusProposal?: RegistrationStatus | undefined;
    relations?: ResourceModel[] | undefined;
    responsibleDeputy?: IopPersonModel | undefined;
    responsiblePerson?: IopPersonModel | undefined;
    retentionPeriod?: Date | undefined;
    retentionPeriodComplement?: MultiLanguageModel | undefined;
    system: SystemInfoModel | undefined;
    spatial?: string[] | undefined;
    temporalCoverage?: PeriodOfTimeModel[] | undefined;
    themes?: VocabularyEntryModel[] | undefined;
    title?: MultiLanguageModel | undefined;
    version?: string | undefined;
    versionNotes?: MultiLanguageModel | undefined;
}

export class DcatDistributionInputModel implements IDcatDistributionInputModel {
    accessServices?: IdModel[] | undefined;
    accessUrl!: ResourceModel | undefined;
    availability?: CodeInputModel | undefined;
    byteSize?: number | undefined;
    checksum?: ChecksumInputModel | undefined;
    conformsTo?: ResourceModel[] | undefined;
    coverage?: PeriodOfTimeModel[] | undefined;
    description!: MultiLanguageModel | undefined;
    documentation?: ResourceModel[] | undefined;
    downloadUrl?: ResourceModel | undefined;
    format?: CodeInputModel | undefined;
    id?: string | undefined;
    identifier?: string | undefined;
    images?: ResourceModel[] | undefined;
    issued?: Date | undefined;
    languages?: CodeInputModel[] | undefined;
    license?: CodeInputModel | undefined;
    mediaType?: CodeInputModel | undefined;
    modified?: Date | undefined;
    packagingFormat?: CodeInputModel | undefined;
    rights?: string | undefined;
    spatialResolution?: number | undefined;
    temporalResolution?: string | undefined;
    title!: MultiLanguageModel | undefined;

    constructor(data?: IDcatDistributionInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accessServices"])) {
                this.accessServices = [] as any;
                for (let item of _data["accessServices"])
                    this.accessServices!.push(IdModel.fromJS(item));
            }
            this.accessUrl = _data["accessUrl"] ? ResourceModel.fromJS(_data["accessUrl"]) : undefined as any;
            this.availability = _data["availability"] ? CodeInputModel.fromJS(_data["availability"]) : undefined as any;
            this.byteSize = _data["byteSize"];
            this.checksum = _data["checksum"] ? ChecksumInputModel.fromJS(_data["checksum"]) : undefined as any;
            if (Array.isArray(_data["conformsTo"])) {
                this.conformsTo = [] as any;
                for (let item of _data["conformsTo"])
                    this.conformsTo!.push(ResourceModel.fromJS(item));
            }
            if (Array.isArray(_data["coverage"])) {
                this.coverage = [] as any;
                for (let item of _data["coverage"])
                    this.coverage!.push(PeriodOfTimeModel.fromJS(item));
            }
            this.description = _data["description"] ? MultiLanguageModel.fromJS(_data["description"]) : undefined as any;
            if (Array.isArray(_data["documentation"])) {
                this.documentation = [] as any;
                for (let item of _data["documentation"])
                    this.documentation!.push(ResourceModel.fromJS(item));
            }
            this.downloadUrl = _data["downloadUrl"] ? ResourceModel.fromJS(_data["downloadUrl"]) : undefined as any;
            this.format = _data["format"] ? CodeInputModel.fromJS(_data["format"]) : undefined as any;
            this.id = _data["id"];
            this.identifier = _data["identifier"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ResourceModel.fromJS(item));
            }
            this.issued = _data["issued"] ? new Date(_data["issued"].toString()) : undefined as any;
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(CodeInputModel.fromJS(item));
            }
            this.license = _data["license"] ? CodeInputModel.fromJS(_data["license"]) : undefined as any;
            this.mediaType = _data["mediaType"] ? CodeInputModel.fromJS(_data["mediaType"]) : undefined as any;
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.packagingFormat = _data["packagingFormat"] ? CodeInputModel.fromJS(_data["packagingFormat"]) : undefined as any;
            this.rights = _data["rights"];
            this.spatialResolution = _data["spatialResolution"];
            this.temporalResolution = _data["temporalResolution"];
            this.title = _data["title"] ? MultiLanguageModel.fromJS(_data["title"]) : undefined as any;
        }
    }

    static fromJS(data: any): DcatDistributionInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new DcatDistributionInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accessServices)) {
            data["accessServices"] = [];
            for (let item of this.accessServices)
                data["accessServices"].push(item ? item.toJSON() : undefined as any);
        }
        data["accessUrl"] = this.accessUrl ? this.accessUrl.toJSON() : undefined as any;
        data["availability"] = this.availability ? this.availability.toJSON() : undefined as any;
        data["byteSize"] = this.byteSize;
        data["checksum"] = this.checksum ? this.checksum.toJSON() : undefined as any;
        if (Array.isArray(this.conformsTo)) {
            data["conformsTo"] = [];
            for (let item of this.conformsTo)
                data["conformsTo"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.coverage)) {
            data["coverage"] = [];
            for (let item of this.coverage)
                data["coverage"].push(item ? item.toJSON() : undefined as any);
        }
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        if (Array.isArray(this.documentation)) {
            data["documentation"] = [];
            for (let item of this.documentation)
                data["documentation"].push(item ? item.toJSON() : undefined as any);
        }
        data["downloadUrl"] = this.downloadUrl ? this.downloadUrl.toJSON() : undefined as any;
        data["format"] = this.format ? this.format.toJSON() : undefined as any;
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item ? item.toJSON() : undefined as any);
        }
        data["issued"] = this.issued ? this.issued.toISOString() : undefined as any;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item ? item.toJSON() : undefined as any);
        }
        data["license"] = this.license ? this.license.toJSON() : undefined as any;
        data["mediaType"] = this.mediaType ? this.mediaType.toJSON() : undefined as any;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["packagingFormat"] = this.packagingFormat ? this.packagingFormat.toJSON() : undefined as any;
        data["rights"] = this.rights;
        data["spatialResolution"] = this.spatialResolution;
        data["temporalResolution"] = this.temporalResolution;
        data["title"] = this.title ? this.title.toJSON() : undefined as any;
        return data;
    }
}

export interface IDcatDistributionInputModel {
    accessServices?: IdModel[] | undefined;
    accessUrl: ResourceModel | undefined;
    availability?: CodeInputModel | undefined;
    byteSize?: number | undefined;
    checksum?: ChecksumInputModel | undefined;
    conformsTo?: ResourceModel[] | undefined;
    coverage?: PeriodOfTimeModel[] | undefined;
    description: MultiLanguageModel | undefined;
    documentation?: ResourceModel[] | undefined;
    downloadUrl?: ResourceModel | undefined;
    format?: CodeInputModel | undefined;
    id?: string | undefined;
    identifier?: string | undefined;
    images?: ResourceModel[] | undefined;
    issued?: Date | undefined;
    languages?: CodeInputModel[] | undefined;
    license?: CodeInputModel | undefined;
    mediaType?: CodeInputModel | undefined;
    modified?: Date | undefined;
    packagingFormat?: CodeInputModel | undefined;
    rights?: string | undefined;
    spatialResolution?: number | undefined;
    temporalResolution?: string | undefined;
    title: MultiLanguageModel | undefined;
}

export class DcatDistributionModel implements IDcatDistributionModel {
    accessServices?: IdModel[] | undefined;
    accessUrl?: ResourceModel | undefined;
    availability?: VocabularyEntryModel | undefined;
    byteSize?: number | undefined;
    checksum?: ChecksumModel | undefined;
    conformsTo?: ResourceModel[] | undefined;
    coverage?: PeriodOfTimeModel[] | undefined;
    description?: MultiLanguageModel | undefined;
    documentation?: ResourceModel[] | undefined;
    downloadUrl?: ResourceModel | undefined;
    format?: VocabularyEntryModel | undefined;
    id?: string;
    identifier?: string | undefined;
    images?: ResourceModel[] | undefined;
    issued?: Date | undefined;
    languages?: VocabularyEntryModel[] | undefined;
    license?: VocabularyEntryModel | undefined;
    mediaType?: VocabularyEntryModel | undefined;
    modified?: Date | undefined;
    packagingFormat?: VocabularyEntryModel | undefined;
    rights?: string | undefined;
    spatialResolution?: number | undefined;
    temporalResolution?: string | undefined;
    title?: MultiLanguageModel | undefined;

    constructor(data?: IDcatDistributionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accessServices"])) {
                this.accessServices = [] as any;
                for (let item of _data["accessServices"])
                    this.accessServices!.push(IdModel.fromJS(item));
            }
            this.accessUrl = _data["accessUrl"] ? ResourceModel.fromJS(_data["accessUrl"]) : undefined as any;
            this.availability = _data["availability"] ? VocabularyEntryModel.fromJS(_data["availability"]) : undefined as any;
            this.byteSize = _data["byteSize"];
            this.checksum = _data["checksum"] ? ChecksumModel.fromJS(_data["checksum"]) : undefined as any;
            if (Array.isArray(_data["conformsTo"])) {
                this.conformsTo = [] as any;
                for (let item of _data["conformsTo"])
                    this.conformsTo!.push(ResourceModel.fromJS(item));
            }
            if (Array.isArray(_data["coverage"])) {
                this.coverage = [] as any;
                for (let item of _data["coverage"])
                    this.coverage!.push(PeriodOfTimeModel.fromJS(item));
            }
            this.description = _data["description"] ? MultiLanguageModel.fromJS(_data["description"]) : undefined as any;
            if (Array.isArray(_data["documentation"])) {
                this.documentation = [] as any;
                for (let item of _data["documentation"])
                    this.documentation!.push(ResourceModel.fromJS(item));
            }
            this.downloadUrl = _data["downloadUrl"] ? ResourceModel.fromJS(_data["downloadUrl"]) : undefined as any;
            this.format = _data["format"] ? VocabularyEntryModel.fromJS(_data["format"]) : undefined as any;
            this.id = _data["id"];
            this.identifier = _data["identifier"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ResourceModel.fromJS(item));
            }
            this.issued = _data["issued"] ? new Date(_data["issued"].toString()) : undefined as any;
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(VocabularyEntryModel.fromJS(item));
            }
            this.license = _data["license"] ? VocabularyEntryModel.fromJS(_data["license"]) : undefined as any;
            this.mediaType = _data["mediaType"] ? VocabularyEntryModel.fromJS(_data["mediaType"]) : undefined as any;
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.packagingFormat = _data["packagingFormat"] ? VocabularyEntryModel.fromJS(_data["packagingFormat"]) : undefined as any;
            this.rights = _data["rights"];
            this.spatialResolution = _data["spatialResolution"];
            this.temporalResolution = _data["temporalResolution"];
            this.title = _data["title"] ? MultiLanguageModel.fromJS(_data["title"]) : undefined as any;
        }
    }

    static fromJS(data: any): DcatDistributionModel {
        data = typeof data === 'object' ? data : {};
        let result = new DcatDistributionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accessServices)) {
            data["accessServices"] = [];
            for (let item of this.accessServices)
                data["accessServices"].push(item ? item.toJSON() : undefined as any);
        }
        data["accessUrl"] = this.accessUrl ? this.accessUrl.toJSON() : undefined as any;
        data["availability"] = this.availability ? this.availability.toJSON() : undefined as any;
        data["byteSize"] = this.byteSize;
        data["checksum"] = this.checksum ? this.checksum.toJSON() : undefined as any;
        if (Array.isArray(this.conformsTo)) {
            data["conformsTo"] = [];
            for (let item of this.conformsTo)
                data["conformsTo"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.coverage)) {
            data["coverage"] = [];
            for (let item of this.coverage)
                data["coverage"].push(item ? item.toJSON() : undefined as any);
        }
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        if (Array.isArray(this.documentation)) {
            data["documentation"] = [];
            for (let item of this.documentation)
                data["documentation"].push(item ? item.toJSON() : undefined as any);
        }
        data["downloadUrl"] = this.downloadUrl ? this.downloadUrl.toJSON() : undefined as any;
        data["format"] = this.format ? this.format.toJSON() : undefined as any;
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item ? item.toJSON() : undefined as any);
        }
        data["issued"] = this.issued ? this.issued.toISOString() : undefined as any;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item ? item.toJSON() : undefined as any);
        }
        data["license"] = this.license ? this.license.toJSON() : undefined as any;
        data["mediaType"] = this.mediaType ? this.mediaType.toJSON() : undefined as any;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["packagingFormat"] = this.packagingFormat ? this.packagingFormat.toJSON() : undefined as any;
        data["rights"] = this.rights;
        data["spatialResolution"] = this.spatialResolution;
        data["temporalResolution"] = this.temporalResolution;
        data["title"] = this.title ? this.title.toJSON() : undefined as any;
        return data;
    }
}

export interface IDcatDistributionModel {
    accessServices?: IdModel[] | undefined;
    accessUrl?: ResourceModel | undefined;
    availability?: VocabularyEntryModel | undefined;
    byteSize?: number | undefined;
    checksum?: ChecksumModel | undefined;
    conformsTo?: ResourceModel[] | undefined;
    coverage?: PeriodOfTimeModel[] | undefined;
    description?: MultiLanguageModel | undefined;
    documentation?: ResourceModel[] | undefined;
    downloadUrl?: ResourceModel | undefined;
    format?: VocabularyEntryModel | undefined;
    id?: string;
    identifier?: string | undefined;
    images?: ResourceModel[] | undefined;
    issued?: Date | undefined;
    languages?: VocabularyEntryModel[] | undefined;
    license?: VocabularyEntryModel | undefined;
    mediaType?: VocabularyEntryModel | undefined;
    modified?: Date | undefined;
    packagingFormat?: VocabularyEntryModel | undefined;
    rights?: string | undefined;
    spatialResolution?: number | undefined;
    temporalResolution?: string | undefined;
    title?: MultiLanguageModel | undefined;
}

export class DcatQualifiedAttributionInputModel implements IDcatQualifiedAttributionInputModel {
    agent!: IdentifierInputModel | undefined;
    hadRole!: CodeInputModel | undefined;

    constructor(data?: IDcatQualifiedAttributionInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agent = _data["agent"] ? IdentifierInputModel.fromJS(_data["agent"]) : undefined as any;
            this.hadRole = _data["hadRole"] ? CodeInputModel.fromJS(_data["hadRole"]) : undefined as any;
        }
    }

    static fromJS(data: any): DcatQualifiedAttributionInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new DcatQualifiedAttributionInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agent"] = this.agent ? this.agent.toJSON() : undefined as any;
        data["hadRole"] = this.hadRole ? this.hadRole.toJSON() : undefined as any;
        return data;
    }
}

export interface IDcatQualifiedAttributionInputModel {
    agent: IdentifierInputModel | undefined;
    hadRole: CodeInputModel | undefined;
}

export class DcatQualifiedAttributionModel implements IDcatQualifiedAttributionModel {
    agent?: AgentModel | undefined;
    hadRole?: VocabularyEntryModel | undefined;

    constructor(data?: IDcatQualifiedAttributionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agent = _data["agent"] ? AgentModel.fromJS(_data["agent"]) : undefined as any;
            this.hadRole = _data["hadRole"] ? VocabularyEntryModel.fromJS(_data["hadRole"]) : undefined as any;
        }
    }

    static fromJS(data: any): DcatQualifiedAttributionModel {
        data = typeof data === 'object' ? data : {};
        let result = new DcatQualifiedAttributionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agent"] = this.agent ? this.agent.toJSON() : undefined as any;
        data["hadRole"] = this.hadRole ? this.hadRole.toJSON() : undefined as any;
        return data;
    }
}

export interface IDcatQualifiedAttributionModel {
    agent?: AgentModel | undefined;
    hadRole?: VocabularyEntryModel | undefined;
}

export class DcatQualifiedRelationInputModel implements IDcatQualifiedRelationInputModel {
    hadRole!: CodeInputModel | undefined;
    relation!: ResourceModel | undefined;

    constructor(data?: IDcatQualifiedRelationInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hadRole = _data["hadRole"] ? CodeInputModel.fromJS(_data["hadRole"]) : undefined as any;
            this.relation = _data["relation"] ? ResourceModel.fromJS(_data["relation"]) : undefined as any;
        }
    }

    static fromJS(data: any): DcatQualifiedRelationInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new DcatQualifiedRelationInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hadRole"] = this.hadRole ? this.hadRole.toJSON() : undefined as any;
        data["relation"] = this.relation ? this.relation.toJSON() : undefined as any;
        return data;
    }
}

export interface IDcatQualifiedRelationInputModel {
    hadRole: CodeInputModel | undefined;
    relation: ResourceModel | undefined;
}

export class DcatQualifiedRelationModel implements IDcatQualifiedRelationModel {
    hadRole?: VocabularyEntryModel | undefined;
    relation?: ResourceModel | undefined;

    constructor(data?: IDcatQualifiedRelationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hadRole = _data["hadRole"] ? VocabularyEntryModel.fromJS(_data["hadRole"]) : undefined as any;
            this.relation = _data["relation"] ? ResourceModel.fromJS(_data["relation"]) : undefined as any;
        }
    }

    static fromJS(data: any): DcatQualifiedRelationModel {
        data = typeof data === 'object' ? data : {};
        let result = new DcatQualifiedRelationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hadRole"] = this.hadRole ? this.hadRole.toJSON() : undefined as any;
        data["relation"] = this.relation ? this.relation.toJSON() : undefined as any;
        return data;
    }
}

export interface IDcatQualifiedRelationModel {
    hadRole?: VocabularyEntryModel | undefined;
    relation?: ResourceModel | undefined;
}

export class DcatVocabularyEntry implements IDcatVocabularyEntry {
    code?: string | undefined;
    name?: MultiLanguage | undefined;
    themeTaxonomy?: string | undefined;
    uri?: string | undefined;

    constructor(data?: IDcatVocabularyEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"] ? MultiLanguage.fromJS(_data["name"]) : undefined as any;
            this.themeTaxonomy = _data["themeTaxonomy"];
            this.uri = _data["uri"];
        }
    }

    static fromJS(data: any): DcatVocabularyEntry {
        data = typeof data === 'object' ? data : {};
        let result = new DcatVocabularyEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name ? this.name.toJSON() : undefined as any;
        data["themeTaxonomy"] = this.themeTaxonomy;
        data["uri"] = this.uri;
        return data;
    }
}

export interface IDcatVocabularyEntry {
    code?: string | undefined;
    name?: MultiLanguage | undefined;
    themeTaxonomy?: string | undefined;
    uri?: string | undefined;
}

export class DistributionSummary implements IDistributionSummary {
    byteSize?: number | undefined;
    format?: VocabularyEntry | undefined;
    id?: string;
    languages?: string[] | undefined;
    lastUpdated?: Date | undefined;
    published?: Date | undefined;
    title?: MultiLanguage | undefined;

    constructor(data?: IDistributionSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.byteSize = _data["byteSize"];
            this.format = _data["format"] ? VocabularyEntry.fromJS(_data["format"]) : undefined as any;
            this.id = _data["id"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(item);
            }
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : undefined as any;
            this.published = _data["published"] ? new Date(_data["published"].toString()) : undefined as any;
            this.title = _data["title"] ? MultiLanguage.fromJS(_data["title"]) : undefined as any;
        }
    }

    static fromJS(data: any): DistributionSummary {
        data = typeof data === 'object' ? data : {};
        let result = new DistributionSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["byteSize"] = this.byteSize;
        data["format"] = this.format ? this.format.toJSON() : undefined as any;
        data["id"] = this.id;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item);
        }
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : undefined as any;
        data["published"] = this.published ? this.published.toISOString() : undefined as any;
        data["title"] = this.title ? this.title.toJSON() : undefined as any;
        return data;
    }
}

export interface IDistributionSummary {
    byteSize?: number | undefined;
    format?: VocabularyEntry | undefined;
    id?: string;
    languages?: string[] | undefined;
    lastUpdated?: Date | undefined;
    published?: Date | undefined;
    title?: MultiLanguage | undefined;
}

export class EmailInputModel implements IEmailInputModel {
    email!: string | undefined;

    constructor(data?: IEmailInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): EmailInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmailInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IEmailInputModel {
    email: string | undefined;
}

export class FilterConfigurationModel implements IFilterConfigurationModel {
    filters!: FilterDefinitionModel[] | undefined;

    constructor(data?: IFilterConfigurationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(FilterDefinitionModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterConfigurationModel {
        data = typeof data === 'object' ? data : {};
        let result = new FilterConfigurationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterConfigurationModel {
    filters: FilterDefinitionModel[] | undefined;
}

export class FilterCountResult implements IFilterCountResult {
    accessRights?: FilterCountResultItem[] | undefined;
    attributedAgents?: FilterCountResultItem[] | undefined;
    businessEvents?: FilterCountResultItem[] | undefined;
    conceptValueTypes?: FilterCountResultItem[] | undefined;
    formats?: FilterCountResultItem[] | undefined;
    lifeEvents?: FilterCountResultItem[] | undefined;
    publicationLevelProposals?: FilterCountResultItem[] | undefined;
    publicationLevels?: FilterCountResultItem[] | undefined;
    publishers?: FilterCountResultItem[] | undefined;
    registrationStatuses?: FilterCountResultItem[] | undefined;
    registrationStatusProposals?: FilterCountResultItem[] | undefined;
    structures?: FilterCountResultItem[] | undefined;
    themes?: FilterCountResultItem[] | undefined;
    totalDocCount?: number;
    types?: FilterCountResultItem[] | undefined;

    constructor(data?: IFilterCountResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accessRights"])) {
                this.accessRights = [] as any;
                for (let item of _data["accessRights"])
                    this.accessRights!.push(FilterCountResultItem.fromJS(item));
            }
            if (Array.isArray(_data["attributedAgents"])) {
                this.attributedAgents = [] as any;
                for (let item of _data["attributedAgents"])
                    this.attributedAgents!.push(FilterCountResultItem.fromJS(item));
            }
            if (Array.isArray(_data["businessEvents"])) {
                this.businessEvents = [] as any;
                for (let item of _data["businessEvents"])
                    this.businessEvents!.push(FilterCountResultItem.fromJS(item));
            }
            if (Array.isArray(_data["conceptValueTypes"])) {
                this.conceptValueTypes = [] as any;
                for (let item of _data["conceptValueTypes"])
                    this.conceptValueTypes!.push(FilterCountResultItem.fromJS(item));
            }
            if (Array.isArray(_data["formats"])) {
                this.formats = [] as any;
                for (let item of _data["formats"])
                    this.formats!.push(FilterCountResultItem.fromJS(item));
            }
            if (Array.isArray(_data["lifeEvents"])) {
                this.lifeEvents = [] as any;
                for (let item of _data["lifeEvents"])
                    this.lifeEvents!.push(FilterCountResultItem.fromJS(item));
            }
            if (Array.isArray(_data["publicationLevelProposals"])) {
                this.publicationLevelProposals = [] as any;
                for (let item of _data["publicationLevelProposals"])
                    this.publicationLevelProposals!.push(FilterCountResultItem.fromJS(item));
            }
            if (Array.isArray(_data["publicationLevels"])) {
                this.publicationLevels = [] as any;
                for (let item of _data["publicationLevels"])
                    this.publicationLevels!.push(FilterCountResultItem.fromJS(item));
            }
            if (Array.isArray(_data["publishers"])) {
                this.publishers = [] as any;
                for (let item of _data["publishers"])
                    this.publishers!.push(FilterCountResultItem.fromJS(item));
            }
            if (Array.isArray(_data["registrationStatuses"])) {
                this.registrationStatuses = [] as any;
                for (let item of _data["registrationStatuses"])
                    this.registrationStatuses!.push(FilterCountResultItem.fromJS(item));
            }
            if (Array.isArray(_data["registrationStatusProposals"])) {
                this.registrationStatusProposals = [] as any;
                for (let item of _data["registrationStatusProposals"])
                    this.registrationStatusProposals!.push(FilterCountResultItem.fromJS(item));
            }
            if (Array.isArray(_data["structures"])) {
                this.structures = [] as any;
                for (let item of _data["structures"])
                    this.structures!.push(FilterCountResultItem.fromJS(item));
            }
            if (Array.isArray(_data["themes"])) {
                this.themes = [] as any;
                for (let item of _data["themes"])
                    this.themes!.push(FilterCountResultItem.fromJS(item));
            }
            this.totalDocCount = _data["totalDocCount"];
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(FilterCountResultItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterCountResult {
        data = typeof data === 'object' ? data : {};
        let result = new FilterCountResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accessRights)) {
            data["accessRights"] = [];
            for (let item of this.accessRights)
                data["accessRights"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.attributedAgents)) {
            data["attributedAgents"] = [];
            for (let item of this.attributedAgents)
                data["attributedAgents"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.businessEvents)) {
            data["businessEvents"] = [];
            for (let item of this.businessEvents)
                data["businessEvents"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.conceptValueTypes)) {
            data["conceptValueTypes"] = [];
            for (let item of this.conceptValueTypes)
                data["conceptValueTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.formats)) {
            data["formats"] = [];
            for (let item of this.formats)
                data["formats"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.lifeEvents)) {
            data["lifeEvents"] = [];
            for (let item of this.lifeEvents)
                data["lifeEvents"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.publicationLevelProposals)) {
            data["publicationLevelProposals"] = [];
            for (let item of this.publicationLevelProposals)
                data["publicationLevelProposals"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.publicationLevels)) {
            data["publicationLevels"] = [];
            for (let item of this.publicationLevels)
                data["publicationLevels"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.publishers)) {
            data["publishers"] = [];
            for (let item of this.publishers)
                data["publishers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.registrationStatuses)) {
            data["registrationStatuses"] = [];
            for (let item of this.registrationStatuses)
                data["registrationStatuses"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.registrationStatusProposals)) {
            data["registrationStatusProposals"] = [];
            for (let item of this.registrationStatusProposals)
                data["registrationStatusProposals"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.structures)) {
            data["structures"] = [];
            for (let item of this.structures)
                data["structures"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.themes)) {
            data["themes"] = [];
            for (let item of this.themes)
                data["themes"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalDocCount"] = this.totalDocCount;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterCountResult {
    accessRights?: FilterCountResultItem[] | undefined;
    attributedAgents?: FilterCountResultItem[] | undefined;
    businessEvents?: FilterCountResultItem[] | undefined;
    conceptValueTypes?: FilterCountResultItem[] | undefined;
    formats?: FilterCountResultItem[] | undefined;
    lifeEvents?: FilterCountResultItem[] | undefined;
    publicationLevelProposals?: FilterCountResultItem[] | undefined;
    publicationLevels?: FilterCountResultItem[] | undefined;
    publishers?: FilterCountResultItem[] | undefined;
    registrationStatuses?: FilterCountResultItem[] | undefined;
    registrationStatusProposals?: FilterCountResultItem[] | undefined;
    structures?: FilterCountResultItem[] | undefined;
    themes?: FilterCountResultItem[] | undefined;
    totalDocCount?: number;
    types?: FilterCountResultItem[] | undefined;
}

export class FilterCountResultItem implements IFilterCountResultItem {
    count?: number;
    label?: MultiLanguage | undefined;
    reference?: string | undefined;

    constructor(data?: IFilterCountResultItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            this.label = _data["label"] ? MultiLanguage.fromJS(_data["label"]) : undefined as any;
            this.reference = _data["reference"];
        }
    }

    static fromJS(data: any): FilterCountResultItem {
        data = typeof data === 'object' ? data : {};
        let result = new FilterCountResultItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        data["label"] = this.label ? this.label.toJSON() : undefined as any;
        data["reference"] = this.reference;
        return data;
    }
}

export interface IFilterCountResultItem {
    count?: number;
    label?: MultiLanguage | undefined;
    reference?: string | undefined;
}

export class FilterDefinitionFilterValueModel implements IFilterDefinitionFilterValueModel {
    name!: MultiLanguageModel | undefined;
    filterValueIdentifier!: string | undefined;
    fieldValues!: FilterDefinitionValueModel[] | undefined;
    occurType?: OccurType;

    constructor(data?: IFilterDefinitionFilterValueModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] ? MultiLanguageModel.fromJS(_data["name"]) : undefined as any;
            this.filterValueIdentifier = _data["filterValueIdentifier"];
            if (Array.isArray(_data["fieldValues"])) {
                this.fieldValues = [] as any;
                for (let item of _data["fieldValues"])
                    this.fieldValues!.push(FilterDefinitionValueModel.fromJS(item));
            }
            this.occurType = _data["occurType"];
        }
    }

    static fromJS(data: any): FilterDefinitionFilterValueModel {
        data = typeof data === 'object' ? data : {};
        let result = new FilterDefinitionFilterValueModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name ? this.name.toJSON() : undefined as any;
        data["filterValueIdentifier"] = this.filterValueIdentifier;
        if (Array.isArray(this.fieldValues)) {
            data["fieldValues"] = [];
            for (let item of this.fieldValues)
                data["fieldValues"].push(item ? item.toJSON() : undefined as any);
        }
        data["occurType"] = this.occurType;
        return data;
    }
}

export interface IFilterDefinitionFilterValueModel {
    name: MultiLanguageModel | undefined;
    filterValueIdentifier: string | undefined;
    fieldValues: FilterDefinitionValueModel[] | undefined;
    occurType?: OccurType;
}

export class FilterDefinitionModel implements IFilterDefinitionModel {
    filterIdentifier!: string | undefined;
    name!: MultiLanguageModel | undefined;
    description?: MultiLanguageModel | undefined;
    values?: FilterDefinitionFilterValueModel[] | undefined;

    constructor(data?: IFilterDefinitionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterIdentifier = _data["filterIdentifier"];
            this.name = _data["name"] ? MultiLanguageModel.fromJS(_data["name"]) : undefined as any;
            this.description = _data["description"] ? MultiLanguageModel.fromJS(_data["description"]) : undefined as any;
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(FilterDefinitionFilterValueModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterDefinitionModel {
        data = typeof data === 'object' ? data : {};
        let result = new FilterDefinitionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterIdentifier"] = this.filterIdentifier;
        data["name"] = this.name ? this.name.toJSON() : undefined as any;
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFilterDefinitionModel {
    filterIdentifier: string | undefined;
    name: MultiLanguageModel | undefined;
    description?: MultiLanguageModel | undefined;
    values?: FilterDefinitionFilterValueModel[] | undefined;
}

export class FilterDefinitionValueModel implements IFilterDefinitionValueModel {
    fieldName!: string | undefined;
    fieldValue?: string | undefined;
    fieldValueMultilanguage?: MultiLanguageModel | undefined;
    fieldProperty?: string | undefined;

    constructor(data?: IFilterDefinitionValueModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldName = _data["fieldName"];
            this.fieldValue = _data["fieldValue"];
            this.fieldValueMultilanguage = _data["fieldValueMultilanguage"] ? MultiLanguageModel.fromJS(_data["fieldValueMultilanguage"]) : undefined as any;
            this.fieldProperty = _data["fieldProperty"];
        }
    }

    static fromJS(data: any): FilterDefinitionValueModel {
        data = typeof data === 'object' ? data : {};
        let result = new FilterDefinitionValueModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldName"] = this.fieldName;
        data["fieldValue"] = this.fieldValue;
        data["fieldValueMultilanguage"] = this.fieldValueMultilanguage ? this.fieldValueMultilanguage.toJSON() : undefined as any;
        data["fieldProperty"] = this.fieldProperty;
        return data;
    }
}

export interface IFilterDefinitionValueModel {
    fieldName: string | undefined;
    fieldValue?: string | undefined;
    fieldValueMultilanguage?: MultiLanguageModel | undefined;
    fieldProperty?: string | undefined;
}

export class IdLabel implements IIdLabel {
    id?: string;
    label?: MultiLanguage | undefined;

    constructor(data?: IIdLabel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"] ? MultiLanguage.fromJS(_data["label"]) : undefined as any;
        }
    }

    static fromJS(data: any): IdLabel {
        data = typeof data === 'object' ? data : {};
        let result = new IdLabel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label ? this.label.toJSON() : undefined as any;
        return data;
    }
}

export interface IIdLabel {
    id?: string;
    label?: MultiLanguage | undefined;
}

export class IdModel implements IIdModel {
    id!: string;

    constructor(data?: IIdModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): IdModel {
        data = typeof data === 'object' ? data : {};
        let result = new IdModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IIdModel {
    id: string;
}

export class IdNameModel implements IIdNameModel {
    id!: string;
    name?: MultiLanguageModel | undefined;

    constructor(data?: IIdNameModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"] ? MultiLanguageModel.fromJS(_data["name"]) : undefined as any;
        }
    }

    static fromJS(data: any): IdNameModel {
        data = typeof data === 'object' ? data : {};
        let result = new IdNameModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name ? this.name.toJSON() : undefined as any;
        return data;
    }
}

export interface IIdNameModel {
    id: string;
    name?: MultiLanguageModel | undefined;
}

export class IdentifierInputModel implements IIdentifierInputModel {
    identifier!: string | undefined;

    constructor(data?: IIdentifierInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
        }
    }

    static fromJS(data: any): IdentifierInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new IdentifierInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        return data;
    }
}

export interface IIdentifierInputModel {
    identifier: string | undefined;
}

export class IdentifierNameModel implements IIdentifierNameModel {
    identifier!: string | undefined;
    name?: MultiLanguageModel | undefined;

    constructor(data?: IIdentifierNameModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.name = _data["name"] ? MultiLanguageModel.fromJS(_data["name"]) : undefined as any;
        }
    }

    static fromJS(data: any): IdentifierNameModel {
        data = typeof data === 'object' ? data : {};
        let result = new IdentifierNameModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["name"] = this.name ? this.name.toJSON() : undefined as any;
        return data;
    }
}

export interface IIdentifierNameModel {
    identifier: string | undefined;
    name?: MultiLanguageModel | undefined;
}

export class IdentifierVersionExistsResult implements IIdentifierVersionExistsResult {
    identifier?: string | undefined;
    version?: string | undefined;
    result?: boolean;
    message?: IdentifierVersionExistsResultMessage;
    objectType?: IdentifierVersionExistsResultObjectType;

    constructor(data?: IIdentifierVersionExistsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.version = _data["version"];
            this.result = _data["result"];
            this.message = _data["message"];
            this.objectType = _data["objectType"];
        }
    }

    static fromJS(data: any): IdentifierVersionExistsResult {
        data = typeof data === 'object' ? data : {};
        let result = new IdentifierVersionExistsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["version"] = this.version;
        data["result"] = this.result;
        data["message"] = this.message;
        data["objectType"] = this.objectType;
        return data;
    }
}

export interface IIdentifierVersionExistsResult {
    identifier?: string | undefined;
    version?: string | undefined;
    result?: boolean;
    message?: IdentifierVersionExistsResultMessage;
    objectType?: IdentifierVersionExistsResultObjectType;
}

export enum IdentifierVersionExistsResultMessage {
    None = "None",
    IdentifierFromAnotherPublisherAlreadyExists = "IdentifierFromAnotherPublisherAlreadyExists",
    IdentifierAndVersionAlreadyExists = "IdentifierAndVersionAlreadyExists",
}

export enum IdentifierVersionExistsResultObjectType {
    Concept = "Concept",
    MappingTable = "MappingTable",
}

export class IopConceptModel implements IIopConceptModel {
    codeListEntries?: CodeListEntryModel[] | undefined;
    codeListEntryDefaultSortProperty?: CodeListEntrySortProperty | undefined;
    codeListEntryValueMaxLength?: number | undefined;
    codeListEntryValueType?: CodeListEntryValueType | undefined;
    conceptType?: ConceptType;
    conformsTo?: ResourceModel[] | undefined;
    description!: MultiLanguageModel | undefined;
    id?: string;
    identifiers?: string[] | undefined;
    isLocked?: boolean;
    keywords?: KeywordModel[] | undefined;
    maxLength?: number | undefined;
    maxValue?: number | undefined;
    measurementUnit?: string | undefined;
    minLength?: number | undefined;
    minValue?: number | undefined;
    name!: MultiLanguageModel | undefined;
    numberDecimals?: number | undefined;
    pattern?: string | undefined;
    replaces?: ConceptReferenceModel[] | undefined;
    isReplacedBy?: ConceptReferenceModel[] | undefined;
    publicationLevel?: PublicationLevel;
    publicationLevelProposal?: PublicationLevel | undefined;
    publisher!: AgentModel | undefined;
    registrationStatus?: RegistrationStatus;
    registrationStatusProposal?: RegistrationStatus | undefined;
    responsibleDeputy?: IopPersonModel | undefined;
    responsiblePerson!: IopPersonModel | undefined;
    system!: SystemInfoModel | undefined;
    themes?: VocabularyEntryModel[] | undefined;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
    version!: string | undefined;

    constructor(data?: IIopConceptModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["codeListEntries"])) {
                this.codeListEntries = [] as any;
                for (let item of _data["codeListEntries"])
                    this.codeListEntries!.push(CodeListEntryModel.fromJS(item));
            }
            this.codeListEntryDefaultSortProperty = _data["codeListEntryDefaultSortProperty"];
            this.codeListEntryValueMaxLength = _data["codeListEntryValueMaxLength"];
            this.codeListEntryValueType = _data["codeListEntryValueType"];
            this.conceptType = _data["conceptType"];
            if (Array.isArray(_data["conformsTo"])) {
                this.conformsTo = [] as any;
                for (let item of _data["conformsTo"])
                    this.conformsTo!.push(ResourceModel.fromJS(item));
            }
            this.description = _data["description"] ? MultiLanguageModel.fromJS(_data["description"]) : undefined as any;
            this.id = _data["id"];
            if (Array.isArray(_data["identifiers"])) {
                this.identifiers = [] as any;
                for (let item of _data["identifiers"])
                    this.identifiers!.push(item);
            }
            this.isLocked = _data["isLocked"];
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(KeywordModel.fromJS(item));
            }
            this.maxLength = _data["maxLength"];
            this.maxValue = _data["maxValue"];
            this.measurementUnit = _data["measurementUnit"];
            this.minLength = _data["minLength"];
            this.minValue = _data["minValue"];
            this.name = _data["name"] ? MultiLanguageModel.fromJS(_data["name"]) : undefined as any;
            this.numberDecimals = _data["numberDecimals"];
            this.pattern = _data["pattern"];
            if (Array.isArray(_data["replaces"])) {
                this.replaces = [] as any;
                for (let item of _data["replaces"])
                    this.replaces!.push(ConceptReferenceModel.fromJS(item));
            }
            if (Array.isArray(_data["isReplacedBy"])) {
                this.isReplacedBy = [] as any;
                for (let item of _data["isReplacedBy"])
                    this.isReplacedBy!.push(ConceptReferenceModel.fromJS(item));
            }
            this.publicationLevel = _data["publicationLevel"];
            this.publicationLevelProposal = _data["publicationLevelProposal"];
            this.publisher = _data["publisher"] ? AgentModel.fromJS(_data["publisher"]) : undefined as any;
            this.registrationStatus = _data["registrationStatus"];
            this.registrationStatusProposal = _data["registrationStatusProposal"];
            this.responsibleDeputy = _data["responsibleDeputy"] ? IopPersonModel.fromJS(_data["responsibleDeputy"]) : undefined as any;
            this.responsiblePerson = _data["responsiblePerson"] ? IopPersonModel.fromJS(_data["responsiblePerson"]) : undefined as any;
            this.system = _data["system"] ? SystemInfoModel.fromJS(_data["system"]) : undefined as any;
            if (Array.isArray(_data["themes"])) {
                this.themes = [] as any;
                for (let item of _data["themes"])
                    this.themes!.push(VocabularyEntryModel.fromJS(item));
            }
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : undefined as any;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : undefined as any;
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): IopConceptModel {
        data = typeof data === 'object' ? data : {};
        let result = new IopConceptModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.codeListEntries)) {
            data["codeListEntries"] = [];
            for (let item of this.codeListEntries)
                data["codeListEntries"].push(item ? item.toJSON() : undefined as any);
        }
        data["codeListEntryDefaultSortProperty"] = this.codeListEntryDefaultSortProperty;
        data["codeListEntryValueMaxLength"] = this.codeListEntryValueMaxLength;
        data["codeListEntryValueType"] = this.codeListEntryValueType;
        data["conceptType"] = this.conceptType;
        if (Array.isArray(this.conformsTo)) {
            data["conformsTo"] = [];
            for (let item of this.conformsTo)
                data["conformsTo"].push(item ? item.toJSON() : undefined as any);
        }
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        data["id"] = this.id;
        if (Array.isArray(this.identifiers)) {
            data["identifiers"] = [];
            for (let item of this.identifiers)
                data["identifiers"].push(item);
        }
        data["isLocked"] = this.isLocked;
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item ? item.toJSON() : undefined as any);
        }
        data["maxLength"] = this.maxLength;
        data["maxValue"] = this.maxValue;
        data["measurementUnit"] = this.measurementUnit;
        data["minLength"] = this.minLength;
        data["minValue"] = this.minValue;
        data["name"] = this.name ? this.name.toJSON() : undefined as any;
        data["numberDecimals"] = this.numberDecimals;
        data["pattern"] = this.pattern;
        if (Array.isArray(this.replaces)) {
            data["replaces"] = [];
            for (let item of this.replaces)
                data["replaces"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.isReplacedBy)) {
            data["isReplacedBy"] = [];
            for (let item of this.isReplacedBy)
                data["isReplacedBy"].push(item ? item.toJSON() : undefined as any);
        }
        data["publicationLevel"] = this.publicationLevel;
        data["publicationLevelProposal"] = this.publicationLevelProposal;
        data["publisher"] = this.publisher ? this.publisher.toJSON() : undefined as any;
        data["registrationStatus"] = this.registrationStatus;
        data["registrationStatusProposal"] = this.registrationStatusProposal;
        data["responsibleDeputy"] = this.responsibleDeputy ? this.responsibleDeputy.toJSON() : undefined as any;
        data["responsiblePerson"] = this.responsiblePerson ? this.responsiblePerson.toJSON() : undefined as any;
        data["system"] = this.system ? this.system.toJSON() : undefined as any;
        if (Array.isArray(this.themes)) {
            data["themes"] = [];
            for (let item of this.themes)
                data["themes"].push(item ? item.toJSON() : undefined as any);
        }
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : undefined as any;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : undefined as any;
        data["version"] = this.version;
        return data;
    }
}

export interface IIopConceptModel {
    codeListEntries?: CodeListEntryModel[] | undefined;
    codeListEntryDefaultSortProperty?: CodeListEntrySortProperty | undefined;
    codeListEntryValueMaxLength?: number | undefined;
    codeListEntryValueType?: CodeListEntryValueType | undefined;
    conceptType?: ConceptType;
    conformsTo?: ResourceModel[] | undefined;
    description: MultiLanguageModel | undefined;
    id?: string;
    identifiers?: string[] | undefined;
    isLocked?: boolean;
    keywords?: KeywordModel[] | undefined;
    maxLength?: number | undefined;
    maxValue?: number | undefined;
    measurementUnit?: string | undefined;
    minLength?: number | undefined;
    minValue?: number | undefined;
    name: MultiLanguageModel | undefined;
    numberDecimals?: number | undefined;
    pattern?: string | undefined;
    replaces?: ConceptReferenceModel[] | undefined;
    isReplacedBy?: ConceptReferenceModel[] | undefined;
    publicationLevel?: PublicationLevel;
    publicationLevelProposal?: PublicationLevel | undefined;
    publisher: AgentModel | undefined;
    registrationStatus?: RegistrationStatus;
    registrationStatusProposal?: RegistrationStatus | undefined;
    responsibleDeputy?: IopPersonModel | undefined;
    responsiblePerson: IopPersonModel | undefined;
    system: SystemInfoModel | undefined;
    themes?: VocabularyEntryModel[] | undefined;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
    version: string | undefined;
}

export class IopConceptStructureReferenceModel implements IIopConceptStructureReferenceModel {
    datasetUri?: string | undefined;
    attributeUri?: string | undefined;
    datasetReferenceModel?: DatasetReferenceModel | undefined;

    constructor(data?: IIopConceptStructureReferenceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datasetUri = _data["datasetUri"];
            this.attributeUri = _data["attributeUri"];
            this.datasetReferenceModel = _data["datasetReferenceModel"] ? DatasetReferenceModel.fromJS(_data["datasetReferenceModel"]) : undefined as any;
        }
    }

    static fromJS(data: any): IopConceptStructureReferenceModel {
        data = typeof data === 'object' ? data : {};
        let result = new IopConceptStructureReferenceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datasetUri"] = this.datasetUri;
        data["attributeUri"] = this.attributeUri;
        data["datasetReferenceModel"] = this.datasetReferenceModel ? this.datasetReferenceModel.toJSON() : undefined as any;
        return data;
    }
}

export interface IIopConceptStructureReferenceModel {
    datasetUri?: string | undefined;
    attributeUri?: string | undefined;
    datasetReferenceModel?: DatasetReferenceModel | undefined;
}

export class IopPersonModel implements IIopPersonModel {
    givenName!: string | undefined;
    familyName!: string | undefined;
    email!: string | undefined;

    constructor(data?: IIopPersonModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.givenName = _data["givenName"];
            this.familyName = _data["familyName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): IopPersonModel {
        data = typeof data === 'object' ? data : {};
        let result = new IopPersonModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["givenName"] = this.givenName;
        data["familyName"] = this.familyName;
        data["email"] = this.email;
        return data;
    }
}

export interface IIopPersonModel {
    givenName: string | undefined;
    familyName: string | undefined;
    email: string | undefined;
}

export class KeywordModel implements IKeywordModel {
    label?: MultiLanguageModel | undefined;
    uri?: string | undefined;

    constructor(data?: IKeywordModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"] ? MultiLanguageModel.fromJS(_data["label"]) : undefined as any;
            this.uri = _data["uri"];
        }
    }

    static fromJS(data: any): KeywordModel {
        data = typeof data === 'object' ? data : {};
        let result = new KeywordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label ? this.label.toJSON() : undefined as any;
        data["uri"] = this.uri;
        return data;
    }
}

export interface IKeywordModel {
    label?: MultiLanguageModel | undefined;
    uri?: string | undefined;
}

export enum LindasResourceType {
    Concept = "Concept",
    Dataset = "Dataset",
}

export enum LinkedDataFormat {
    Ttl = "Ttl",
    Rdf = "Rdf",
    JsonLd = "JsonLd",
}

export class LocalizedText implements ILocalizedText {
    cultureCode?: string | undefined;
    text?: string | undefined;

    constructor(data?: ILocalizedText) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cultureCode = _data["cultureCode"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): LocalizedText {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizedText();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cultureCode"] = this.cultureCode;
        data["text"] = this.text;
        return data;
    }
}

export interface ILocalizedText {
    cultureCode?: string | undefined;
    text?: string | undefined;
}

export class MappingRelationInputModel implements IMappingRelationInputModel {
    source!: UriInputModel | undefined;
    target!: UriInputModel | undefined;
    relationType!: CodeInputModel | undefined;

    constructor(data?: IMappingRelationInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"] ? UriInputModel.fromJS(_data["source"]) : undefined as any;
            this.target = _data["target"] ? UriInputModel.fromJS(_data["target"]) : undefined as any;
            this.relationType = _data["relationType"] ? CodeInputModel.fromJS(_data["relationType"]) : undefined as any;
        }
    }

    static fromJS(data: any): MappingRelationInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new MappingRelationInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source ? this.source.toJSON() : undefined as any;
        data["target"] = this.target ? this.target.toJSON() : undefined as any;
        data["relationType"] = this.relationType ? this.relationType.toJSON() : undefined as any;
        return data;
    }
}

export interface IMappingRelationInputModel {
    source: UriInputModel | undefined;
    target: UriInputModel | undefined;
    relationType: CodeInputModel | undefined;
}

export class MappingRelationModel implements IMappingRelationModel {
    id?: string;
    source!: MappingRelationUriModel | undefined;
    target!: MappingRelationUriModel | undefined;
    relationType!: VocabularyEntryModel | undefined;

    constructor(data?: IMappingRelationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.source = _data["source"] ? MappingRelationUriModel.fromJS(_data["source"]) : undefined as any;
            this.target = _data["target"] ? MappingRelationUriModel.fromJS(_data["target"]) : undefined as any;
            this.relationType = _data["relationType"] ? VocabularyEntryModel.fromJS(_data["relationType"]) : undefined as any;
        }
    }

    static fromJS(data: any): MappingRelationModel {
        data = typeof data === 'object' ? data : {};
        let result = new MappingRelationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["source"] = this.source ? this.source.toJSON() : undefined as any;
        data["target"] = this.target ? this.target.toJSON() : undefined as any;
        data["relationType"] = this.relationType ? this.relationType.toJSON() : undefined as any;
        return data;
    }
}

export interface IMappingRelationModel {
    id?: string;
    source: MappingRelationUriModel | undefined;
    target: MappingRelationUriModel | undefined;
    relationType: VocabularyEntryModel | undefined;
}

export class MappingRelationUriModel implements IMappingRelationUriModel {
    uri!: string | undefined;
    code?: string | undefined;
    name?: MultiLanguageModel | undefined;

    constructor(data?: IMappingRelationUriModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uri = _data["uri"];
            this.code = _data["code"];
            this.name = _data["name"] ? MultiLanguageModel.fromJS(_data["name"]) : undefined as any;
        }
    }

    static fromJS(data: any): MappingRelationUriModel {
        data = typeof data === 'object' ? data : {};
        let result = new MappingRelationUriModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uri"] = this.uri;
        data["code"] = this.code;
        data["name"] = this.name ? this.name.toJSON() : undefined as any;
        return data;
    }
}

export interface IMappingRelationUriModel {
    uri: string | undefined;
    code?: string | undefined;
    name?: MultiLanguageModel | undefined;
}

export enum MappingRelationsDataFormat {
    Json = "Json",
    Csv = "Csv",
}

export class MappingTableInputModel implements IMappingTableInputModel {
    conformsTo?: ResourceModel[] | undefined;
    description!: MultiLanguageModel | undefined;
    identifiers?: string[] | undefined;
    keywords?: KeywordModel[] | undefined;
    name!: MultiLanguageModel | undefined;
    publisher!: IdentifierInputModel | undefined;
    responsibleDeputy?: EmailInputModel | undefined;
    responsiblePerson!: EmailInputModel | undefined;
    source!: UriInputModel | undefined;
    target!: UriInputModel | undefined;
    themes?: CodeInputModel[] | undefined;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
    version!: string | undefined;

    constructor(data?: IMappingTableInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["conformsTo"])) {
                this.conformsTo = [] as any;
                for (let item of _data["conformsTo"])
                    this.conformsTo!.push(ResourceModel.fromJS(item));
            }
            this.description = _data["description"] ? MultiLanguageModel.fromJS(_data["description"]) : undefined as any;
            if (Array.isArray(_data["identifiers"])) {
                this.identifiers = [] as any;
                for (let item of _data["identifiers"])
                    this.identifiers!.push(item);
            }
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(KeywordModel.fromJS(item));
            }
            this.name = _data["name"] ? MultiLanguageModel.fromJS(_data["name"]) : undefined as any;
            this.publisher = _data["publisher"] ? IdentifierInputModel.fromJS(_data["publisher"]) : undefined as any;
            this.responsibleDeputy = _data["responsibleDeputy"] ? EmailInputModel.fromJS(_data["responsibleDeputy"]) : undefined as any;
            this.responsiblePerson = _data["responsiblePerson"] ? EmailInputModel.fromJS(_data["responsiblePerson"]) : undefined as any;
            this.source = _data["source"] ? UriInputModel.fromJS(_data["source"]) : undefined as any;
            this.target = _data["target"] ? UriInputModel.fromJS(_data["target"]) : undefined as any;
            if (Array.isArray(_data["themes"])) {
                this.themes = [] as any;
                for (let item of _data["themes"])
                    this.themes!.push(CodeInputModel.fromJS(item));
            }
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : undefined as any;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : undefined as any;
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): MappingTableInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new MappingTableInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.conformsTo)) {
            data["conformsTo"] = [];
            for (let item of this.conformsTo)
                data["conformsTo"].push(item ? item.toJSON() : undefined as any);
        }
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        if (Array.isArray(this.identifiers)) {
            data["identifiers"] = [];
            for (let item of this.identifiers)
                data["identifiers"].push(item);
        }
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item ? item.toJSON() : undefined as any);
        }
        data["name"] = this.name ? this.name.toJSON() : undefined as any;
        data["publisher"] = this.publisher ? this.publisher.toJSON() : undefined as any;
        data["responsibleDeputy"] = this.responsibleDeputy ? this.responsibleDeputy.toJSON() : undefined as any;
        data["responsiblePerson"] = this.responsiblePerson ? this.responsiblePerson.toJSON() : undefined as any;
        data["source"] = this.source ? this.source.toJSON() : undefined as any;
        data["target"] = this.target ? this.target.toJSON() : undefined as any;
        if (Array.isArray(this.themes)) {
            data["themes"] = [];
            for (let item of this.themes)
                data["themes"].push(item ? item.toJSON() : undefined as any);
        }
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : undefined as any;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : undefined as any;
        data["version"] = this.version;
        return data;
    }
}

export interface IMappingTableInputModel {
    conformsTo?: ResourceModel[] | undefined;
    description: MultiLanguageModel | undefined;
    identifiers?: string[] | undefined;
    keywords?: KeywordModel[] | undefined;
    name: MultiLanguageModel | undefined;
    publisher: IdentifierInputModel | undefined;
    responsibleDeputy?: EmailInputModel | undefined;
    responsiblePerson: EmailInputModel | undefined;
    source: UriInputModel | undefined;
    target: UriInputModel | undefined;
    themes?: CodeInputModel[] | undefined;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
    version: string | undefined;
}

export class MappingTableModel implements IMappingTableModel {
    conformsTo?: ResourceModel[] | undefined;
    description!: MultiLanguageModel | undefined;
    id?: string;
    identifiers?: string[] | undefined;
    keywords?: KeywordModel[] | undefined;
    name!: MultiLanguageModel | undefined;
    publicationLevel?: PublicationLevel;
    publicationLevelProposal?: PublicationLevel | undefined;
    publisher!: AgentModel | undefined;
    registrationStatus?: RegistrationStatus;
    registrationStatusProposal?: RegistrationStatus | undefined;
    responsibleDeputy?: IopPersonModel | undefined;
    responsiblePerson!: IopPersonModel | undefined;
    system!: SystemInfoModel | undefined;
    source!: MappingTableUriModel | undefined;
    target!: MappingTableUriModel | undefined;
    themes?: VocabularyEntryModel[] | undefined;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
    version!: string | undefined;

    constructor(data?: IMappingTableModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["conformsTo"])) {
                this.conformsTo = [] as any;
                for (let item of _data["conformsTo"])
                    this.conformsTo!.push(ResourceModel.fromJS(item));
            }
            this.description = _data["description"] ? MultiLanguageModel.fromJS(_data["description"]) : undefined as any;
            this.id = _data["id"];
            if (Array.isArray(_data["identifiers"])) {
                this.identifiers = [] as any;
                for (let item of _data["identifiers"])
                    this.identifiers!.push(item);
            }
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(KeywordModel.fromJS(item));
            }
            this.name = _data["name"] ? MultiLanguageModel.fromJS(_data["name"]) : undefined as any;
            this.publicationLevel = _data["publicationLevel"];
            this.publicationLevelProposal = _data["publicationLevelProposal"];
            this.publisher = _data["publisher"] ? AgentModel.fromJS(_data["publisher"]) : undefined as any;
            this.registrationStatus = _data["registrationStatus"];
            this.registrationStatusProposal = _data["registrationStatusProposal"];
            this.responsibleDeputy = _data["responsibleDeputy"] ? IopPersonModel.fromJS(_data["responsibleDeputy"]) : undefined as any;
            this.responsiblePerson = _data["responsiblePerson"] ? IopPersonModel.fromJS(_data["responsiblePerson"]) : undefined as any;
            this.system = _data["system"] ? SystemInfoModel.fromJS(_data["system"]) : undefined as any;
            this.source = _data["source"] ? MappingTableUriModel.fromJS(_data["source"]) : undefined as any;
            this.target = _data["target"] ? MappingTableUriModel.fromJS(_data["target"]) : undefined as any;
            if (Array.isArray(_data["themes"])) {
                this.themes = [] as any;
                for (let item of _data["themes"])
                    this.themes!.push(VocabularyEntryModel.fromJS(item));
            }
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : undefined as any;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : undefined as any;
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): MappingTableModel {
        data = typeof data === 'object' ? data : {};
        let result = new MappingTableModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.conformsTo)) {
            data["conformsTo"] = [];
            for (let item of this.conformsTo)
                data["conformsTo"].push(item ? item.toJSON() : undefined as any);
        }
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        data["id"] = this.id;
        if (Array.isArray(this.identifiers)) {
            data["identifiers"] = [];
            for (let item of this.identifiers)
                data["identifiers"].push(item);
        }
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item ? item.toJSON() : undefined as any);
        }
        data["name"] = this.name ? this.name.toJSON() : undefined as any;
        data["publicationLevel"] = this.publicationLevel;
        data["publicationLevelProposal"] = this.publicationLevelProposal;
        data["publisher"] = this.publisher ? this.publisher.toJSON() : undefined as any;
        data["registrationStatus"] = this.registrationStatus;
        data["registrationStatusProposal"] = this.registrationStatusProposal;
        data["responsibleDeputy"] = this.responsibleDeputy ? this.responsibleDeputy.toJSON() : undefined as any;
        data["responsiblePerson"] = this.responsiblePerson ? this.responsiblePerson.toJSON() : undefined as any;
        data["system"] = this.system ? this.system.toJSON() : undefined as any;
        data["source"] = this.source ? this.source.toJSON() : undefined as any;
        data["target"] = this.target ? this.target.toJSON() : undefined as any;
        if (Array.isArray(this.themes)) {
            data["themes"] = [];
            for (let item of this.themes)
                data["themes"].push(item ? item.toJSON() : undefined as any);
        }
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : undefined as any;
        data["validTo"] = this.validTo ? this.validTo.toISOString() : undefined as any;
        data["version"] = this.version;
        return data;
    }
}

export interface IMappingTableModel {
    conformsTo?: ResourceModel[] | undefined;
    description: MultiLanguageModel | undefined;
    id?: string;
    identifiers?: string[] | undefined;
    keywords?: KeywordModel[] | undefined;
    name: MultiLanguageModel | undefined;
    publicationLevel?: PublicationLevel;
    publicationLevelProposal?: PublicationLevel | undefined;
    publisher: AgentModel | undefined;
    registrationStatus?: RegistrationStatus;
    registrationStatusProposal?: RegistrationStatus | undefined;
    responsibleDeputy?: IopPersonModel | undefined;
    responsiblePerson: IopPersonModel | undefined;
    system: SystemInfoModel | undefined;
    source: MappingTableUriModel | undefined;
    target: MappingTableUriModel | undefined;
    themes?: VocabularyEntryModel[] | undefined;
    validFrom?: Date | undefined;
    validTo?: Date | undefined;
    version: string | undefined;
}

export class MappingTableUriModel implements IMappingTableUriModel {
    uri!: string | undefined;
    name?: MultiLanguageModel | undefined;

    constructor(data?: IMappingTableUriModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uri = _data["uri"];
            this.name = _data["name"] ? MultiLanguageModel.fromJS(_data["name"]) : undefined as any;
        }
    }

    static fromJS(data: any): MappingTableUriModel {
        data = typeof data === 'object' ? data : {};
        let result = new MappingTableUriModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uri"] = this.uri;
        data["name"] = this.name ? this.name.toJSON() : undefined as any;
        return data;
    }
}

export interface IMappingTableUriModel {
    uri: string | undefined;
    name?: MultiLanguageModel | undefined;
}

export class MetaSearchResultItem implements IMetaSearchResultItem {
    description?: LocalizedText | undefined;
    identifier?: string | undefined;
    link?: string | undefined;
    title?: LocalizedText | undefined;

    constructor(data?: IMetaSearchResultItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"] ? LocalizedText.fromJS(_data["description"]) : undefined as any;
            this.identifier = _data["identifier"];
            this.link = _data["link"];
            this.title = _data["title"] ? LocalizedText.fromJS(_data["title"]) : undefined as any;
        }
    }

    static fromJS(data: any): MetaSearchResultItem {
        data = typeof data === 'object' ? data : {};
        let result = new MetaSearchResultItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        data["identifier"] = this.identifier;
        data["link"] = this.link;
        data["title"] = this.title ? this.title.toJSON() : undefined as any;
        return data;
    }
}

export interface IMetaSearchResultItem {
    description?: LocalizedText | undefined;
    identifier?: string | undefined;
    link?: string | undefined;
    title?: LocalizedText | undefined;
}

export class MultiLanguage implements IMultiLanguage {
    de?: string | undefined;
    en?: string | undefined;
    fr?: string | undefined;
    it?: string | undefined;
    rm?: string | undefined;

    constructor(data?: IMultiLanguage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.de = _data["de"];
            this.en = _data["en"];
            this.fr = _data["fr"];
            this.it = _data["it"];
            this.rm = _data["rm"];
        }
    }

    static fromJS(data: any): MultiLanguage {
        data = typeof data === 'object' ? data : {};
        let result = new MultiLanguage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["de"] = this.de;
        data["en"] = this.en;
        data["fr"] = this.fr;
        data["it"] = this.it;
        data["rm"] = this.rm;
        return data;
    }
}

export interface IMultiLanguage {
    de?: string | undefined;
    en?: string | undefined;
    fr?: string | undefined;
    it?: string | undefined;
    rm?: string | undefined;
}

export class MultiLanguageModel implements IMultiLanguageModel {
    de?: string | undefined;
    en?: string | undefined;
    fr?: string | undefined;
    it?: string | undefined;
    rm?: string | undefined;

    constructor(data?: IMultiLanguageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.de = _data["de"];
            this.en = _data["en"];
            this.fr = _data["fr"];
            this.it = _data["it"];
            this.rm = _data["rm"];
        }
    }

    static fromJS(data: any): MultiLanguageModel {
        data = typeof data === 'object' ? data : {};
        let result = new MultiLanguageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["de"] = this.de;
        data["en"] = this.en;
        data["fr"] = this.fr;
        data["it"] = this.it;
        data["rm"] = this.rm;
        return data;
    }
}

export interface IMultiLanguageModel {
    de?: string | undefined;
    en?: string | undefined;
    fr?: string | undefined;
    it?: string | undefined;
    rm?: string | undefined;
}

export enum OccurType {
    Must = "Must",
    Should = "Should",
    MustNot = "MustNot",
}

export class PeriodOfTime implements IPeriodOfTime {
    end?: Date | undefined;
    start?: Date | undefined;

    constructor(data?: IPeriodOfTime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.end = _data["end"] ? new Date(_data["end"].toString()) : undefined as any;
            this.start = _data["start"] ? new Date(_data["start"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PeriodOfTime {
        data = typeof data === 'object' ? data : {};
        let result = new PeriodOfTime();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["end"] = this.end ? this.end.toISOString() : undefined as any;
        data["start"] = this.start ? this.start.toISOString() : undefined as any;
        return data;
    }
}

export interface IPeriodOfTime {
    end?: Date | undefined;
    start?: Date | undefined;
}

export class PeriodOfTimeModel implements IPeriodOfTimeModel {
    start?: Date | undefined;
    end?: Date | undefined;

    constructor(data?: IPeriodOfTimeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : undefined as any;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PeriodOfTimeModel {
        data = typeof data === 'object' ? data : {};
        let result = new PeriodOfTimeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toISOString() : undefined as any;
        data["end"] = this.end ? this.end.toISOString() : undefined as any;
        return data;
    }
}

export interface IPeriodOfTimeModel {
    start?: Date | undefined;
    end?: Date | undefined;
}

export class Person implements IPerson {
    id?: string;
    identifier?: string | undefined;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;

    constructor(data?: IPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.identifier = _data["identifier"];
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): Person {
        data = typeof data === 'object' ? data : {};
        let result = new Person();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["identifier"] = this.identifier;
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }
}

export interface IPerson {
    id?: string;
    identifier?: string | undefined;
    name?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class PublicServiceInput implements IPublicServiceInput {
    businessEventsCodes?: string[] | undefined;
    channels?: ChannelInputModel[] | undefined;
    competentAuthority?: IdentifierInputModel | undefined;
    description?: MultiLanguage | undefined;
    id?: string;
    identifiers?: string[] | undefined;
    isDescribedAt?: IdModel[] | undefined;
    keywords?: KeywordModel[] | undefined;
    languageCodes?: string[] | undefined;
    lifeEventsCodes?: string[] | undefined;
    relations?: IdModel[] | undefined;
    requires?: IdModel[] | undefined;
    responsibleDeputy?: EmailInputModel | undefined;
    responsiblePerson?: EmailInputModel | undefined;
    sectorCodes?: string[] | undefined;
    spatial?: string[] | undefined;
    thematicAreaCodes?: string[] | undefined;
    title?: MultiLanguage | undefined;
    spatialCH?: VocabularyEntry[] | undefined;

    constructor(data?: IPublicServiceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["businessEventsCodes"])) {
                this.businessEventsCodes = [] as any;
                for (let item of _data["businessEventsCodes"])
                    this.businessEventsCodes!.push(item);
            }
            if (Array.isArray(_data["channels"])) {
                this.channels = [] as any;
                for (let item of _data["channels"])
                    this.channels!.push(ChannelInputModel.fromJS(item));
            }
            this.competentAuthority = _data["competentAuthority"] ? IdentifierInputModel.fromJS(_data["competentAuthority"]) : undefined as any;
            this.description = _data["description"] ? MultiLanguage.fromJS(_data["description"]) : undefined as any;
            this.id = _data["id"];
            if (Array.isArray(_data["identifiers"])) {
                this.identifiers = [] as any;
                for (let item of _data["identifiers"])
                    this.identifiers!.push(item);
            }
            if (Array.isArray(_data["isDescribedAt"])) {
                this.isDescribedAt = [] as any;
                for (let item of _data["isDescribedAt"])
                    this.isDescribedAt!.push(IdModel.fromJS(item));
            }
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(KeywordModel.fromJS(item));
            }
            if (Array.isArray(_data["languageCodes"])) {
                this.languageCodes = [] as any;
                for (let item of _data["languageCodes"])
                    this.languageCodes!.push(item);
            }
            if (Array.isArray(_data["lifeEventsCodes"])) {
                this.lifeEventsCodes = [] as any;
                for (let item of _data["lifeEventsCodes"])
                    this.lifeEventsCodes!.push(item);
            }
            if (Array.isArray(_data["relations"])) {
                this.relations = [] as any;
                for (let item of _data["relations"])
                    this.relations!.push(IdModel.fromJS(item));
            }
            if (Array.isArray(_data["requires"])) {
                this.requires = [] as any;
                for (let item of _data["requires"])
                    this.requires!.push(IdModel.fromJS(item));
            }
            this.responsibleDeputy = _data["responsibleDeputy"] ? EmailInputModel.fromJS(_data["responsibleDeputy"]) : undefined as any;
            this.responsiblePerson = _data["responsiblePerson"] ? EmailInputModel.fromJS(_data["responsiblePerson"]) : undefined as any;
            if (Array.isArray(_data["sectorCodes"])) {
                this.sectorCodes = [] as any;
                for (let item of _data["sectorCodes"])
                    this.sectorCodes!.push(item);
            }
            if (Array.isArray(_data["spatial"])) {
                this.spatial = [] as any;
                for (let item of _data["spatial"])
                    this.spatial!.push(item);
            }
            if (Array.isArray(_data["thematicAreaCodes"])) {
                this.thematicAreaCodes = [] as any;
                for (let item of _data["thematicAreaCodes"])
                    this.thematicAreaCodes!.push(item);
            }
            this.title = _data["title"] ? MultiLanguage.fromJS(_data["title"]) : undefined as any;
            if (Array.isArray(_data["spatialCH"])) {
                this.spatialCH = [] as any;
                for (let item of _data["spatialCH"])
                    this.spatialCH!.push(VocabularyEntry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PublicServiceInput {
        data = typeof data === 'object' ? data : {};
        let result = new PublicServiceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.businessEventsCodes)) {
            data["businessEventsCodes"] = [];
            for (let item of this.businessEventsCodes)
                data["businessEventsCodes"].push(item);
        }
        if (Array.isArray(this.channels)) {
            data["channels"] = [];
            for (let item of this.channels)
                data["channels"].push(item ? item.toJSON() : undefined as any);
        }
        data["competentAuthority"] = this.competentAuthority ? this.competentAuthority.toJSON() : undefined as any;
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        data["id"] = this.id;
        if (Array.isArray(this.identifiers)) {
            data["identifiers"] = [];
            for (let item of this.identifiers)
                data["identifiers"].push(item);
        }
        if (Array.isArray(this.isDescribedAt)) {
            data["isDescribedAt"] = [];
            for (let item of this.isDescribedAt)
                data["isDescribedAt"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.languageCodes)) {
            data["languageCodes"] = [];
            for (let item of this.languageCodes)
                data["languageCodes"].push(item);
        }
        if (Array.isArray(this.lifeEventsCodes)) {
            data["lifeEventsCodes"] = [];
            for (let item of this.lifeEventsCodes)
                data["lifeEventsCodes"].push(item);
        }
        if (Array.isArray(this.relations)) {
            data["relations"] = [];
            for (let item of this.relations)
                data["relations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.requires)) {
            data["requires"] = [];
            for (let item of this.requires)
                data["requires"].push(item ? item.toJSON() : undefined as any);
        }
        data["responsibleDeputy"] = this.responsibleDeputy ? this.responsibleDeputy.toJSON() : undefined as any;
        data["responsiblePerson"] = this.responsiblePerson ? this.responsiblePerson.toJSON() : undefined as any;
        if (Array.isArray(this.sectorCodes)) {
            data["sectorCodes"] = [];
            for (let item of this.sectorCodes)
                data["sectorCodes"].push(item);
        }
        if (Array.isArray(this.spatial)) {
            data["spatial"] = [];
            for (let item of this.spatial)
                data["spatial"].push(item);
        }
        if (Array.isArray(this.thematicAreaCodes)) {
            data["thematicAreaCodes"] = [];
            for (let item of this.thematicAreaCodes)
                data["thematicAreaCodes"].push(item);
        }
        data["title"] = this.title ? this.title.toJSON() : undefined as any;
        if (Array.isArray(this.spatialCH)) {
            data["spatialCH"] = [];
            for (let item of this.spatialCH)
                data["spatialCH"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPublicServiceInput {
    businessEventsCodes?: string[] | undefined;
    channels?: ChannelInputModel[] | undefined;
    competentAuthority?: IdentifierInputModel | undefined;
    description?: MultiLanguage | undefined;
    id?: string;
    identifiers?: string[] | undefined;
    isDescribedAt?: IdModel[] | undefined;
    keywords?: KeywordModel[] | undefined;
    languageCodes?: string[] | undefined;
    lifeEventsCodes?: string[] | undefined;
    relations?: IdModel[] | undefined;
    requires?: IdModel[] | undefined;
    responsibleDeputy?: EmailInputModel | undefined;
    responsiblePerson?: EmailInputModel | undefined;
    sectorCodes?: string[] | undefined;
    spatial?: string[] | undefined;
    thematicAreaCodes?: string[] | undefined;
    title?: MultiLanguage | undefined;
    spatialCH?: VocabularyEntry[] | undefined;
}

export class PublicServiceModel implements IPublicServiceModel {
    businessEvents?: VocabularyEntryModel[] | undefined;
    channels?: ChannelModel[] | undefined;
    description!: MultiLanguageModel | undefined;
    id?: string;
    identifiers?: string[] | undefined;
    isDescribedAt?: IdModel[] | undefined;
    keywords?: KeywordModel[] | undefined;
    languages?: VocabularyEntryModel[] | undefined;
    lifeEvents?: VocabularyEntryModel[] | undefined;
    name!: MultiLanguageModel | undefined;
    publicationLevel?: PublicationLevel;
    publicationLevelProposal?: PublicationLevel | undefined;
    publisher!: AgentModel | undefined;
    registrationStatus?: RegistrationStatus;
    registrationStatusProposal?: RegistrationStatus | undefined;
    relations?: IdModel[] | undefined;
    requires?: IdModel[] | undefined;
    responsibleDeputy?: IopPersonModel | undefined;
    responsiblePerson?: IopPersonModel | undefined;
    sectors?: VocabularyEntryModel[] | undefined;
    system!: SystemInfoModel | undefined;
    spatial?: string[] | undefined;
    thematicAreas?: VocabularyEntryModel[] | undefined;
    spatialCH?: VocabularyEntryModel[] | undefined;

    constructor(data?: IPublicServiceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["businessEvents"])) {
                this.businessEvents = [] as any;
                for (let item of _data["businessEvents"])
                    this.businessEvents!.push(VocabularyEntryModel.fromJS(item));
            }
            if (Array.isArray(_data["channels"])) {
                this.channels = [] as any;
                for (let item of _data["channels"])
                    this.channels!.push(ChannelModel.fromJS(item));
            }
            this.description = _data["description"] ? MultiLanguageModel.fromJS(_data["description"]) : undefined as any;
            this.id = _data["id"];
            if (Array.isArray(_data["identifiers"])) {
                this.identifiers = [] as any;
                for (let item of _data["identifiers"])
                    this.identifiers!.push(item);
            }
            if (Array.isArray(_data["isDescribedAt"])) {
                this.isDescribedAt = [] as any;
                for (let item of _data["isDescribedAt"])
                    this.isDescribedAt!.push(IdModel.fromJS(item));
            }
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(KeywordModel.fromJS(item));
            }
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(VocabularyEntryModel.fromJS(item));
            }
            if (Array.isArray(_data["lifeEvents"])) {
                this.lifeEvents = [] as any;
                for (let item of _data["lifeEvents"])
                    this.lifeEvents!.push(VocabularyEntryModel.fromJS(item));
            }
            this.name = _data["name"] ? MultiLanguageModel.fromJS(_data["name"]) : undefined as any;
            this.publicationLevel = _data["publicationLevel"];
            this.publicationLevelProposal = _data["publicationLevelProposal"];
            this.publisher = _data["publisher"] ? AgentModel.fromJS(_data["publisher"]) : undefined as any;
            this.registrationStatus = _data["registrationStatus"];
            this.registrationStatusProposal = _data["registrationStatusProposal"];
            if (Array.isArray(_data["relations"])) {
                this.relations = [] as any;
                for (let item of _data["relations"])
                    this.relations!.push(IdModel.fromJS(item));
            }
            if (Array.isArray(_data["requires"])) {
                this.requires = [] as any;
                for (let item of _data["requires"])
                    this.requires!.push(IdModel.fromJS(item));
            }
            this.responsibleDeputy = _data["responsibleDeputy"] ? IopPersonModel.fromJS(_data["responsibleDeputy"]) : undefined as any;
            this.responsiblePerson = _data["responsiblePerson"] ? IopPersonModel.fromJS(_data["responsiblePerson"]) : undefined as any;
            if (Array.isArray(_data["sectors"])) {
                this.sectors = [] as any;
                for (let item of _data["sectors"])
                    this.sectors!.push(VocabularyEntryModel.fromJS(item));
            }
            this.system = _data["system"] ? SystemInfoModel.fromJS(_data["system"]) : undefined as any;
            if (Array.isArray(_data["spatial"])) {
                this.spatial = [] as any;
                for (let item of _data["spatial"])
                    this.spatial!.push(item);
            }
            if (Array.isArray(_data["thematicAreas"])) {
                this.thematicAreas = [] as any;
                for (let item of _data["thematicAreas"])
                    this.thematicAreas!.push(VocabularyEntryModel.fromJS(item));
            }
            if (Array.isArray(_data["spatialCH"])) {
                this.spatialCH = [] as any;
                for (let item of _data["spatialCH"])
                    this.spatialCH!.push(VocabularyEntryModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PublicServiceModel {
        data = typeof data === 'object' ? data : {};
        let result = new PublicServiceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.businessEvents)) {
            data["businessEvents"] = [];
            for (let item of this.businessEvents)
                data["businessEvents"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.channels)) {
            data["channels"] = [];
            for (let item of this.channels)
                data["channels"].push(item ? item.toJSON() : undefined as any);
        }
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        data["id"] = this.id;
        if (Array.isArray(this.identifiers)) {
            data["identifiers"] = [];
            for (let item of this.identifiers)
                data["identifiers"].push(item);
        }
        if (Array.isArray(this.isDescribedAt)) {
            data["isDescribedAt"] = [];
            for (let item of this.isDescribedAt)
                data["isDescribedAt"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.lifeEvents)) {
            data["lifeEvents"] = [];
            for (let item of this.lifeEvents)
                data["lifeEvents"].push(item ? item.toJSON() : undefined as any);
        }
        data["name"] = this.name ? this.name.toJSON() : undefined as any;
        data["publicationLevel"] = this.publicationLevel;
        data["publicationLevelProposal"] = this.publicationLevelProposal;
        data["publisher"] = this.publisher ? this.publisher.toJSON() : undefined as any;
        data["registrationStatus"] = this.registrationStatus;
        data["registrationStatusProposal"] = this.registrationStatusProposal;
        if (Array.isArray(this.relations)) {
            data["relations"] = [];
            for (let item of this.relations)
                data["relations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.requires)) {
            data["requires"] = [];
            for (let item of this.requires)
                data["requires"].push(item ? item.toJSON() : undefined as any);
        }
        data["responsibleDeputy"] = this.responsibleDeputy ? this.responsibleDeputy.toJSON() : undefined as any;
        data["responsiblePerson"] = this.responsiblePerson ? this.responsiblePerson.toJSON() : undefined as any;
        if (Array.isArray(this.sectors)) {
            data["sectors"] = [];
            for (let item of this.sectors)
                data["sectors"].push(item ? item.toJSON() : undefined as any);
        }
        data["system"] = this.system ? this.system.toJSON() : undefined as any;
        if (Array.isArray(this.spatial)) {
            data["spatial"] = [];
            for (let item of this.spatial)
                data["spatial"].push(item);
        }
        if (Array.isArray(this.thematicAreas)) {
            data["thematicAreas"] = [];
            for (let item of this.thematicAreas)
                data["thematicAreas"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.spatialCH)) {
            data["spatialCH"] = [];
            for (let item of this.spatialCH)
                data["spatialCH"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPublicServiceModel {
    businessEvents?: VocabularyEntryModel[] | undefined;
    channels?: ChannelModel[] | undefined;
    description: MultiLanguageModel | undefined;
    id?: string;
    identifiers?: string[] | undefined;
    isDescribedAt?: IdModel[] | undefined;
    keywords?: KeywordModel[] | undefined;
    languages?: VocabularyEntryModel[] | undefined;
    lifeEvents?: VocabularyEntryModel[] | undefined;
    name: MultiLanguageModel | undefined;
    publicationLevel?: PublicationLevel;
    publicationLevelProposal?: PublicationLevel | undefined;
    publisher: AgentModel | undefined;
    registrationStatus?: RegistrationStatus;
    registrationStatusProposal?: RegistrationStatus | undefined;
    relations?: IdModel[] | undefined;
    requires?: IdModel[] | undefined;
    responsibleDeputy?: IopPersonModel | undefined;
    responsiblePerson?: IopPersonModel | undefined;
    sectors?: VocabularyEntryModel[] | undefined;
    system: SystemInfoModel | undefined;
    spatial?: string[] | undefined;
    thematicAreas?: VocabularyEntryModel[] | undefined;
    spatialCH?: VocabularyEntryModel[] | undefined;
}

export class PublicServiceView implements IPublicServiceView {
    businessEvents?: VocabularyEntry[] | undefined;
    channels?: ChannelModel[] | undefined;
    competentAuthority?: Agent | undefined;
    description?: MultiLanguage | undefined;
    id?: string;
    identifiers?: string[] | undefined;
    isDescribedAt?: IdLabel[] | undefined;
    keywords?: KeywordModel[] | undefined;
    languages?: VocabularyEntry[] | undefined;
    lifeEvents?: VocabularyEntry[] | undefined;
    publicationLevel?: PublicationLevel;
    publicationLevelProposal?: PublicationLevel | undefined;
    registrationStatus?: RegistrationStatus;
    registrationStatusProposal?: RegistrationStatus | undefined;
    relation?: IdLabel[] | undefined;
    requires?: IdLabel[] | undefined;
    responsibleDeputy?: IopPersonModel | undefined;
    responsiblePerson?: IopPersonModel | undefined;
    sectors?: VocabularyEntry[] | undefined;
    spatial?: string[] | undefined;
    system?: SystemInfoModel | undefined;
    thematicAreas?: VocabularyEntry[] | undefined;
    title?: MultiLanguage | undefined;
    spatialCH?: VocabularyEntry[] | undefined;

    constructor(data?: IPublicServiceView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["businessEvents"])) {
                this.businessEvents = [] as any;
                for (let item of _data["businessEvents"])
                    this.businessEvents!.push(VocabularyEntry.fromJS(item));
            }
            if (Array.isArray(_data["channels"])) {
                this.channels = [] as any;
                for (let item of _data["channels"])
                    this.channels!.push(ChannelModel.fromJS(item));
            }
            this.competentAuthority = _data["competentAuthority"] ? Agent.fromJS(_data["competentAuthority"]) : undefined as any;
            this.description = _data["description"] ? MultiLanguage.fromJS(_data["description"]) : undefined as any;
            this.id = _data["id"];
            if (Array.isArray(_data["identifiers"])) {
                this.identifiers = [] as any;
                for (let item of _data["identifiers"])
                    this.identifiers!.push(item);
            }
            if (Array.isArray(_data["isDescribedAt"])) {
                this.isDescribedAt = [] as any;
                for (let item of _data["isDescribedAt"])
                    this.isDescribedAt!.push(IdLabel.fromJS(item));
            }
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(KeywordModel.fromJS(item));
            }
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(VocabularyEntry.fromJS(item));
            }
            if (Array.isArray(_data["lifeEvents"])) {
                this.lifeEvents = [] as any;
                for (let item of _data["lifeEvents"])
                    this.lifeEvents!.push(VocabularyEntry.fromJS(item));
            }
            this.publicationLevel = _data["publicationLevel"];
            this.publicationLevelProposal = _data["publicationLevelProposal"];
            this.registrationStatus = _data["registrationStatus"];
            this.registrationStatusProposal = _data["registrationStatusProposal"];
            if (Array.isArray(_data["relation"])) {
                this.relation = [] as any;
                for (let item of _data["relation"])
                    this.relation!.push(IdLabel.fromJS(item));
            }
            if (Array.isArray(_data["requires"])) {
                this.requires = [] as any;
                for (let item of _data["requires"])
                    this.requires!.push(IdLabel.fromJS(item));
            }
            this.responsibleDeputy = _data["responsibleDeputy"] ? IopPersonModel.fromJS(_data["responsibleDeputy"]) : undefined as any;
            this.responsiblePerson = _data["responsiblePerson"] ? IopPersonModel.fromJS(_data["responsiblePerson"]) : undefined as any;
            if (Array.isArray(_data["sectors"])) {
                this.sectors = [] as any;
                for (let item of _data["sectors"])
                    this.sectors!.push(VocabularyEntry.fromJS(item));
            }
            if (Array.isArray(_data["spatial"])) {
                this.spatial = [] as any;
                for (let item of _data["spatial"])
                    this.spatial!.push(item);
            }
            this.system = _data["system"] ? SystemInfoModel.fromJS(_data["system"]) : undefined as any;
            if (Array.isArray(_data["thematicAreas"])) {
                this.thematicAreas = [] as any;
                for (let item of _data["thematicAreas"])
                    this.thematicAreas!.push(VocabularyEntry.fromJS(item));
            }
            this.title = _data["title"] ? MultiLanguage.fromJS(_data["title"]) : undefined as any;
            if (Array.isArray(_data["spatialCH"])) {
                this.spatialCH = [] as any;
                for (let item of _data["spatialCH"])
                    this.spatialCH!.push(VocabularyEntry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PublicServiceView {
        data = typeof data === 'object' ? data : {};
        let result = new PublicServiceView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.businessEvents)) {
            data["businessEvents"] = [];
            for (let item of this.businessEvents)
                data["businessEvents"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.channels)) {
            data["channels"] = [];
            for (let item of this.channels)
                data["channels"].push(item ? item.toJSON() : undefined as any);
        }
        data["competentAuthority"] = this.competentAuthority ? this.competentAuthority.toJSON() : undefined as any;
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        data["id"] = this.id;
        if (Array.isArray(this.identifiers)) {
            data["identifiers"] = [];
            for (let item of this.identifiers)
                data["identifiers"].push(item);
        }
        if (Array.isArray(this.isDescribedAt)) {
            data["isDescribedAt"] = [];
            for (let item of this.isDescribedAt)
                data["isDescribedAt"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.lifeEvents)) {
            data["lifeEvents"] = [];
            for (let item of this.lifeEvents)
                data["lifeEvents"].push(item ? item.toJSON() : undefined as any);
        }
        data["publicationLevel"] = this.publicationLevel;
        data["publicationLevelProposal"] = this.publicationLevelProposal;
        data["registrationStatus"] = this.registrationStatus;
        data["registrationStatusProposal"] = this.registrationStatusProposal;
        if (Array.isArray(this.relation)) {
            data["relation"] = [];
            for (let item of this.relation)
                data["relation"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.requires)) {
            data["requires"] = [];
            for (let item of this.requires)
                data["requires"].push(item ? item.toJSON() : undefined as any);
        }
        data["responsibleDeputy"] = this.responsibleDeputy ? this.responsibleDeputy.toJSON() : undefined as any;
        data["responsiblePerson"] = this.responsiblePerson ? this.responsiblePerson.toJSON() : undefined as any;
        if (Array.isArray(this.sectors)) {
            data["sectors"] = [];
            for (let item of this.sectors)
                data["sectors"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.spatial)) {
            data["spatial"] = [];
            for (let item of this.spatial)
                data["spatial"].push(item);
        }
        data["system"] = this.system ? this.system.toJSON() : undefined as any;
        if (Array.isArray(this.thematicAreas)) {
            data["thematicAreas"] = [];
            for (let item of this.thematicAreas)
                data["thematicAreas"].push(item ? item.toJSON() : undefined as any);
        }
        data["title"] = this.title ? this.title.toJSON() : undefined as any;
        if (Array.isArray(this.spatialCH)) {
            data["spatialCH"] = [];
            for (let item of this.spatialCH)
                data["spatialCH"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPublicServiceView {
    businessEvents?: VocabularyEntry[] | undefined;
    channels?: ChannelModel[] | undefined;
    competentAuthority?: Agent | undefined;
    description?: MultiLanguage | undefined;
    id?: string;
    identifiers?: string[] | undefined;
    isDescribedAt?: IdLabel[] | undefined;
    keywords?: KeywordModel[] | undefined;
    languages?: VocabularyEntry[] | undefined;
    lifeEvents?: VocabularyEntry[] | undefined;
    publicationLevel?: PublicationLevel;
    publicationLevelProposal?: PublicationLevel | undefined;
    registrationStatus?: RegistrationStatus;
    registrationStatusProposal?: RegistrationStatus | undefined;
    relation?: IdLabel[] | undefined;
    requires?: IdLabel[] | undefined;
    responsibleDeputy?: IopPersonModel | undefined;
    responsiblePerson?: IopPersonModel | undefined;
    sectors?: VocabularyEntry[] | undefined;
    spatial?: string[] | undefined;
    system?: SystemInfoModel | undefined;
    thematicAreas?: VocabularyEntry[] | undefined;
    title?: MultiLanguage | undefined;
    spatialCH?: VocabularyEntry[] | undefined;
}

export enum PublicationLevel {
    Internal = "Internal",
    Public = "Public",
}

export class PublicationLevelInfoModel implements IPublicationLevelInfoModel {
    allowedLevels?: PublicationLevel[] | undefined;
    allowedProposals?: PublicationLevel[] | undefined;
    canUserRevertProposal?: boolean;
    level?: PublicationLevel;
    proposal?: PublicationLevel | undefined;

    constructor(data?: IPublicationLevelInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["allowedLevels"])) {
                this.allowedLevels = [] as any;
                for (let item of _data["allowedLevels"])
                    this.allowedLevels!.push(item);
            }
            if (Array.isArray(_data["allowedProposals"])) {
                this.allowedProposals = [] as any;
                for (let item of _data["allowedProposals"])
                    this.allowedProposals!.push(item);
            }
            this.canUserRevertProposal = _data["canUserRevertProposal"];
            this.level = _data["level"];
            this.proposal = _data["proposal"];
        }
    }

    static fromJS(data: any): PublicationLevelInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new PublicationLevelInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allowedLevels)) {
            data["allowedLevels"] = [];
            for (let item of this.allowedLevels)
                data["allowedLevels"].push(item);
        }
        if (Array.isArray(this.allowedProposals)) {
            data["allowedProposals"] = [];
            for (let item of this.allowedProposals)
                data["allowedProposals"].push(item);
        }
        data["canUserRevertProposal"] = this.canUserRevertProposal;
        data["level"] = this.level;
        data["proposal"] = this.proposal;
        return data;
    }
}

export interface IPublicationLevelInfoModel {
    allowedLevels?: PublicationLevel[] | undefined;
    allowedProposals?: PublicationLevel[] | undefined;
    canUserRevertProposal?: boolean;
    level?: PublicationLevel;
    proposal?: PublicationLevel | undefined;
}

export class QualifiedAttribution implements IQualifiedAttribution {
    agent?: Agent | undefined;
    datasetQualifiedAttributionId?: string;
    hadRole?: VocabularyEntry | undefined;
    id?: string;

    constructor(data?: IQualifiedAttribution) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.agent = _data["agent"] ? Agent.fromJS(_data["agent"]) : undefined as any;
            this.datasetQualifiedAttributionId = _data["datasetQualifiedAttributionId"];
            this.hadRole = _data["hadRole"] ? VocabularyEntry.fromJS(_data["hadRole"]) : undefined as any;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): QualifiedAttribution {
        data = typeof data === 'object' ? data : {};
        let result = new QualifiedAttribution();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["agent"] = this.agent ? this.agent.toJSON() : undefined as any;
        data["datasetQualifiedAttributionId"] = this.datasetQualifiedAttributionId;
        data["hadRole"] = this.hadRole ? this.hadRole.toJSON() : undefined as any;
        data["id"] = this.id;
        return data;
    }
}

export interface IQualifiedAttribution {
    agent?: Agent | undefined;
    datasetQualifiedAttributionId?: string;
    hadRole?: VocabularyEntry | undefined;
    id?: string;
}

export class QualifiedRelation implements IQualifiedRelation {
    datasetQualifiedRelationId?: string;
    hadRole?: VocabularyEntry | undefined;
    id?: string;
    relation?: Resource | undefined;

    constructor(data?: IQualifiedRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datasetQualifiedRelationId = _data["datasetQualifiedRelationId"];
            this.hadRole = _data["hadRole"] ? VocabularyEntry.fromJS(_data["hadRole"]) : undefined as any;
            this.id = _data["id"];
            this.relation = _data["relation"] ? Resource.fromJS(_data["relation"]) : undefined as any;
        }
    }

    static fromJS(data: any): QualifiedRelation {
        data = typeof data === 'object' ? data : {};
        let result = new QualifiedRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datasetQualifiedRelationId"] = this.datasetQualifiedRelationId;
        data["hadRole"] = this.hadRole ? this.hadRole.toJSON() : undefined as any;
        data["id"] = this.id;
        data["relation"] = this.relation ? this.relation.toJSON() : undefined as any;
        return data;
    }
}

export interface IQualifiedRelation {
    datasetQualifiedRelationId?: string;
    hadRole?: VocabularyEntry | undefined;
    id?: string;
    relation?: Resource | undefined;
}

export enum RegistrationStatus {
    Incomplete = "Incomplete",
    Candidate = "Candidate",
    Recorded = "Recorded",
    Qualified = "Qualified",
    Standard = "Standard",
    PreferredStandard = "PreferredStandard",
    Superseded = "Superseded",
    Retired = "Retired",
}

export class RegistrationStatusInfoModel implements IRegistrationStatusInfoModel {
    allowedProposals?: RegistrationStatus[] | undefined;
    allowedStatuses?: RegistrationStatus[] | undefined;
    canUserRevertProposal?: boolean;
    proposal?: RegistrationStatus | undefined;
    status?: RegistrationStatus;

    constructor(data?: IRegistrationStatusInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["allowedProposals"])) {
                this.allowedProposals = [] as any;
                for (let item of _data["allowedProposals"])
                    this.allowedProposals!.push(item);
            }
            if (Array.isArray(_data["allowedStatuses"])) {
                this.allowedStatuses = [] as any;
                for (let item of _data["allowedStatuses"])
                    this.allowedStatuses!.push(item);
            }
            this.canUserRevertProposal = _data["canUserRevertProposal"];
            this.proposal = _data["proposal"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): RegistrationStatusInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationStatusInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allowedProposals)) {
            data["allowedProposals"] = [];
            for (let item of this.allowedProposals)
                data["allowedProposals"].push(item);
        }
        if (Array.isArray(this.allowedStatuses)) {
            data["allowedStatuses"] = [];
            for (let item of this.allowedStatuses)
                data["allowedStatuses"].push(item);
        }
        data["canUserRevertProposal"] = this.canUserRevertProposal;
        data["proposal"] = this.proposal;
        data["status"] = this.status;
        return data;
    }
}

export interface IRegistrationStatusInfoModel {
    allowedProposals?: RegistrationStatus[] | undefined;
    allowedStatuses?: RegistrationStatus[] | undefined;
    canUserRevertProposal?: boolean;
    proposal?: RegistrationStatus | undefined;
    status?: RegistrationStatus;
}

export class RelationsCountModel implements IRelationsCountModel {
    id!: string;
    total?: number;
    structureAttribute?: number | undefined;
    mappingTable?: number | undefined;
    dataService?: number | undefined;
    publicService?: number | undefined;
    dataset?: number | undefined;

    constructor(data?: IRelationsCountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.total = _data["total"];
            this.structureAttribute = _data["structureAttribute"];
            this.mappingTable = _data["mappingTable"];
            this.dataService = _data["dataService"];
            this.publicService = _data["publicService"];
            this.dataset = _data["dataset"];
        }
    }

    static fromJS(data: any): RelationsCountModel {
        data = typeof data === 'object' ? data : {};
        let result = new RelationsCountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["total"] = this.total;
        data["structureAttribute"] = this.structureAttribute;
        data["mappingTable"] = this.mappingTable;
        data["dataService"] = this.dataService;
        data["publicService"] = this.publicService;
        data["dataset"] = this.dataset;
        return data;
    }
}

export interface IRelationsCountModel {
    id: string;
    total?: number;
    structureAttribute?: number | undefined;
    mappingTable?: number | undefined;
    dataService?: number | undefined;
    publicService?: number | undefined;
    dataset?: number | undefined;
}

export class RelationsCountRequestItem implements IRelationsCountRequestItem {
    id!: string;
    type!: SearchResourceType;

    constructor(data?: IRelationsCountRequestItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): RelationsCountRequestItem {
        data = typeof data === 'object' ? data : {};
        let result = new RelationsCountRequestItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        return data;
    }
}

export interface IRelationsCountRequestItem {
    id: string;
    type: SearchResourceType;
}

export class Resource implements IResource {
    href!: string | undefined;
    label?: MultiLanguage | undefined;

    constructor(data?: IResource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.href = _data["href"];
            this.label = _data["label"] ? MultiLanguage.fromJS(_data["label"]) : undefined as any;
        }
    }

    static fromJS(data: any): Resource {
        data = typeof data === 'object' ? data : {};
        let result = new Resource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["href"] = this.href;
        data["label"] = this.label ? this.label.toJSON() : undefined as any;
        return data;
    }
}

export interface IResource {
    href: string | undefined;
    label?: MultiLanguage | undefined;
}

export class ResourceModel implements IResourceModel {
    label?: MultiLanguageModel | undefined;
    uri!: string | undefined;

    constructor(data?: IResourceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"] ? MultiLanguageModel.fromJS(_data["label"]) : undefined as any;
            this.uri = _data["uri"];
        }
    }

    static fromJS(data: any): ResourceModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label ? this.label.toJSON() : undefined as any;
        data["uri"] = this.uri;
        return data;
    }
}

export interface IResourceModel {
    label?: MultiLanguageModel | undefined;
    uri: string | undefined;
}

export class SchemaClass implements ISchemaClass {
    label?: MultiLanguageModel | undefined;
    description?: MultiLanguageModel | undefined;
    uriComplete!: string | undefined;
    targetClass?: string | undefined;
    point?: SchemaPoint | undefined;
    closed?: boolean | undefined;
    identifier?: string | undefined;
    properties?: SchemaProperty[] | undefined;

    constructor(data?: ISchemaClass) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"] ? MultiLanguageModel.fromJS(_data["label"]) : undefined as any;
            this.description = _data["description"] ? MultiLanguageModel.fromJS(_data["description"]) : undefined as any;
            this.uriComplete = _data["uriComplete"];
            this.targetClass = _data["targetClass"];
            this.point = _data["point"] ? SchemaPoint.fromJS(_data["point"]) : undefined as any;
            this.closed = _data["closed"];
            this.identifier = _data["identifier"];
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties!.push(SchemaProperty.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SchemaClass {
        data = typeof data === 'object' ? data : {};
        let result = new SchemaClass();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label ? this.label.toJSON() : undefined as any;
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        data["uriComplete"] = this.uriComplete;
        data["targetClass"] = this.targetClass;
        data["point"] = this.point ? this.point.toJSON() : undefined as any;
        data["closed"] = this.closed;
        data["identifier"] = this.identifier;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISchemaClass {
    label?: MultiLanguageModel | undefined;
    description?: MultiLanguageModel | undefined;
    uriComplete: string | undefined;
    targetClass?: string | undefined;
    point?: SchemaPoint | undefined;
    closed?: boolean | undefined;
    identifier?: string | undefined;
    properties?: SchemaProperty[] | undefined;
}

export class SchemaGraph implements ISchemaGraph {
    schemaName!: string | undefined;
    classes?: SchemaClass[] | undefined;

    constructor(data?: ISchemaGraph) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.schemaName = _data["schemaName"];
            if (Array.isArray(_data["classes"])) {
                this.classes = [] as any;
                for (let item of _data["classes"])
                    this.classes!.push(SchemaClass.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SchemaGraph {
        data = typeof data === 'object' ? data : {};
        let result = new SchemaGraph();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["schemaName"] = this.schemaName;
        if (Array.isArray(this.classes)) {
            data["classes"] = [];
            for (let item of this.classes)
                data["classes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISchemaGraph {
    schemaName: string | undefined;
    classes?: SchemaClass[] | undefined;
}

export class SchemaPoint implements ISchemaPoint {
    x?: number;
    y?: number;

    constructor(data?: ISchemaPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.x = _data["x"];
            this.y = _data["y"];
        }
    }

    static fromJS(data: any): SchemaPoint {
        data = typeof data === 'object' ? data : {};
        let result = new SchemaPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x;
        data["y"] = this.y;
        return data;
    }
}

export interface ISchemaPoint {
    x?: number;
    y?: number;
}

export class SchemaProperty implements ISchemaProperty {
    path!: string | undefined;
    allowedValues?: string[] | undefined;
    conformsTo?: string | undefined;
    description?: MultiLanguageModel | undefined;
    label?: MultiLanguageModel | undefined;
    dataType?: string | undefined;
    pattern?: string | undefined;
    uriComplete?: string | undefined;
    unit?: string | undefined;
    toClassUri?: string | undefined;
    identifier?: string | undefined;
    minCardinality?: number | undefined;
    maxCardinality?: number | undefined;
    minLength?: number | undefined;
    maxLength?: number | undefined;
    order?: number | undefined;

    constructor(data?: ISchemaProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.path = _data["path"];
            if (Array.isArray(_data["allowedValues"])) {
                this.allowedValues = [] as any;
                for (let item of _data["allowedValues"])
                    this.allowedValues!.push(item);
            }
            this.conformsTo = _data["conformsTo"];
            this.description = _data["description"] ? MultiLanguageModel.fromJS(_data["description"]) : undefined as any;
            this.label = _data["label"] ? MultiLanguageModel.fromJS(_data["label"]) : undefined as any;
            this.dataType = _data["dataType"];
            this.pattern = _data["pattern"];
            this.uriComplete = _data["uriComplete"];
            this.unit = _data["unit"];
            this.toClassUri = _data["toClassUri"];
            this.identifier = _data["identifier"];
            this.minCardinality = _data["minCardinality"];
            this.maxCardinality = _data["maxCardinality"];
            this.minLength = _data["minLength"];
            this.maxLength = _data["maxLength"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): SchemaProperty {
        data = typeof data === 'object' ? data : {};
        let result = new SchemaProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["path"] = this.path;
        if (Array.isArray(this.allowedValues)) {
            data["allowedValues"] = [];
            for (let item of this.allowedValues)
                data["allowedValues"].push(item);
        }
        data["conformsTo"] = this.conformsTo;
        data["description"] = this.description ? this.description.toJSON() : undefined as any;
        data["label"] = this.label ? this.label.toJSON() : undefined as any;
        data["dataType"] = this.dataType;
        data["pattern"] = this.pattern;
        data["uriComplete"] = this.uriComplete;
        data["unit"] = this.unit;
        data["toClassUri"] = this.toClassUri;
        data["identifier"] = this.identifier;
        data["minCardinality"] = this.minCardinality;
        data["maxCardinality"] = this.maxCardinality;
        data["minLength"] = this.minLength;
        data["maxLength"] = this.maxLength;
        data["order"] = this.order;
        return data;
    }
}

export interface ISchemaProperty {
    path: string | undefined;
    allowedValues?: string[] | undefined;
    conformsTo?: string | undefined;
    description?: MultiLanguageModel | undefined;
    label?: MultiLanguageModel | undefined;
    dataType?: string | undefined;
    pattern?: string | undefined;
    uriComplete?: string | undefined;
    unit?: string | undefined;
    toClassUri?: string | undefined;
    identifier?: string | undefined;
    minCardinality?: number | undefined;
    maxCardinality?: number | undefined;
    minLength?: number | undefined;
    maxLength?: number | undefined;
    order?: number | undefined;
}

export enum SearchResourceType {
    Dataset = "Dataset",
    DataService = "DataService",
    PublicService = "PublicService",
    Concept = "Concept",
    MappingTable = "MappingTable",
}

export class SearchResourceTypeSearchCountResultItem implements ISearchResourceTypeSearchCountResultItem {
    count?: number;
    value!: SearchResourceType;

    constructor(data?: ISearchResourceTypeSearchCountResultItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SearchResourceTypeSearchCountResultItem {
        data = typeof data === 'object' ? data : {};
        let result = new SearchResourceTypeSearchCountResultItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        data["value"] = this.value;
        return data;
    }
}

export interface ISearchResourceTypeSearchCountResultItem {
    count?: number;
    value: SearchResourceType;
}

export enum SearchStructureOption {
    WithStructure = "WithStructure",
    WithoutStructure = "WithoutStructure",
}

export enum SortOrder {
    Ascending = "Ascending",
    Descending = "Descending",
}

export class SystemInfoModel implements ISystemInfoModel {
    createdAt?: Date;
    creationType?: CreationType | undefined;
    modifiedAt?: Date | undefined;

    constructor(data?: ISystemInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.creationType = _data["creationType"];
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SystemInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new SystemInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["creationType"] = this.creationType;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface ISystemInfoModel {
    createdAt?: Date;
    creationType?: CreationType | undefined;
    modifiedAt?: Date | undefined;
}

export class UriInputModel implements IUriInputModel {
    uri!: string | undefined;

    constructor(data?: IUriInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uri = _data["uri"];
        }
    }

    static fromJS(data: any): UriInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new UriInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uri"] = this.uri;
        return data;
    }
}

export interface IUriInputModel {
    uri: string | undefined;
}

export class UserModel implements IUserModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    businessRole?: BusinessRole;
    agents?: IdentifierNameModel[] | undefined;

    constructor(data?: IUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.businessRole = _data["businessRole"];
            if (Array.isArray(_data["agents"])) {
                this.agents = [] as any;
                for (let item of _data["agents"])
                    this.agents!.push(IdentifierNameModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["businessRole"] = this.businessRole;
        if (Array.isArray(this.agents)) {
            data["agents"] = [];
            for (let item of this.agents)
                data["agents"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    businessRole?: BusinessRole;
    agents?: IdentifierNameModel[] | undefined;
}

export enum VCardKind {
    Organization = "Organization",
}

export class VCardModel implements IVCardModel {
    fn?: MultiLanguageModel | undefined;
    hasAddress?: MultiLanguageModel | undefined;
    hasEmail!: string | undefined;
    hasTelephone?: string | undefined;
    kind?: VCardKind;
    note?: MultiLanguageModel | undefined;

    constructor(data?: IVCardModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fn = _data["fn"] ? MultiLanguageModel.fromJS(_data["fn"]) : undefined as any;
            this.hasAddress = _data["hasAddress"] ? MultiLanguageModel.fromJS(_data["hasAddress"]) : undefined as any;
            this.hasEmail = _data["hasEmail"];
            this.hasTelephone = _data["hasTelephone"];
            this.kind = _data["kind"];
            this.note = _data["note"] ? MultiLanguageModel.fromJS(_data["note"]) : undefined as any;
        }
    }

    static fromJS(data: any): VCardModel {
        data = typeof data === 'object' ? data : {};
        let result = new VCardModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fn"] = this.fn ? this.fn.toJSON() : undefined as any;
        data["hasAddress"] = this.hasAddress ? this.hasAddress.toJSON() : undefined as any;
        data["hasEmail"] = this.hasEmail;
        data["hasTelephone"] = this.hasTelephone;
        data["kind"] = this.kind;
        data["note"] = this.note ? this.note.toJSON() : undefined as any;
        return data;
    }
}

export interface IVCardModel {
    fn?: MultiLanguageModel | undefined;
    hasAddress?: MultiLanguageModel | undefined;
    hasEmail: string | undefined;
    hasTelephone?: string | undefined;
    kind?: VCardKind;
    note?: MultiLanguageModel | undefined;
}

export class Vcard implements IVcard {
    adrWork?: MultiLanguage | undefined;
    emailInternet!: string | undefined;
    fn?: MultiLanguage | undefined;
    note?: MultiLanguage | undefined;
    org?: MultiLanguage | undefined;
    telWorkVoice?: string | undefined;

    constructor(data?: IVcard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adrWork = _data["adrWork"] ? MultiLanguage.fromJS(_data["adrWork"]) : undefined as any;
            this.emailInternet = _data["emailInternet"];
            this.fn = _data["fn"] ? MultiLanguage.fromJS(_data["fn"]) : undefined as any;
            this.note = _data["note"] ? MultiLanguage.fromJS(_data["note"]) : undefined as any;
            this.org = _data["org"] ? MultiLanguage.fromJS(_data["org"]) : undefined as any;
            this.telWorkVoice = _data["telWorkVoice"];
        }
    }

    static fromJS(data: any): Vcard {
        data = typeof data === 'object' ? data : {};
        let result = new Vcard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adrWork"] = this.adrWork ? this.adrWork.toJSON() : undefined as any;
        data["emailInternet"] = this.emailInternet;
        data["fn"] = this.fn ? this.fn.toJSON() : undefined as any;
        data["note"] = this.note ? this.note.toJSON() : undefined as any;
        data["org"] = this.org ? this.org.toJSON() : undefined as any;
        data["telWorkVoice"] = this.telWorkVoice;
        return data;
    }
}

export interface IVcard {
    adrWork?: MultiLanguage | undefined;
    emailInternet: string | undefined;
    fn?: MultiLanguage | undefined;
    note?: MultiLanguage | undefined;
    org?: MultiLanguage | undefined;
    telWorkVoice?: string | undefined;
}

export class VocabularyConfigModel implements IVocabularyConfigModel {
    id?: string;
    conceptIdentifier!: string | undefined;
    conceptVersion!: string | undefined;
    vocabularyIdentifier!: string | undefined;

    constructor(data?: IVocabularyConfigModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.conceptIdentifier = _data["conceptIdentifier"];
            this.conceptVersion = _data["conceptVersion"];
            this.vocabularyIdentifier = _data["vocabularyIdentifier"];
        }
    }

    static fromJS(data: any): VocabularyConfigModel {
        data = typeof data === 'object' ? data : {};
        let result = new VocabularyConfigModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["conceptIdentifier"] = this.conceptIdentifier;
        data["conceptVersion"] = this.conceptVersion;
        data["vocabularyIdentifier"] = this.vocabularyIdentifier;
        return data;
    }
}

export interface IVocabularyConfigModel {
    id?: string;
    conceptIdentifier: string | undefined;
    conceptVersion: string | undefined;
    vocabularyIdentifier: string | undefined;
}

export class VocabularyEntry implements IVocabularyEntry {
    code?: string | undefined;
    name?: MultiLanguage | undefined;
    uri?: string | undefined;

    constructor(data?: IVocabularyEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"] ? MultiLanguage.fromJS(_data["name"]) : undefined as any;
            this.uri = _data["uri"];
        }
    }

    static fromJS(data: any): VocabularyEntry {
        data = typeof data === 'object' ? data : {};
        let result = new VocabularyEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name ? this.name.toJSON() : undefined as any;
        data["uri"] = this.uri;
        return data;
    }
}

export interface IVocabularyEntry {
    code?: string | undefined;
    name?: MultiLanguage | undefined;
    uri?: string | undefined;
}

export class VocabularyEntryModel implements IVocabularyEntryModel {
    code!: string | undefined;
    name?: MultiLanguageModel | undefined;
    uri?: string | undefined;

    constructor(data?: IVocabularyEntryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"] ? MultiLanguageModel.fromJS(_data["name"]) : undefined as any;
            this.uri = _data["uri"];
        }
    }

    static fromJS(data: any): VocabularyEntryModel {
        data = typeof data === 'object' ? data : {};
        let result = new VocabularyEntryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name ? this.name.toJSON() : undefined as any;
        data["uri"] = this.uri;
        return data;
    }
}

export interface IVocabularyEntryModel {
    code: string | undefined;
    name?: MultiLanguageModel | undefined;
    uri?: string | undefined;
}

export class SwaggerResponse<TResult> {
    status: number;
    headers: { [key: string]: any; };
    result: TResult;

    constructor(status: number, headers: { [key: string]: any; }, result: TResult)
    {
        this.status = status;
        this.headers = headers;
        this.result = result;
    }
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}